/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  StringOrStringArray: { input: any; output: any; }
};

export type ActiveSupportItem = {
  __typename?: 'ActiveSupportItem';
  appealId: Scalars['ID']['output'];
  appealStatus?: Maybe<AppealCurrentStatus>;
  condition?: Maybe<Scalars['String']['output']>;
  helpScoutConversationId: Scalars['String']['output'];
  helpScoutCreatedAt: Scalars['String']['output'];
  helpScoutStatus: Scalars['String']['output'];
  helpScoutSubject?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
};

export type AddAppealLetterTraceToEvalDatasetInput = {
  evalName: Scalars['String']['input'];
  expectedOutput: ExpectedOutputInput;
  letterGenerationId: Scalars['ID']['input'];
};

export type AddClinicalEvidenceEntryInput = {
  abstract: Scalars['String']['input'];
  citation: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddLetterTestScenarioInput = {
  condition: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  letterTestId: Scalars['ID']['input'];
  medication: Scalars['String']['input'];
  persona?: InputMaybe<Scalars['String']['input']>;
  subDenialReasons?: InputMaybe<Array<SubDenialReasonEnum>>;
};

/**
 * At some point I think we will want to roll this together with the ConfirmDetailsInput.
 *
 * This may depend on how the rework of the madlib page pans out.
 */
export type AdditionalInsuranceInformationInput = {
  claimId?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  memberNumber: Scalars['String']['input'];
  planCategory: PlanCategory;
  rxGroupNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AddressSuggestion = {
  __typename?: 'AddressSuggestion';
  city: Scalars['String']['output'];
  primaryLine: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AdverseEvent = {
  __typename?: 'AdverseEvent';
  adverseEvent: Scalars['String']['output'];
  adverseEventId: Scalars['ID']['output'];
  appealId: Scalars['ID']['output'];
  channel: AdverseEventChannel;
  condition: Scalars['String']['output'];
  createdTimestamp: Scalars['Date']['output'];
  medication: Scalars['String']['output'];
  reportingUserId?: Maybe<Scalars['ID']['output']>;
  sanofiId?: Maybe<Scalars['String']['output']>;
  updatedTimestamp: Scalars['Date']['output'];
};

export type AdverseEventAppealResult = {
  __typename?: 'AdverseEventAppealResult';
  appealId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
};

export enum AdverseEventChannel {
  Email = 'Email',
  PhoneCall = 'Phone_Call',
  Product = 'Product',
  Sms = 'SMS'
}

export type AdverseEventSearchTermsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hasBeenReported?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AdverseEventsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<AdverseEventSearchTermsInput>;
};

export type Appeal = {
  __typename?: 'Appeal';
  appealId: Scalars['ID']['output'];
  appealLetter?: Maybe<AppealLetter>;
  appealType?: Maybe<AppealType>;
  caregiver?: Maybe<Caregiver>;
  ccDestinations: Array<CcDestination>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdTimestamp: Scalars['Date']['output'];
  denial?: Maybe<Denial>;
  destination?: Maybe<AppealDestination>;
  formattedSurveyAnswers?: Maybe<Scalars['String']['output']>;
  isCoverageFund: Scalars['Boolean']['output'];
  isExpeditedReview?: Maybe<Scalars['Boolean']['output']>;
  letterGeneration?: Maybe<LetterGeneration>;
  originalAppealId?: Maybe<Scalars['ID']['output']>;
  patient?: Maybe<Patient>;
  patientInsurance?: Maybe<PatientInsurance>;
  referral?: Maybe<ProviderReferral>;
  secondAppealId?: Maybe<Scalars['ID']['output']>;
  sentFaxes: Array<SentFax>;
  sentLetters: Array<SentLetter>;
  status: AppealStatus;
  supportingDocuments?: Maybe<Array<AppealSupportingDocument>>;
  surveyAnswers: Array<SurveyAnswer>;
  surveyId?: Maybe<Scalars['ID']['output']>;
  surveyJsAnswers: Scalars['String']['output'];
  updatedTimestamp: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};


export type AppealSupportingDocumentsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AppealCurrentStatus {
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  InSupport = 'IN_SUPPORT',
  LetterGenerated = 'LETTER_GENERATED',
  LetterGenerating = 'LETTER_GENERATING',
  Overturned = 'OVERTURNED',
  ReferralInProgress = 'REFERRAL_IN_PROGRESS',
  Referred = 'REFERRED',
  Submitted = 'SUBMITTED',
  Upheld = 'UPHELD'
}

export type AppealDeliverabilityMetrics = {
  __typename?: 'AppealDeliverabilityMetrics';
  dateRange: DeliverabilityDateRange;
  kpis: DeliverabilityKpis;
  payerHealth: Array<DeliverabilityPayerRow>;
  stuckLetters: Array<DeliverabilityStuckLetterRow>;
  worstCcDestinations: Array<DeliverabilityCcDestinationRow>;
  worstFaxNumbers: Array<DeliverabilityFaxNumberRow>;
};

export type AppealDenialDetailsSectionStatus = {
  __typename?: 'AppealDenialDetailsSectionStatus';
  status: AppealSectionStatus;
};

export type AppealDepartmentAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AppealDepartmentRecord = {
  __typename?: 'AppealDepartmentRecord';
  address: Address;
  addressCompany?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  denyingPartyName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expeditedFaxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<PlanCategory>;
  secondaryStandardFaxNumber?: Maybe<Scalars['String']['output']>;
  standardFaxNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type AppealDepartmentSearchTermsInput = {
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyName?: InputMaybe<Scalars['String']['input']>;
  planCategory?: InputMaybe<PlanCategory>;
};

export type AppealDepartmentsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<AppealDepartmentSearchTermsInput>;
};

export type AppealDestination = {
  __typename?: 'AppealDestination';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['ID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recipientType: RecipientType;
};

export type AppealDestinationInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientType: RecipientType;
};

export type AppealDetailSection = {
  __typename?: 'AppealDetailSection';
  appealId: Scalars['ID']['output'];
  condition?: Maybe<Scalars['String']['output']>;
  createdTimestamp: Scalars['Date']['output'];
  denialReason?: Maybe<Scalars['String']['output']>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
};

export type AppealFinalizeAndSubmitSectionStatus = {
  __typename?: 'AppealFinalizeAndSubmitSectionStatus';
  status: AppealSectionStatus;
};

export type AppealGenerateAndReviewSectionStatus = {
  __typename?: 'AppealGenerateAndReviewSectionStatus';
  status: AppealSectionStatus;
};

export type AppealInsuranceCoverageSectionStatus = {
  __typename?: 'AppealInsuranceCoverageSectionStatus';
  status: AppealSectionStatus;
};

export type AppealLetter = {
  __typename?: 'AppealLetter';
  body: Scalars['String']['output'];
  references: Scalars['String']['output'];
};

export type AppealLetterInput = {
  body: Scalars['String']['input'];
  references: Scalars['String']['input'];
};

export type AppealLetterIssueInput = {
  categories: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export type AppealOutcomeEvent = {
  __typename?: 'AppealOutcomeEvent';
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorUserType?: Maybe<Scalars['String']['output']>;
  eventTimestamp: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum AppealOutcomeSource {
  ClaimableConsole = 'CLAIMABLE_CONSOLE',
  Email = 'EMAIL',
  MyAppeals = 'MY_APPEALS',
  Sms = 'SMS',
  Support = 'SUPPORT'
}

export enum AppealOutcomeStatus {
  Overturned = 'OVERTURNED',
  Upheld = 'UPHELD'
}

export type AppealOverview = {
  __typename?: 'AppealOverview';
  appealId: Scalars['ID']['output'];
  appealStatus: AppealStatus;
  condition?: Maybe<Scalars['String']['output']>;
  denialDetailsSection: AppealDenialDetailsSectionStatus;
  finalizeAndSubmitSection: AppealFinalizeAndSubmitSectionStatus;
  generateAndReviewSection: AppealGenerateAndReviewSectionStatus;
  insuranceCoverageSection: AppealInsuranceCoverageSectionStatus;
  medicationName?: Maybe<Scalars['String']['output']>;
  patientProfileSection: AppealPatientProfileSectionStatus;
  referral?: Maybe<ProviderReferral>;
  supportingDocumentsSection: AppealSupportingDocumentsSectionStatus;
  surveySection?: Maybe<AppealSurveySectionStatus>;
};

export type AppealPatientProfileSectionStatus = {
  __typename?: 'AppealPatientProfileSectionStatus';
  status: AppealSectionStatus;
};

export type AppealPurchaseSummary = {
  __typename?: 'AppealPurchaseSummary';
  ccDestinations: Array<CcDestination>;
  destination?: Maybe<AppealDestination>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<Scalars['String']['output']>;
  referralId?: Maybe<Scalars['ID']['output']>;
  referringProviderType?: Maybe<Scalars['String']['output']>;
};

export enum AppealSectionStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  Optional = 'OPTIONAL'
}

export type AppealStatus = {
  __typename?: 'AppealStatus';
  appealLetterGenerated?: Maybe<Scalars['Boolean']['output']>;
  appealSubmitted?: Maybe<Scalars['Boolean']['output']>;
  appealSubmittedTimestamp?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  currentStatus?: Maybe<AppealCurrentStatus>;
  denialLetterExtracted?: Maybe<Scalars['Boolean']['output']>;
  denialLetterExtractionFailed?: Maybe<Scalars['Boolean']['output']>;
  denialLetterUpload?: Maybe<Scalars['Boolean']['output']>;
  denialLetterUploadSkipped?: Maybe<Scalars['Boolean']['output']>;
  denialOverturned?: Maybe<Scalars['Boolean']['output']>;
  denialOverturnedTimestamp?: Maybe<Scalars['String']['output']>;
  denialUpheld?: Maybe<Scalars['Boolean']['output']>;
  denialUpheldTimestamp?: Maybe<Scalars['String']['output']>;
  informationConfirmed?: Maybe<Scalars['Boolean']['output']>;
  initiated?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardExtracted?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardExtractionFailed?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardUpload?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardUploadSkipped?: Maybe<Scalars['Boolean']['output']>;
  issueOutstanding?: Maybe<Scalars['Boolean']['output']>;
  letterGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  letterOfMedicalNecessityUploaded?: Maybe<Scalars['Boolean']['output']>;
  outcomeDeterminedAt?: Maybe<Scalars['String']['output']>;
  patientSavedExperience?: Maybe<Scalars['Boolean']['output']>;
  paymentFailed?: Maybe<Scalars['Boolean']['output']>;
  paymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
  pdfGenerated?: Maybe<Scalars['Boolean']['output']>;
  pdfGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  referred?: Maybe<Scalars['Boolean']['output']>;
  secondAppealRequested?: Maybe<Scalars['Boolean']['output']>;
  secondAppealRequestedTimestamp?: Maybe<Scalars['String']['output']>;
  updatedTimestamp?: Maybe<Scalars['Date']['output']>;
};

export type AppealStrategiesQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<AppealStrategySearchTermsInput>;
};

export type AppealStrategy = {
  __typename?: 'AppealStrategy';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  status: AppealStrategyStatus;
  strategy: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type AppealStrategyAuditEntry = {
  __typename?: 'AppealStrategyAuditEntry';
  createdAt: Scalars['Date']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  performedByEmail?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  previousStrategy?: Maybe<Scalars['String']['output']>;
  previousTags?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type AppealStrategySearchTermsInput = {
  status?: InputMaybe<AppealStrategyStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export enum AppealStrategyStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type AppealSupportingDocument = {
  __typename?: 'AppealSupportingDocument';
  documentId: Scalars['ID']['output'];
  documentType: AppealSupportingDocumentType;
  files: Array<AppealSupportingDocumentFile>;
  isIncludedInAppeal: Scalars['Boolean']['output'];
  otherDocumentTypeName?: Maybe<Scalars['String']['output']>;
  uploadedBy: AppealSupportingDocumentUploadedBy;
};

export type AppealSupportingDocumentFile = {
  __typename?: 'AppealSupportingDocumentFile';
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileType: AppealSupportingDocumentFileType;
  pageCount: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum AppealSupportingDocumentFileType {
  Image = 'IMAGE',
  Pdf = 'PDF'
}

export enum AppealSupportingDocumentType {
  ApprovalLetter = 'APPROVAL_LETTER',
  CoverLetter = 'COVER_LETTER',
  DenialLetter = 'DENIAL_LETTER',
  DenialUpheldLetter = 'DENIAL_UPHELD_LETTER',
  InsuranceCard = 'INSURANCE_CARD',
  InsuranceForm = 'INSURANCE_FORM',
  LabResults = 'LAB_RESULTS',
  LetterOfMedicalNecessity = 'LETTER_OF_MEDICAL_NECESSITY',
  MedicalRecords = 'MEDICAL_RECORDS',
  NoticeOfBenefitChange = 'NOTICE_OF_BENEFIT_CHANGE',
  Other = 'OTHER',
  PatientConsent = 'PATIENT_CONSENT'
}

export enum AppealSupportingDocumentUploadedBy {
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  Support = 'SUPPORT'
}

export type AppealSupportingDocumentsSectionStatus = {
  __typename?: 'AppealSupportingDocumentsSectionStatus';
  status: AppealSectionStatus;
};

export type AppealSurveySectionStatus = {
  __typename?: 'AppealSurveySectionStatus';
  status: AppealSectionStatus;
};

export enum AppealType {
  Dependent = 'DEPENDENT',
  Self = 'SELF'
}

export type AppealsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<AppealsSearchTermsInput>;
};

export type AppealsSearchTermsInput = {
  appealLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  appealStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  appealSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAfter?: InputMaybe<Scalars['Date']['input']>;
  createdBefore?: InputMaybe<Scalars['Date']['input']>;
  isCoverageFund?: InputMaybe<Scalars['Boolean']['input']>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  patientEmail?: InputMaybe<Scalars['String']['input']>;
  patientExternalId?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerUserEmail?: InputMaybe<Scalars['String']['input']>;
  secondAppealRequested?: InputMaybe<Scalars['Boolean']['input']>;
  shouldFilterOutAppealsWithoutOpenSupportRequests?: InputMaybe<Scalars['Boolean']['input']>;
  shouldFilterOutInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ApprovalStatus {
  All = 'ALL',
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED'
}

export type Caregiver = {
  __typename?: 'Caregiver';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  relationship: CaregiverRelationship;
};

export type CaregiverInfoInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  relationship: CaregiverRelationship;
};

export type CaregiverInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  relationship: CaregiverRelationship;
};

export enum CaregiverRelationship {
  AuthorizedRepresentative = 'AUTHORIZED_REPRESENTATIVE',
  Father = 'FATHER',
  Mother = 'MOTHER',
  OtherLegalGuardian = 'OTHER_LEGAL_GUARDIAN'
}

export type CcDestination = {
  __typename?: 'CcDestination';
  destination: AppealDestination;
  sendMethod: SendMethod;
};

export type CcDestinationAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CcDestinationInput = {
  destination: AppealDestinationInput;
  sendMethod: SendMethod;
};

export type CcDestinationRecord = {
  __typename?: 'CcDestinationRecord';
  address: Address;
  addressCompany?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  denyingPartyParent?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recipientType: RecipientType;
  stateCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CcDestinationSearchTermsInput = {
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyParent?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<RecipientType>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type CcDestinationsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<CcDestinationSearchTermsInput>;
};

export type ChatGptDocumentInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  pageCount: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type ChatGptMessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type ChatGptResponse = {
  __typename?: 'ChatGptResponse';
  message: Scalars['String']['output'];
  usage: ChatGptUsage;
};

export type ChatGptTextContextInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ChatGptUsage = {
  __typename?: 'ChatGptUsage';
  completionTokens: Scalars['Int']['output'];
  promptTokens: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type ClinicalEvidence = {
  __typename?: 'ClinicalEvidence';
  abstract: Scalars['String']['output'];
  citation: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medication: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type ClinicalEvidenceQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<EvidenceSearchTermsInput>;
  sort?: InputMaybe<EvidenceSortOptions>;
};

export type Condition = {
  __typename?: 'Condition';
  abbreviation?: Maybe<Scalars['String']['output']>;
  aliases: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isReferrable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ConditionSearchInput = {
  isReferrable?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type ConditionsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<ConditionSearchInput>;
};

export type ConfirmDetailsInput = {
  employer?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider: Scalars['String']['input'];
  memberNumber: Scalars['String']['input'];
  pbmName?: InputMaybe<Scalars['String']['input']>;
  planCategory: PlanCategory;
  rxBinNumber?: InputMaybe<Scalars['String']['input']>;
  rxGroupNumber?: InputMaybe<Scalars['String']['input']>;
  rxMemberId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppealDepartmentInput = {
  address: AppealDepartmentAddressInput;
  addressCompany?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  expeditedFaxNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planCategory?: InputMaybe<PlanCategory>;
  secondaryStandardFaxNumber?: InputMaybe<Scalars['String']['input']>;
  standardFaxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppealStagingInput = {
  condition: Scalars['String']['input'];
  eligibilityScenario?: InputMaybe<EligibilityScenario>;
  medication: Scalars['String']['input'];
};

export type CreateAppealStagingResult = {
  __typename?: 'CreateAppealStagingResult';
  appealId: Scalars['ID']['output'];
};

export type CreateAppealStrategyInput = {
  status?: InputMaybe<AppealStrategyStatus>;
  strategy: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CreateCcDestinationInput = {
  address: CcDestinationAddressInput;
  addressCompany?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyParent?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recipientType: RecipientType;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConditionInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName: Scalars['String']['input'];
  isReferrable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDenialReasonInput = {
  displayName: Scalars['String']['input'];
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEmailMessageInput = {
  body: Scalars['String']['input'];
  eventType: EmailMessageEventType;
  providerId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLetterTestInput = {
  name: Scalars['String']['input'];
  scenarios: Array<CreateLetterTestScenarioInput>;
};

export type CreateLetterTestScenarioInput = {
  condition: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  persona?: InputMaybe<Scalars['String']['input']>;
  subDenialReasons?: InputMaybe<Array<SubDenialReasonEnum>>;
};

export type CreateMedicationConditionInput = {
  conditionId: Scalars['ID']['input'];
  medicationId: Scalars['ID']['input'];
};

export type CreateMedicationInput = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePayerPolicyClinicalCriteriaInput = {
  condition: Scalars['String']['input'];
  continuationClinicalCriteria: Scalars['String']['input'];
  initialClinicalCriteria: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  payer: Scalars['String']['input'];
};

export type CreateProviderViaSelfSignUpInput = {
  identificationNumber: Scalars['String']['input'];
  organizationType: OrganizationType;
  providerName: Scalars['String']['input'];
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubDenialReasonInput = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateSurveySchemaInput = {
  condition: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  schemaData: Scalars['String']['input'];
};

export type DeliverabilityCcDestinationRow = {
  __typename?: 'DeliverabilityCcDestinationRow';
  destinationName: Scalars['String']['output'];
  failureCount: Scalars['Int']['output'];
  sendMethod: SendMethod;
  successCount: Scalars['Int']['output'];
  successRate?: Maybe<Scalars['Float']['output']>;
  totalSends: Scalars['Int']['output'];
};

export enum DeliverabilityDateRange {
  AllTime = 'ALL_TIME',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export type DeliverabilityFaxNumberRow = {
  __typename?: 'DeliverabilityFaxNumberRow';
  failureCount: Scalars['Int']['output'];
  inFlightCount: Scalars['Int']['output'];
  recipientCompany?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
  successRate?: Maybe<Scalars['Float']['output']>;
  toFaxNumber: Scalars['String']['output'];
  totalSends: Scalars['Int']['output'];
};

export type DeliverabilityKpis = {
  __typename?: 'DeliverabilityKpis';
  faxAttempts: Scalars['Int']['output'];
  faxFailedWithFallback: Scalars['Int']['output'];
  faxFailures: Scalars['Int']['output'];
  faxFallbackRate?: Maybe<Scalars['Float']['output']>;
  faxInFlight: Scalars['Int']['output'];
  faxSuccessRate?: Maybe<Scalars['Float']['output']>;
  faxSuccesses: Scalars['Int']['output'];
  letterAttempts: Scalars['Int']['output'];
  letterDelivered: Scalars['Int']['output'];
  letterDeliveredRate?: Maybe<Scalars['Float']['output']>;
  letterReroutedOrInternational: Scalars['Int']['output'];
  letterReturnedToSender: Scalars['Int']['output'];
  letterReturnedToSenderRate?: Maybe<Scalars['Float']['output']>;
  letterTerminal: Scalars['Int']['output'];
  totalAppealsSent: Scalars['Int']['output'];
};

export type DeliverabilityPayerRow = {
  __typename?: 'DeliverabilityPayerRow';
  destinationCompany: Scalars['String']['output'];
  faxAttempts: Scalars['Int']['output'];
  faxSuccessRate?: Maybe<Scalars['Float']['output']>;
  letterAttempts: Scalars['Int']['output'];
  letterDeliveredRate?: Maybe<Scalars['Float']['output']>;
  totalAppeals: Scalars['Int']['output'];
};

export type DeliverabilityStuckLetterRow = {
  __typename?: 'DeliverabilityStuckLetterRow';
  appealId: Scalars['ID']['output'];
  daysSinceInitiated: Scalars['Int']['output'];
  expectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  initiatedTimestamp: Scalars['Date']['output'];
  letterId: Scalars['ID']['output'];
  lobExpectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  lobStatus: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

export type Denial = {
  __typename?: 'Denial';
  bmiComorbidCriteria?: Maybe<Scalars['Float']['output']>;
  bmiObesityCriteria?: Maybe<Scalars['Float']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  daysToAppeal?: Maybe<Scalars['Int']['output']>;
  denialDate?: Maybe<Scalars['Date']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  denyingParty?: Maybe<DenyingParty>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
  medicationGenericName?: Maybe<Scalars['String']['output']>;
  otherAppealSituations?: Maybe<Array<OtherAppealSituations>>;
  otherDenyingPartyName?: Maybe<Scalars['String']['output']>;
  subDenialReasons: Array<SubDenialReasonEnum>;
};

export type DenialLetter = {
  __typename?: 'DenialLetter';
  confirmed?: Maybe<DenialLetterInfo>;
  extracted?: Maybe<DenialLetterInfo>;
  s3Urls: Array<Maybe<UploadUrls>>;
};

export type DenialLetterInfo = {
  __typename?: 'DenialLetterInfo';
  daysToAppeal?: Maybe<Scalars['Int']['output']>;
  denialDate?: Maybe<Scalars['Date']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  disease?: Maybe<Scalars['String']['output']>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
  medicationGenericName?: Maybe<Scalars['String']['output']>;
};

export type DenialReasonRecord = {
  __typename?: 'DenialReasonRecord';
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUniversal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type DenialReasonSearchInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type DenialReasonsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<DenialReasonSearchInput>;
};

export enum DenyingParty {
  InsuranceCompany = 'INSURANCE_COMPANY',
  Other = 'OTHER',
  Pbm = 'PBM'
}

export type DenyingPartyAppealDepartment = {
  __typename?: 'DenyingPartyAppealDepartment';
  address: Address;
  company?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DenyingPartyInput = {
  denyingParty: DenyingParty;
  otherDenyingPartyName?: InputMaybe<Scalars['String']['input']>;
};

export enum EligibilityScenario {
  CoverageFund = 'COVERAGE_FUND',
  PansPandasFormulary = 'PANS_PANDAS_FORMULARY'
}

export type EmailMessage = {
  __typename?: 'EmailMessage';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  eventType: EmailMessageEventType;
  id: Scalars['ID']['output'];
  providerId: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum EmailMessageEventType {
  PatientAppealOutcomeOverturned = 'PATIENT_APPEAL_OUTCOME_OVERTURNED',
  PatientAppealOutcomeUpheld = 'PATIENT_APPEAL_OUTCOME_UPHELD',
  PatientAppealSubmitted = 'PATIENT_APPEAL_SUBMITTED',
  PostAppealCheckIn = 'POST_APPEAL_CHECK_IN',
  ProviderReferralSubmitted = 'PROVIDER_REFERRAL_SUBMITTED'
}

export type Employer = {
  __typename?: 'Employer';
  address?: Maybe<Address>;
  employerName?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
};

export type EmployerInput = {
  address: AddressInput;
  employerName: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  recipientName: Scalars['String']['input'];
};

export type EvaluatorInfo = {
  __typename?: 'EvaluatorInfo';
  datasetName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  evalName: Scalars['String']['output'];
  scoreName: Scalars['String']['output'];
};

export type EvidenceSearchTermsInput = {
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  evidenceType?: InputMaybe<Array<Scalars['String']['input']>>;
  journalImpactFactor?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  minNumberOfCitations?: InputMaybe<Scalars['Int']['input']>;
  publicationYearMax?: InputMaybe<Scalars['Int']['input']>;
  publicationYearMin?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Array<Scalars['String']['input']>>;
  trialPhase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EvidenceSortOptions = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type ExpectedOutputInput = {
  description: Scalars['String']['input'];
  result: Scalars['String']['input'];
};

/** The server-side recommendation for whether an appeal should use expedited review. */
export enum ExpeditedReviewRecommendation {
  AskPatient = 'ASK_PATIENT',
  Expedited = 'EXPEDITED',
  Standard = 'STANDARD'
}

export enum ExtractionResult {
  Failed = 'FAILED',
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export enum FaxSentStatus {
  Initiated = 'INITIATED',
  InitiationFailed = 'INITIATION_FAILED',
  SendFailed = 'SEND_FAILED',
  SendSucceeded = 'SEND_SUCCEEDED'
}

export type GatherClinicalEvidenceInput = {
  brandName: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  genericName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GatherClinicalEvidenceResult = {
  __typename?: 'GatherClinicalEvidenceResult';
  papersInserted: Scalars['Int']['output'];
};

export type GenerateAppealStrategyInput = {
  conditionName: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  medicationName: Scalars['String']['input'];
  planCategory?: InputMaybe<Scalars['String']['input']>;
  subDenialReasons?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GenerateLetterTestPersonasInput = {
  additionalContext: Scalars['String']['input'];
  coverageType: PersonaCoverageType;
  letterTestId: Scalars['ID']['input'];
  patientType: PersonaPatientType;
};

export type GenerateLetterTestPersonasResult = {
  __typename?: 'GenerateLetterTestPersonasResult';
  scenarioCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type GenerateLettersForLetterTestInput = {
  letterTestId: Scalars['ID']['input'];
  models: Array<Scalars['String']['input']>;
  overrides?: InputMaybe<GenerationOverridesInput>;
};

export type GenerateLettersForLetterTestResult = {
  __typename?: 'GenerateLettersForLetterTestResult';
  executionCount: Scalars['Int']['output'];
};

export type GenerateSupportingDocumentFileInput = {
  fileName: Scalars['String']['input'];
  fileType: AppealSupportingDocumentFileType;
  pageCount: Scalars['Int']['input'];
};

export type GenerateSupportingDocumentUploadInput = {
  documentType: AppealSupportingDocumentType;
  files: Array<GenerateSupportingDocumentFileInput>;
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  otherDocumentTypeName?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateSupportingDocumentUploadUrlsResponse = {
  __typename?: 'GenerateSupportingDocumentUploadUrlsResponse';
  documentId: Scalars['ID']['output'];
  fileUploadDetails: Array<SupportingDocumentFileUploadDetail>;
};

export type GeneratedAppealStrategy = {
  __typename?: 'GeneratedAppealStrategy';
  reasoning: Scalars['String']['output'];
  strategy: Scalars['String']['output'];
  suggestedTags: Array<Scalars['String']['output']>;
};

export type GenerationOverridesInput = {
  singleStep?: InputMaybe<Scalars['Boolean']['input']>;
  skipPatientSummary?: InputMaybe<Scalars['Boolean']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

export type HelpScoutConversation = {
  __typename?: 'HelpScoutConversation';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  threads: Array<HelpScoutThread>;
};

export type HelpScoutThread = {
  __typename?: 'HelpScoutThread';
  author: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type HistoryQuestion = {
  __typename?: 'HistoryQuestion';
  answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  question: Scalars['String']['output'];
};

export type InReviewClinicalEvidence = {
  __typename?: 'InReviewClinicalEvidence';
  abstract: Scalars['String']['output'];
  ageGroup?: Maybe<Scalars['String']['output']>;
  citation: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  conditionIndication?: Maybe<Scalars['String']['output']>;
  dosageRegimen?: Maybe<Scalars['String']['output']>;
  drugMedicine?: Maybe<Scalars['String']['output']>;
  evidenceType?: Maybe<Scalars['String']['output']>;
  fundingDetails?: Maybe<Scalars['String']['output']>;
  fundingSource?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journalImpactFactor?: Maybe<Scalars['String']['output']>;
  journalName?: Maybe<Scalars['String']['output']>;
  labelAbstract?: Maybe<Scalars['String']['output']>;
  medication: Scalars['String']['output'];
  numberOfCitations: Scalars['Int']['output'];
  populationRegion?: Maybe<Scalars['String']['output']>;
  publicationYear?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  resultDescription?: Maybe<Scalars['String']['output']>;
  sampleSize?: Maybe<Scalars['Int']['output']>;
  sexStudied?: Maybe<Scalars['String']['output']>;
  specialPopulations?: Maybe<Array<Scalars['String']['output']>>;
  studyDesign?: Maybe<Scalars['String']['output']>;
  tldr?: Maybe<Scalars['String']['output']>;
  trialPhase?: Maybe<Scalars['String']['output']>;
};

export type InitialReferralData = {
  __typename?: 'InitialReferralData';
  appealId: Scalars['ID']['output'];
  condition: Scalars['String']['output'];
  denialReason: Scalars['String']['output'];
  medication: Scalars['String']['output'];
};

export type InitializeReferralInput = {
  condition: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  isExpeditedReview?: InputMaybe<Scalars['Boolean']['input']>;
  medication: Scalars['String']['input'];
  otherAppealSituations?: InputMaybe<Array<OtherAppealSituations>>;
  subDenialReasons?: InputMaybe<Array<SubDenialReasonEnum>>;
};

export type InsuranceCardExtraction = {
  __typename?: 'InsuranceCardExtraction';
  appealId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  extractedData: InsuranceCardExtractionResult;
  extractionResult: ExtractionResult;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type InsuranceCardExtractionResult = {
  __typename?: 'InsuranceCardExtractionResult';
  employer?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceProvider?: Maybe<Scalars['String']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<Scalars['String']['output']>;
  rxBin?: Maybe<Scalars['String']['output']>;
  rxGroup?: Maybe<Scalars['String']['output']>;
  rxMemberId?: Maybe<Scalars['String']['output']>;
};

export type InsuranceInfo = {
  __typename?: 'InsuranceInfo';
  confirmed?: Maybe<InsuranceInfoDetails>;
};

export type InsuranceInfoDetails = {
  __typename?: 'InsuranceInfoDetails';
  birthDate?: Maybe<Scalars['Date']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  denyingParty?: Maybe<DenyingParty>;
  employer?: Maybe<Scalars['String']['output']>;
  enrolleeFirstName?: Maybe<Scalars['String']['output']>;
  enrolleeLastName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceProvider?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  isPatientEnrollee?: Maybe<Scalars['Boolean']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
  otherAppealSituations?: Maybe<Array<OtherAppealSituations>>;
  otherDenyingPartyName?: Maybe<Scalars['String']['output']>;
  pbmName?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<PlanCategory>;
  rxBinNumber?: Maybe<Scalars['String']['output']>;
  rxGroupNumber?: Maybe<Scalars['String']['output']>;
  rxMemberId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type LetterGeneration = {
  __typename?: 'LetterGeneration';
  appealId?: Maybe<Scalars['ID']['output']>;
  appealLetterGenerationId?: Maybe<Scalars['ID']['output']>;
  createdTimestamp?: Maybe<Scalars['Date']['output']>;
  generationOutput?: Maybe<Scalars['String']['output']>;
  letterBody?: Maybe<Scalars['String']['output']>;
  letterReferences?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  reviewGrade?: Maybe<ReviewGrade>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedBySupportUserEmail?: Maybe<Scalars['String']['output']>;
  trace?: Maybe<Scalars['String']['output']>;
  updatedTimestamp?: Maybe<Scalars['Date']['output']>;
};

export type LetterOfNecessityInfo = {
  __typename?: 'LetterOfNecessityInfo';
  s3Urls: Array<Maybe<UploadUrls>>;
};

export type LetterRevisionFull = {
  __typename?: 'LetterRevisionFull';
  appealLetterRevisionId: Scalars['ID']['output'];
  comment: Scalars['String']['output'];
  createdTimestamp: Scalars['Date']['output'];
  letterBody: Scalars['String']['output'];
  letterReferences: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  supportUserEmail: Scalars['String']['output'];
  supportUserId: Scalars['ID']['output'];
  updatedTimestamp: Scalars['Date']['output'];
};

export type LetterRevisionHistory = {
  __typename?: 'LetterRevisionHistory';
  comment?: Maybe<Scalars['String']['output']>;
  createdTimestamp?: Maybe<Scalars['Date']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  supportUserEmail: Scalars['String']['output'];
  supportUserId?: Maybe<Scalars['ID']['output']>;
};

export type LetterRevisionInput = {
  appealLetter: AppealLetterInput;
  comment: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type LetterTest = {
  __typename?: 'LetterTest';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scenarios: Array<LetterTestScenario>;
  status: LetterTestStatus;
  updatedAt: Scalars['String']['output'];
};

export type LetterTestScenario = {
  __typename?: 'LetterTestScenario';
  condition: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  denialReason: Scalars['String']['output'];
  executions: Array<LetterTestScenarioExecution>;
  id: Scalars['ID']['output'];
  letterTestId: Scalars['ID']['output'];
  medication: Scalars['String']['output'];
  persona: Scalars['String']['output'];
  subDenialReasons: Array<SubDenialReasonEnum>;
  updatedAt: Scalars['String']['output'];
};

export type LetterTestScenarioExecution = {
  __typename?: 'LetterTestScenarioExecution';
  appealId?: Maybe<Scalars['ID']['output']>;
  configuration: LetterTestScenarioExecutionConfiguration;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  letterGeneration?: Maybe<LetterGeneration>;
  letterGenerationId?: Maybe<Scalars['ID']['output']>;
  letterTestScenarioId: Scalars['ID']['output'];
  status: LetterTestScenarioExecutionStatus;
  updatedAt: Scalars['String']['output'];
};

export type LetterTestScenarioExecutionConfiguration = {
  __typename?: 'LetterTestScenarioExecutionConfiguration';
  model?: Maybe<Scalars['String']['output']>;
  singleStep?: Maybe<Scalars['Boolean']['output']>;
  skipPatientSummary?: Maybe<Scalars['Boolean']['output']>;
  strategyId?: Maybe<Scalars['ID']['output']>;
};

export enum LetterTestScenarioExecutionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export enum LetterTestStatus {
  GeneratingLetters = 'GENERATING_LETTERS',
  GeneratingPersonas = 'GENERATING_PERSONAS',
  LettersGenerated = 'LETTERS_GENERATED',
  LetterGenerationFailed = 'LETTER_GENERATION_FAILED',
  Setup = 'SETUP'
}

export type LetterTestsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkAppealStagingToUserResult = {
  __typename?: 'LinkAppealStagingToUserResult';
  appealId: Scalars['ID']['output'];
};

export type ManualAppealSendInput = {
  appealId: Scalars['ID']['input'];
  customDestination?: InputMaybe<AppealDestinationInput>;
  method: SendMethod;
  regeneratePdf?: InputMaybe<Scalars['Boolean']['input']>;
  usePayerDestination: Scalars['Boolean']['input'];
};

export type ManualAppealSendResponse = {
  __typename?: 'ManualAppealSendResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  questions: Array<HistoryQuestion>;
};

export type Medication = {
  __typename?: 'Medication';
  aliases: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MedicationCondition = {
  __typename?: 'MedicationCondition';
  conditionDisplayName: Scalars['String']['output'];
  conditionId: Scalars['ID']['output'];
  conditionName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  medicationDisplayName: Scalars['String']['output'];
  medicationId: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
};

export type MedicationConditionPair = {
  __typename?: 'MedicationConditionPair';
  condition: Scalars['String']['output'];
  conditionAliases: Array<Scalars['String']['output']>;
  medication: Scalars['String']['output'];
  medicationAliases: Array<Scalars['String']['output']>;
};

export type MedicationConditionSearchTermsInput = {
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  medicationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicationConditionsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<MedicationConditionSearchTermsInput>;
};

export type MedicationSearchTermsInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<MedicationSearchTermsInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Updates a provider user's role (Support only) */
  UpdateProviderUserRole?: Maybe<ProviderUser>;
  /** Adds an appeal letter generation trace to an eval dataset in Langfuse. The eval name (e.g., strategy-adherence) must match a known evaluator. The dataset name is derived from the evaluator. Creates the dataset if it does not exist. Support users only. */
  addAppealLetterTraceToEvalDataset: Scalars['Boolean']['output'];
  /**
   * Adds a new clinical evidence record directly to the gold standard table.
   * Support users only. Evidence will be immediately available for letter generation.
   */
  addClinicalEvidenceEntry: ClinicalEvidence;
  /** Creates a provider user within the same provider that the user calling is in. */
  addNewUserToProvider?: Maybe<ProviderUser>;
  /** Creates a provider user in the provided provider. */
  addNewUserToProviderByProviderId?: Maybe<ProviderUser>;
  /** Approves a payer policy extraction */
  approvePayerPolicyExtraction: PayerPolicyExtraction;
  /**
   * Archive in-review clinical evidence.
   * Evidence will no longer appear in queries but remains in database.
   * Support users only.
   */
  archiveInReviewEvidence: Scalars['Int']['output'];
  /** Create an exact clone of an existing appeal with all data preserved */
  cloneAppeal: Scalars['ID']['output'];
  /** This will set the closed status on an appeal */
  closeAppeal: Appeal;
  /** Confirms insurance details for an appeal */
  confirmDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a new adverse event manually for an appeal */
  createAdverseEvent: AdverseEvent;
  /** Creates a new appeal department (Support users only) */
  createAppealDepartment: AppealDepartmentRecord;
  /**
   * Given the appealId and the input for an appealLetterIssue, this endpoint will create a HelpScout Conversation to track the issue.
   * It will also update the status for issueOutstanding to true.
   */
  createAppealLetterIssue?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Given the appealId and the input for an appealLetterIssue, this endpoint will create a HelpScout Conversation to track the issue.
   * It will also update the status for issueOutstanding to true.
   * Used for reporting issues from the appeal packet review page.
   */
  createAppealPacketIssue?: Maybe<Scalars['Boolean']['output']>;
  createAppealStaging: CreateAppealStagingResult;
  /** Creates a new appeal strategy (Support users only) */
  createAppealStrategy: AppealStrategy;
  /** Creates a new CC destination (Support users only) */
  createCcDestination: CcDestinationRecord;
  /** This will initiate a checkout session in Stripe and send back the session ID for the Client to use to connect to the session */
  createCheckoutSession: Scalars['String']['output'];
  /** Creates a new condition (Support users only) */
  createCondition: Condition;
  /** Creates a new denial reason (Support users only) */
  createDenialReason: DenialReasonRecord;
  /** Creates an email message for a provider and event type (Support users only) */
  createEmailMessage: EmailMessage;
  /** Allows a support user to revise a letter manually */
  createLetterRevision: Scalars['ID']['output'];
  /** Creates a new letter test with associated scenarios (Support users only) */
  createLetterTest: LetterTest;
  /** Adds a new scenario to an existing letter test (Support users only) */
  createLetterTestScenario: LetterTestScenario;
  /** Creates a new medication (Support users only) */
  createMedication: Medication;
  /** Creates a new medication-condition association (Support users only) */
  createMedicationCondition: MedicationCondition;
  /** Creates a new payer policy clinical criteria record (Support users only) */
  createPayerPolicyClinicalCriteria: PayerPolicyClinicalCriteria;
  /** Creates a new precedent case (Support users only) */
  createPrecedentCase: PrecedentCase;
  /** Create a provider with an initial provider user, returns the new provider ID */
  createProvider?: Maybe<Scalars['ID']['output']>;
  /** Create a provider with a user for whoever created the provider, returns the new provider */
  createProviderViaSelfSignUp: Provider;
  /** Creates a new sub-denial reason entry (Support users only) */
  createSubDenialReason: SubDenialReason;
  /** Creates a new survey schema */
  createSurveySchema: SurveySchema;
  /** Creates a new version of an existing survey schema */
  createSurveySchemaVersion: SurveySchema;
  /** Deletes an appeal department (Support users only) */
  deleteAppealDepartment: Scalars['Boolean']['output'];
  /** Deletes an appeal strategy (Support users only) */
  deleteAppealStrategy: Scalars['Boolean']['output'];
  /** Deletes an appeal supporting document */
  deleteAppealSupportingDocument?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a CC destination (Support users only) */
  deleteCcDestination: Scalars['Boolean']['output'];
  /**
   * Delete a clinical evidence entry from the gold standard table.
   * Support users only. Permanently removes the evidence from the database.
   */
  deleteClinicalEvidence: Scalars['Boolean']['output'];
  /** Deletes an email message (Support users only) */
  deleteEmailMessage: Scalars['Boolean']['output'];
  /** Deletes a letter test scenario (Support users only) */
  deleteLetterTestScenario: Scalars['Boolean']['output'];
  /** Deletes a medication-condition association (Support users only) */
  deleteMedicationCondition: Scalars['Boolean']['output'];
  /** Deletes a payer policy clinical criteria record (Support users only) */
  deletePayerPolicyClinicalCriteria: Scalars['Boolean']['output'];
  /** Deletes a precedent case (Support users only) */
  deletePrecedentCase: Scalars['Boolean']['output'];
  /** Returns links that can be used to download the pdf of the generated appeal letter */
  downloadAppealLetterLink?: Maybe<Scalars['String']['output']>;
  /** Returns links that can be used to download the baa */
  downloadBAAFormLink?: Maybe<Scalars['String']['output']>;
  /** Edits an existing unpublished survey schema in place (only allowed for unpublished schemas) */
  editSurveySchema: SurveySchema;
  /**
   * Extracts insurance card data from uploaded INSURANCE_CARD supporting document images using LLM vision.
   * Requires at least 1 file to be uploaded first via the supporting document flow.
   */
  extractInsuranceCardData: InsuranceCardExtraction;
  /**
   * Searches Semantic Scholar for clinical evidence and stores results in the in-review table.
   * Support users only. Papers can be reviewed and promoted to gold standard evidence.
   */
  gatherClinicalEvidence: GatherClinicalEvidenceResult;
  /**
   * Generate appeal PDF on-demand and return a presigned URL for viewing.
   * Similar to previewAppealPdf but for end users (generates final PDF, not preview).
   */
  generateAppealPdf: Scalars['String']['output'];
  /**
   * Generates a presigned S3 URL for uploading an appeal PDF.
   * Support users only. Returns a presigned URL that can be used to upload a PDF file directly to S3.
   */
  generateAppealPdfUploadLink: Scalars['String']['output'];
  /** Uses Claude to generate an appeal strategy based on condition, medication, and denial details (Support users only) */
  generateAppealStrategy: GeneratedAppealStrategy;
  /** Generates personas for scenarios in a letter test that do not already have one, using an LLM. Support users only. */
  generateLetterTestPersonas: GenerateLetterTestPersonasResult;
  /** Generates appeal letters for scenarios in a letter test that have personas but no existing letters. Support users only. */
  generateLettersForLetterTest: GenerateLettersForLetterTestResult;
  /**
   * Kicks off generation of a Provider Letter of Medical Necessity for an appeal.
   * Returns immediately; the result is written to the appeal's letter generation
   * record, which can be read via getAppealById.letterGeneration.
   */
  generateProviderLetterOfMedicalNecessity: Scalars['Boolean']['output'];
  /**
   * Generates pre-signed S3 upload URLs for supporting document files without creating DB records.
   * Call upsertAppealSupportingDocument after uploads succeed to persist the records.
   */
  generateSupportingDocumentUploadUrls: GenerateSupportingDocumentUploadUrlsResponse;
  /** Initialize a new referral with minimal information for eligibility checking */
  initializeReferral: InitialReferralData;
  linkAppealStagingToUser: LinkAppealStagingToUserResult;
  /**
   * Confirms that an appeal PDF has been uploaded and marks the appeal as having a generated PDF.
   * Support users only. Updates the pdfGenerated status to true.
   */
  markAppealPdfUploaded: Scalars['Boolean']['output'];
  /** Mark a followup appeal as ready for review by updating required statuses - Support users only */
  markAppealReadyForReview: Appeal;
  /** Generates a watermarked preview PDF for support users to review before final generation */
  previewAppealPdf?: Maybe<Scalars['String']['output']>;
  /** Marks a survey schema version as published (unpublishes other versions for the same condition) */
  publishSurveySchema: SurveySchema;
  /** Remove appeal outcome status (Overturned or Upheld) - Support users only */
  removeAppealOutcomeStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Removes the generated letter from a letter test scenario, allowing it to be regenerated (Support users only) */
  removeLetterGenerationFromScenario: LetterTestScenario;
  reportAppealOutcomeStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Request a second appeal for eligible Zepbound forced medication switch denials upheld by CVS Caremark */
  requestSecondAppeal: Scalars['Boolean']['output'];
  /** Given the appealID, this endpoint will update the issueOutstanding status to false */
  resolveIssue?: Maybe<Scalars['Boolean']['output']>;
  /** Review a letter generation by assigning a grade and optional notes. Support only. */
  reviewLetterGeneration: LetterGeneration;
  /** Saves appeal department data for an appeal */
  saveAppealDeptData?: Maybe<Scalars['Boolean']['output']>;
  /** Given the appealId and list of CcDestinationInput, this endpoint will save the ccDestinations on the metadata object */
  saveCCDestinations?: Maybe<Scalars['Boolean']['output']>;
  /** Saves caregiver data for an appeal */
  saveCaregiverData: Scalars['Boolean']['output'];
  /** Save denial upheld reason. */
  saveDenialUpheldDenialReason?: Maybe<Scalars['Boolean']['output']>;
  /** Save whether the patient has received their claims file or not. */
  saveDenialUpheldReceivedClaimsFile?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for who the denial is from to be saved on the confirmed data in the insurance info db row */
  saveDenyingParty?: Maybe<Scalars['Boolean']['output']>;
  /** Save Insurance destination for Employer Self-Funded insurance */
  saveInsuranceEmployer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Save complete insurance information for an appeal including provider details,
   * plan category, policyholder relationship, denying party, and optional employer
   * and pharmacy benefit manager information. This mutation is idempotent and can
   * be called multiple times to update insurance information.
   *
   * Required fields:
   * - insuranceProvider: Name of the insurance company
   * - memberId: Insurance member/subscriber ID
   * - groupNumber: Insurance group number
   * - planCategory: Type of insurance plan
   * - denyingParty: Which party denied the claim
   * - relationshipToPolicyholder: Patient's relationship to the primary policyholder
   *
   * Conditional requirements:
   * - If relationshipToPolicyholder is SPOUSE or DEPENDENT: policyholderFirstName and policyholderLastName required
   * - If planCategory is EMPLOYER_FULLY_INSURED or EMPLOYER_SELF_FUNDED: employerName required
   */
  saveInsuranceInfo?: Maybe<Scalars['Boolean']['output']>;
  saveIsExpeditedReview?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for the patient to save if there are other appeal situations in the insurance info db row */
  saveOtherAppealSituations?: Maybe<Scalars['Boolean']['output']>;
  /** Saves patient and caregiver information for a provider referral */
  savePatientAndCaregiverInfoOnReferral: Scalars['Boolean']['output'];
  /** Saves patient data for an appeal */
  savePatientData?: Maybe<Scalars['Boolean']['output']>;
  /** This allows the primary enrollee of the insurance plan to be saved in the confirmed insurance data */
  savePrimaryEnrollee?: Maybe<Scalars['Boolean']['output']>;
  /** Saves default referral message for a provider */
  saveProviderDefaultReferralMessage?: Maybe<Provider>;
  /**
   * Send the appeal letter to all configured destinations (payer + CCs).
   * Always generates the PDF first.
   */
  sendAppeal: Scalars['Boolean']['output'];
  /**
   * Send an appeal manually to a specific destination.
   * Allows support users to send appeals via fax or mail to either
   * the configured payer destination or a custom address.
   */
  sendAppealManually: ManualAppealSendResponse;
  /** Send a message to ChatGPT and receive a response (Support users only) */
  sendChatGptMessage: ChatGptResponse;
  /** Send a referral to the patient via email. This finalizes the referral by sending the email and marking it as sent. */
  sendReferralToPatient: Scalars['Boolean']['output'];
  /** Assign referred appeals to the user upon account creation */
  setupNewUserWithExistingReferrals?: Maybe<Array<Appeal>>;
  /** Marks this provider as having accepted the BAA with Claimable */
  signProviderBusinessAssociateAgreement?: Maybe<Provider>;
  /** This is used to record that the user is skipping the DENIAL_LETTER upload */
  skipUpload?: Maybe<Scalars['Boolean']['output']>;
  /** This will send an event that will start the generation process for a given appeal */
  startGenerateAppeal?: Maybe<Scalars['Boolean']['output']>;
  /** Start a new appeal based on an existing appeal with relevant data carried forward */
  startNextAppeal: Scalars['ID']['output'];
  /** Toggles whether an appeal supporting document is included in the appeal letter */
  toggleAppealSupportingDocumentInclusion: AppealSupportingDocument;
  /**
   * Toggles Claimable sponsorship for an appeal.
   * If the appeal is not sponsored, it adds Claimable sponsorship.
   * If the appeal is sponsored by Claimable, it removes the sponsorship.
   * Only available to support users.
   */
  toggleClaimableAppealSponsorship: Appeal;
  /** Toggles the is_active flag on a medication-condition association (Support users only) */
  toggleMedicationConditionActive?: Maybe<MedicationCondition>;
  /** Unpublishes a survey schema version, leaving its condition without an active published survey */
  unpublishSurveySchema: SurveySchema;
  /** Updates the Sanofi ID for an adverse event to mark it as reported */
  updateAdverseEventSanofiId: Scalars['Boolean']['output'];
  /** Updates denial reason and sub-denial reasons for an existing appeal */
  updateAppealDenialReasons: Appeal;
  /** Updates an existing appeal department (Support users only) */
  updateAppealDepartment?: Maybe<AppealDepartmentRecord>;
  /** Updates the patient's date of birth on an appeal. Support-only. */
  updateAppealPatientDateOfBirth: Patient;
  /** This will update the plan category of an existing appeal */
  updateAppealPlanCategory?: Maybe<Appeal>;
  updateAppealStatusWithToken?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an existing appeal strategy (Support users only) */
  updateAppealStrategy: AppealStrategy;
  /** Updates the appeal type for an existing appeal */
  updateAppealType: Scalars['Boolean']['output'];
  /** Updates an existing CC destination (Support users only) */
  updateCcDestination?: Maybe<CcDestinationRecord>;
  /**
   * Update an existing clinical evidence entry in the gold standard table.
   * Support users only. All fields except id are optional - only provided fields will be updated.
   */
  updateClinicalEvidence: ClinicalEvidence;
  /** Updates an existing condition (Support users only) */
  updateCondition?: Maybe<Condition>;
  /** Updates an existing denial reason (Support users only) */
  updateDenialReason?: Maybe<DenialReasonRecord>;
  /** Updates an existing email message (Support users only) */
  updateEmailMessage: EmailMessage;
  /** Updates an existing letter test's name and replaces its scenarios (Support users only) */
  updateLetterTest: LetterTest;
  /** Updates the persona of a letter test scenario (Support users only) */
  updateLetterTestScenarioPersona: LetterTestScenario;
  /** Updates an existing medication (Support users only) */
  updateMedication?: Maybe<Medication>;
  /** Updates an existing payer policy clinical criteria record (Support users only) */
  updatePayerPolicyClinicalCriteria?: Maybe<PayerPolicyClinicalCriteria>;
  /** Updates a payer policy extraction's clinical criteria */
  updatePayerPolicyExtraction: PayerPolicyExtraction;
  /** Updates an existing precedent case (Support users only) */
  updatePrecedentCase?: Maybe<PrecedentCase>;
  /** Updates providers free trail end date */
  updateProviderFreeTrialEndDate?: Maybe<Provider>;
  /** Updates the alert email for a provider organization */
  updateProviderNotificationEmail?: Maybe<Provider>;
  /** Updates the provider type (e.g. provider vs enterprise_provider) for a provider */
  updateProviderType?: Maybe<Provider>;
  /** Updates a provider user's active status (Admins only) */
  updateProviderUserActiveStatus: ProviderUser;
  /** Updates a provider user's active status (Support only) */
  updateProviderUserActiveStatusBySupport: ProviderUser;
  /** Updates a provider user's personal info */
  updateProviderUserInfo?: Maybe<ProviderUser>;
  /** Updates an existing sub-denial reason entry (Support users only) */
  updateSubDenialReason?: Maybe<SubDenialReason>;
  /** This allows for survey answers to be saved to an appeal via an appealId */
  updateSurveyAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for survey-js answers to be saved to an appeal via an appealId */
  updateSurveyJsAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** Upserts an appeal supporting document */
  upsertAppealSupportingDocument: UpsertAppealSupportingDocumentResponse;
};


export type MutationUpdateProviderUserRoleArgs = {
  providerUserId: Scalars['ID']['input'];
  role: ProviderUserRole;
};


export type MutationAddAppealLetterTraceToEvalDatasetArgs = {
  input: AddAppealLetterTraceToEvalDatasetInput;
};


export type MutationAddClinicalEvidenceEntryArgs = {
  input: AddClinicalEvidenceEntryInput;
};


export type MutationAddNewUserToProviderArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddNewUserToProviderByProviderIdArgs = {
  email: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  role?: InputMaybe<ProviderUserRole>;
};


export type MutationApprovePayerPolicyExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveInReviewEvidenceArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCloneAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationCloseAppealArgs = {
  appealId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};


export type MutationConfirmDetailsArgs = {
  appealId: Scalars['ID']['input'];
  confirmDetails: ConfirmDetailsInput;
};


export type MutationCreateAdverseEventArgs = {
  adverseEvent: Scalars['String']['input'];
  appealId: Scalars['ID']['input'];
  channel: AdverseEventChannel;
  condition: Scalars['String']['input'];
  medication: Scalars['String']['input'];
};


export type MutationCreateAppealDepartmentArgs = {
  input: CreateAppealDepartmentInput;
};


export type MutationCreateAppealLetterIssueArgs = {
  appealId: Scalars['ID']['input'];
  appealLetterIssue: AppealLetterIssueInput;
};


export type MutationCreateAppealPacketIssueArgs = {
  appealId: Scalars['ID']['input'];
  appealLetterIssue: AppealLetterIssueInput;
};


export type MutationCreateAppealStagingArgs = {
  input: CreateAppealStagingInput;
};


export type MutationCreateAppealStrategyArgs = {
  input: CreateAppealStrategyInput;
};


export type MutationCreateCcDestinationArgs = {
  input: CreateCcDestinationInput;
};


export type MutationCreateCheckoutSessionArgs = {
  appealId: Scalars['ID']['input'];
  useModularRoutes?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateConditionArgs = {
  input: CreateConditionInput;
};


export type MutationCreateDenialReasonArgs = {
  input: CreateDenialReasonInput;
};


export type MutationCreateEmailMessageArgs = {
  input: CreateEmailMessageInput;
};


export type MutationCreateLetterRevisionArgs = {
  appealId: Scalars['ID']['input'];
  letterRevision: LetterRevisionInput;
};


export type MutationCreateLetterTestArgs = {
  input: CreateLetterTestInput;
};


export type MutationCreateLetterTestScenarioArgs = {
  input: AddLetterTestScenarioInput;
};


export type MutationCreateMedicationArgs = {
  input: CreateMedicationInput;
};


export type MutationCreateMedicationConditionArgs = {
  input: CreateMedicationConditionInput;
};


export type MutationCreatePayerPolicyClinicalCriteriaArgs = {
  input: CreatePayerPolicyClinicalCriteriaInput;
};


export type MutationCreatePrecedentCaseArgs = {
  input: PrecedentCaseInput;
};


export type MutationCreateProviderArgs = {
  providerName: Scalars['String']['input'];
  providerUserEmail: Scalars['String']['input'];
  type: ProviderType;
};


export type MutationCreateProviderViaSelfSignUpArgs = {
  input: CreateProviderViaSelfSignUpInput;
};


export type MutationCreateSubDenialReasonArgs = {
  input: CreateSubDenialReasonInput;
};


export type MutationCreateSurveySchemaArgs = {
  input: CreateSurveySchemaInput;
};


export type MutationCreateSurveySchemaVersionArgs = {
  input: UpdateSurveySchemaInput;
};


export type MutationDeleteAppealDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppealStrategyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppealSupportingDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCcDestinationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicalEvidenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLetterTestScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMedicationConditionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePayerPolicyClinicalCriteriaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePrecedentCaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadAppealLetterLinkArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationEditSurveySchemaArgs = {
  input: UpdateSurveySchemaInput;
};


export type MutationExtractInsuranceCardDataArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationGatherClinicalEvidenceArgs = {
  input: GatherClinicalEvidenceInput;
};


export type MutationGenerateAppealPdfArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationGenerateAppealPdfUploadLinkArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationGenerateAppealStrategyArgs = {
  input: GenerateAppealStrategyInput;
};


export type MutationGenerateLetterTestPersonasArgs = {
  input: GenerateLetterTestPersonasInput;
};


export type MutationGenerateLettersForLetterTestArgs = {
  input: GenerateLettersForLetterTestInput;
};


export type MutationGenerateProviderLetterOfMedicalNecessityArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationGenerateSupportingDocumentUploadUrlsArgs = {
  appealId: Scalars['ID']['input'];
  document: GenerateSupportingDocumentUploadInput;
};


export type MutationInitializeReferralArgs = {
  input: InitializeReferralInput;
};


export type MutationLinkAppealStagingToUserArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationMarkAppealPdfUploadedArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationMarkAppealReadyForReviewArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationPreviewAppealPdfArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationPublishSurveySchemaArgs = {
  input: PublishSurveySchemaInput;
};


export type MutationRemoveAppealOutcomeStatusArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationRemoveLetterGenerationFromScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReportAppealOutcomeStatusArgs = {
  appealId: Scalars['ID']['input'];
  source?: InputMaybe<AppealOutcomeSource>;
  status: ReportAppealStatusInput;
};


export type MutationRequestSecondAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationResolveIssueArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationReviewLetterGenerationArgs = {
  input: ReviewLetterGenerationInput;
};


export type MutationSaveAppealDeptDataArgs = {
  appealDeptData: AppealDestinationInput;
  appealId: Scalars['ID']['input'];
};


export type MutationSaveCcDestinationsArgs = {
  appealId: Scalars['ID']['input'];
  destinations: Array<CcDestinationInput>;
};


export type MutationSaveCaregiverDataArgs = {
  appealId: Scalars['ID']['input'];
  caregiver: CaregiverInput;
};


export type MutationSaveDenialUpheldDenialReasonArgs = {
  appealId: Scalars['ID']['input'];
  denialReason: Scalars['String']['input'];
};


export type MutationSaveDenialUpheldReceivedClaimsFileArgs = {
  appealId: Scalars['ID']['input'];
  hasReceivedClaimsFile: Scalars['Boolean']['input'];
};


export type MutationSaveDenyingPartyArgs = {
  appealId: Scalars['ID']['input'];
  denyingParty: DenyingPartyInput;
};


export type MutationSaveInsuranceEmployerArgs = {
  appealId: Scalars['ID']['input'];
  employer: EmployerInput;
};


export type MutationSaveInsuranceInfoArgs = {
  appealId: Scalars['ID']['input'];
  insuranceInfo: SaveInsuranceInfoInput;
};


export type MutationSaveIsExpeditedReviewArgs = {
  appealId: Scalars['ID']['input'];
  isExpeditedReview: Scalars['Boolean']['input'];
};


export type MutationSaveOtherAppealSituationsArgs = {
  appealId: Scalars['ID']['input'];
  otherAppealSituations: OtherAppealSituationsInput;
};


export type MutationSavePatientAndCaregiverInfoOnReferralArgs = {
  input: SavePatientAndCaregiverInfoOnReferralInput;
};


export type MutationSavePatientDataArgs = {
  appealId: Scalars['ID']['input'];
  patientData: PatientDataInput;
};


export type MutationSavePrimaryEnrolleeArgs = {
  appealId: Scalars['ID']['input'];
  primaryEnrollee: PrimaryEnrolleeInput;
};


export type MutationSaveProviderDefaultReferralMessageArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};


export type MutationSendAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationSendAppealManuallyArgs = {
  input: ManualAppealSendInput;
};


export type MutationSendChatGptMessageArgs = {
  documents?: InputMaybe<Array<ChatGptDocumentInput>>;
  messages: Array<ChatGptMessageInput>;
  model?: InputMaybe<Scalars['String']['input']>;
  textContexts?: InputMaybe<Array<ChatGptTextContextInput>>;
};


export type MutationSendReferralToPatientArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationSetupNewUserWithExistingReferralsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSkipUploadArgs = {
  appealId: Scalars['ID']['input'];
  uploadSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  uploadType: UploadDocumentType;
};


export type MutationStartGenerateAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationStartNextAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationToggleAppealSupportingDocumentInclusionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationToggleClaimableAppealSponsorshipArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationToggleMedicationConditionActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpublishSurveySchemaArgs = {
  input: UnpublishSurveySchemaInput;
};


export type MutationUpdateAdverseEventSanofiIdArgs = {
  adverseEventId: Scalars['ID']['input'];
  sanofiId: Scalars['String']['input'];
};


export type MutationUpdateAppealDenialReasonsArgs = {
  input: UpdateAppealDenialReasonsInput;
};


export type MutationUpdateAppealDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAppealDepartmentInput;
};


export type MutationUpdateAppealPatientDateOfBirthArgs = {
  appealId: Scalars['ID']['input'];
  dateOfBirth: Scalars['Date']['input'];
};


export type MutationUpdateAppealPlanCategoryArgs = {
  appealId: Scalars['ID']['input'];
  updateAppealPlanCategoryInput: UpdateAppealPlanCategoryInput;
};


export type MutationUpdateAppealStatusWithTokenArgs = {
  outcomeDeterminedAt?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<AppealOutcomeSource>;
  status: AppealOutcomeStatus;
  token: Scalars['String']['input'];
};


export type MutationUpdateAppealStrategyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAppealStrategyInput;
};


export type MutationUpdateAppealTypeArgs = {
  appealId: Scalars['ID']['input'];
  appealType: AppealType;
};


export type MutationUpdateCcDestinationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCcDestinationInput;
};


export type MutationUpdateClinicalEvidenceArgs = {
  input: UpdateClinicalEvidenceInput;
};


export type MutationUpdateConditionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConditionInput;
};


export type MutationUpdateDenialReasonArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDenialReasonInput;
};


export type MutationUpdateEmailMessageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmailMessageInput;
};


export type MutationUpdateLetterTestArgs = {
  input: UpdateLetterTestInput;
};


export type MutationUpdateLetterTestScenarioPersonaArgs = {
  input: UpdateLetterTestScenarioPersonaInput;
};


export type MutationUpdateMedicationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMedicationInput;
};


export type MutationUpdatePayerPolicyClinicalCriteriaArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePayerPolicyClinicalCriteriaInput;
};


export type MutationUpdatePayerPolicyExtractionArgs = {
  continuationClinicalCriteria?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  initialClinicalCriteria: Scalars['String']['input'];
};


export type MutationUpdatePrecedentCaseArgs = {
  id: Scalars['ID']['input'];
  input: PrecedentCaseInput;
};


export type MutationUpdateProviderFreeTrialEndDateArgs = {
  newEndDate: Scalars['Date']['input'];
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderNotificationEmailArgs = {
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderTypeArgs = {
  providerId: Scalars['ID']['input'];
  type: ProviderType;
};


export type MutationUpdateProviderUserActiveStatusArgs = {
  active: Scalars['Boolean']['input'];
  providerUserId: Scalars['ID']['input'];
};


export type MutationUpdateProviderUserActiveStatusBySupportArgs = {
  active: Scalars['Boolean']['input'];
  providerUserId: Scalars['ID']['input'];
};


export type MutationUpdateProviderUserInfoArgs = {
  input: UpdateProviderUserInfoInput;
};


export type MutationUpdateSubDenialReasonArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubDenialReasonInput;
};


export type MutationUpdateSurveyAnswersArgs = {
  appealId: Scalars['ID']['input'];
  surveyAnswers: Array<SurveyAnswerInput>;
};


export type MutationUpdateSurveyJsAnswersArgs = {
  appealId: Scalars['ID']['input'];
  surveyJsAnswers: Scalars['String']['input'];
  surveySchemaId: Scalars['ID']['input'];
};


export type MutationUpsertAppealSupportingDocumentArgs = {
  appealId: Scalars['ID']['input'];
  document: PersistSupportingDocumentInput;
};

export enum OrganizationType {
  AdvocacyGroup = 'ADVOCACY_GROUP',
  Provider = 'PROVIDER'
}

export enum OtherAppealSituations {
  AppealPeriodExpired = 'APPEAL_PERIOD_EXPIRED',
  CopayDoesNotCount = 'COPAY_DOES_NOT_COUNT',
  ExtremeCareDelay = 'EXTREME_CARE_DELAY',
  SwitchedHealthPlans = 'SWITCHED_HEALTH_PLANS'
}

export type OtherAppealSituationsInput = {
  otherAppealSituations: Array<OtherAppealSituations>;
};

export type PaginatedAdverseEvents = {
  __typename?: 'PaginatedAdverseEvents';
  data: Array<AdverseEvent>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAppealDepartments = {
  __typename?: 'PaginatedAppealDepartments';
  data: Array<AppealDepartmentRecord>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedAppealStrategies = {
  __typename?: 'PaginatedAppealStrategies';
  data: Array<AppealStrategy>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAppeals = {
  __typename?: 'PaginatedAppeals';
  data: Array<Appeal>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedCcDestinations = {
  __typename?: 'PaginatedCcDestinations';
  data: Array<CcDestinationRecord>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedClinicalEvidence = {
  __typename?: 'PaginatedClinicalEvidence';
  data: Array<ClinicalEvidence>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedConditions = {
  __typename?: 'PaginatedConditions';
  data: Array<Condition>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedDenialReasons = {
  __typename?: 'PaginatedDenialReasons';
  data: Array<DenialReasonRecord>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedInReviewClinicalEvidence = {
  __typename?: 'PaginatedInReviewClinicalEvidence';
  data: Array<InReviewClinicalEvidence>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLetterTests = {
  __typename?: 'PaginatedLetterTests';
  data: Array<LetterTest>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMedicationConditions = {
  __typename?: 'PaginatedMedicationConditions';
  data: Array<MedicationCondition>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedMedications = {
  __typename?: 'PaginatedMedications';
  data: Array<Medication>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedPayerPolicyClinicalCriteria = {
  __typename?: 'PaginatedPayerPolicyClinicalCriteria';
  data: Array<PayerPolicyClinicalCriteria>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPayerPolicyExtraction = {
  __typename?: 'PaginatedPayerPolicyExtraction';
  data: Array<PayerPolicyExtraction>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPrecedentCases = {
  __typename?: 'PaginatedPrecedentCases';
  data: Array<PrecedentCase>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProviders = {
  __typename?: 'PaginatedProviders';
  data: Array<Provider>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedReferrals = {
  __typename?: 'PaginatedReferrals';
  hasNextPage: Scalars['Boolean']['output'];
  referrals: Array<Referral>;
};

export type PaginatedSubDenialReasons = {
  __typename?: 'PaginatedSubDenialReasons';
  data: Array<SubDenialReason>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type Patient = {
  __typename?: 'Patient';
  address?: Maybe<Address>;
  dateOfBirth: Scalars['Date']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasMarketingSmsConsent: Scalars['Boolean']['output'];
  hasTransactionalSmsConsent: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  sex?: Maybe<Sex>;
};

export type PatientDataInput = {
  address: AddressInput;
  consentToMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
};

export type PatientInfoInput = {
  dateOfBirth: Scalars['Date']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
  state: Scalars['String']['input'];
};

export type PatientInsurance = {
  __typename?: 'PatientInsurance';
  employer?: Maybe<Employer>;
  enrolleeFirstName?: Maybe<Scalars['String']['output']>;
  enrolleeLastName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  isPatientEnrollee?: Maybe<Scalars['Boolean']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
  pbmName?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<PlanCategory>;
  providerName?: Maybe<Scalars['String']['output']>;
  rxBinNumber?: Maybe<Scalars['String']['output']>;
  rxGroupNumber?: Maybe<Scalars['String']['output']>;
  rxMemberId?: Maybe<Scalars['String']['output']>;
};

export type PayerPolicyClinicalCriteria = {
  __typename?: 'PayerPolicyClinicalCriteria';
  condition: Scalars['String']['output'];
  continuationClinicalCriteria: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initialClinicalCriteria: Scalars['String']['output'];
  medication: Scalars['String']['output'];
  payer: Scalars['String']['output'];
};

export type PayerPolicyClinicalCriteriaInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<PayerPolicyClinicalCriteriaSearchTermsInput>;
};

export type PayerPolicyClinicalCriteriaSearchTermsInput = {
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  payer?: InputMaybe<Scalars['String']['input']>;
};

export type PayerPolicyExtraction = {
  __typename?: 'PayerPolicyExtraction';
  approvingUserId?: Maybe<Scalars['ID']['output']>;
  condition: Scalars['String']['output'];
  continuationClinicalCriteria?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initialClinicalCriteria: Scalars['String']['output'];
  medication: Scalars['String']['output'];
  payer: Scalars['String']['output'];
  payerPolicyClinicalCriteriaId?: Maybe<Scalars['ID']['output']>;
  policyBotId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PayerPolicyExtractionInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<PayerPolicyExtractionSearchTermsInput>;
};

export type PayerPolicyExtractionSearchTermsInput = {
  approvalStatus?: InputMaybe<ApprovalStatus>;
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  payer?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  amountDiscount: Scalars['Float']['output'];
  amountSubtotal: Scalars['Float']['output'];
  amountTax: Scalars['Float']['output'];
  amountTotal: Scalars['Float']['output'];
  appealPrice: Scalars['Float']['output'];
  checkoutSessionId: Scalars['String']['output'];
  destinationPrice: Scalars['Float']['output'];
  destinationQuantity: Scalars['Int']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  paymentTimestamp: Scalars['Date']['output'];
  shippingAmount: Scalars['Float']['output'];
};

export type PersistSupportingDocumentFileInput = {
  fileId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileType: AppealSupportingDocumentFileType;
  pageCount: Scalars['Int']['input'];
};

export type PersistSupportingDocumentInput = {
  documentId: Scalars['ID']['input'];
  documentType: AppealSupportingDocumentType;
  files: Array<PersistSupportingDocumentFileInput>;
  otherDocumentTypeName?: InputMaybe<Scalars['String']['input']>;
};

export enum PersonaCoverageType {
  Continuation = 'CONTINUATION',
  Initial = 'INITIAL'
}

export enum PersonaPatientType {
  Adult = 'ADULT',
  Pediatric = 'PEDIATRIC'
}

export enum PlanCategory {
  EmployerFederalGovernment = 'EMPLOYER_FEDERAL_GOVERNMENT',
  EmployerFullyInsured = 'EMPLOYER_FULLY_INSURED',
  EmployerLocalStateGovernment = 'EMPLOYER_LOCAL_STATE_GOVERNMENT',
  EmployerSelfFunded = 'EMPLOYER_SELF_FUNDED',
  IndividualExchange = 'INDIVIDUAL_EXCHANGE',
  Medicaid = 'MEDICAID',
  MedicareAdvantage = 'MEDICARE_ADVANTAGE',
  MedicareTraditional = 'MEDICARE_TRADITIONAL',
  OtherFederalHealthcare = 'OTHER_FEDERAL_HEALTHCARE'
}

export type PrecedentCase = {
  __typename?: 'PrecedentCase';
  condition: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  decisionYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  medication: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  state: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PrecedentCaseInput = {
  condition: Scalars['String']['input'];
  decisionYear: Scalars['Int']['input'];
  medication: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
  state: Scalars['String']['input'];
  summary: Scalars['String']['input'];
};

export type PrecedentCaseSearchTermsInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  medication?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PrecedentCasesQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<PrecedentCaseSearchTermsInput>;
};

export type PrimaryEnrolleeInput = {
  enrolleeFirstName?: InputMaybe<Scalars['String']['input']>;
  enrolleeLastName?: InputMaybe<Scalars['String']['input']>;
  isPatientEnrollee: Scalars['Boolean']['input'];
};

export type ProductPrices = {
  __typename?: 'ProductPrices';
  appealPrice: Scalars['Float']['output'];
  ccDestinationPrice: Scalars['Float']['output'];
  shippingRate: Scalars['Float']['output'];
};

export enum Pronouns {
  HeHimHis = 'HE_HIM_HIS',
  SheHerHers = 'SHE_HER_HERS',
  TheyThemTheirs = 'THEY_THEM_THEIRS'
}

export type Provider = {
  __typename?: 'Provider';
  createdTimestamp: Scalars['Date']['output'];
  defaultReferralMessage?: Maybe<Scalars['String']['output']>;
  facilities: Array<ProviderFacility>;
  freeTrialEndTimestamp: Scalars['String']['output'];
  hasSignedBAA: Scalars['Boolean']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  notificationEmail?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<OrganizationType>;
  providerId: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  specialty?: Maybe<Scalars['String']['output']>;
  type: ProviderType;
  users: Array<ProviderUser>;
};

export type ProviderFacility = {
  __typename?: 'ProviderFacility';
  facilityName: Scalars['String']['output'];
  facilityShortName: Scalars['String']['output'];
  providerFacilityId: Scalars['ID']['output'];
};

export type ProviderReferral = {
  __typename?: 'ProviderReferral';
  appealId: Scalars['ID']['output'];
  createdTimestamp: Scalars['Date']['output'];
  hasPatientConsent?: Maybe<Scalars['Boolean']['output']>;
  patientEmail?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['ID']['output'];
  providerMessage?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  providerUserId: Scalars['ID']['output'];
  referralId: Scalars['ID']['output'];
  sponsoringParty?: Maybe<SponsoringParty>;
};

export enum ProviderType {
  EnterpriseProvider = 'enterprise_provider',
  Provider = 'provider'
}

export type ProviderUser = {
  __typename?: 'ProviderUser';
  active: Scalars['Boolean']['output'];
  createdTimestamp: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['ID']['output'];
  providerUserId: Scalars['ID']['output'];
  role: ProviderUserRole;
};

export enum ProviderUserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type ProvidersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<ProvidersSearchTermsInput>;
};

export type ProvidersSearchTermsInput = {
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerUserEmail?: InputMaybe<Scalars['String']['input']>;
};

export type PublishSurveySchemaInput = {
  id: Scalars['ID']['input'];
};

export type QrUploadUrlResponse = {
  __typename?: 'QrUploadUrlResponse';
  uploadUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeHelpScoutConversations: Array<ActiveSupportItem>;
  adverseEventAppeals: Array<AdverseEventAppealResult>;
  /** Gets a paginated list of adverse events for Sanofi reporting */
  adverseEvents: PaginatedAdverseEvents;
  /**
   * Aggregate deliverability metrics for support ops. Counts fax/mail send attempts and outcomes
   * in the requested date range. Support users only.
   */
  appealDeliverabilityMetrics: AppealDeliverabilityMetrics;
  /** Gets a single appeal department by ID (Support users only) */
  appealDepartment?: Maybe<AppealDepartmentRecord>;
  /** Gets a paginated list of appeal departments (Support users only) */
  appealDepartments: PaginatedAppealDepartments;
  /** Gets the addresses for the CC selection page by plan category, i.e. Self-Insured or Medicare Advantage */
  appealDestinations: Array<AppealDestination>;
  appealOverview: AppealOverview;
  appealPatient?: Maybe<Patient>;
  appealPurchaseSummary?: Maybe<AppealPurchaseSummary>;
  appealStatus?: Maybe<AppealStatus>;
  /** Gets a paginated list of appeal strategies (Support users only) */
  appealStrategies: PaginatedAppealStrategies;
  /** Gets a single appeal strategy by ID (Support users only) */
  appealStrategy?: Maybe<AppealStrategy>;
  /** Gets the audit log for a specific appeal strategy (Support users only) */
  appealStrategyAuditLog: Array<AppealStrategyAuditEntry>;
  /** Gets all distinct tags used in appeal strategies for autocomplete (Support users only) */
  appealStrategyTags: Array<Scalars['String']['output']>;
  /** This will get a list of paginated appeals, sorted by created date */
  appeals: PaginatedAppeals;
  /** Returns US address suggestions from Lob autocompletions API for a given address prefix. */
  autocompleteAddress: Array<AddressSuggestion>;
  /** Gets a single CC destination by ID (Support users only) */
  ccDestination?: Maybe<CcDestinationRecord>;
  /** Gets a paginated list of CC destinations (Support users only) */
  ccDestinations: PaginatedCcDestinations;
  /** Gets a list of paginated clinical evidence, sorted by medication and condition. */
  clinicalEvidence: PaginatedClinicalEvidence;
  /** Gets all distinct conditions used in clinical evidence for autocomplete. */
  clinicalEvidenceConditions: Array<Scalars['String']['output']>;
  /** Gets all distinct medications used in clinical evidence for autocomplete. */
  clinicalEvidenceMedications: Array<Scalars['String']['output']>;
  /** Gets all distinct tags used in clinical evidence for autocomplete. */
  clinicalEvidenceTags: Array<Scalars['String']['output']>;
  /** Gets a single condition by ID (Support users only) */
  condition?: Maybe<Condition>;
  /** Gets a paginated list of conditions (Support users only) */
  conditions: PaginatedConditions;
  /**
   * Returns the conditions available in the patient eligibility condition dropdown. Lifts the
   * conditions derivation from medication-condition-eligibility-form.tsx onto the server:
   * LIVER_TRANSPLANT and AVANCE_NERVE_GRAFT feature flags are evaluated here, and OBESITY is
   * gated by !coverageFundAppeal. The result is the same sorted string list the client used
   * to render.
   */
  conditionsForEligibility: Array<Scalars['String']['output']>;
  /**
   * Returns the conditions a given medication treats. Server-side equivalent of the shared
   * getConditionsTreatedByMedication helper. The medication arg matches the Medication /
   * PansPandasMedication enum value (e.g. "Humira", "Strensiq").
   */
  conditionsTreatedByMedication: Array<Scalars['String']['output']>;
  denial: Denial;
  /** Gets a single denial reason by ID (Support users only) */
  denialReason?: Maybe<DenialReasonRecord>;
  /** Gets a paginated list of denial reasons (Support users only) */
  denialReasons: PaginatedDenialReasons;
  /**
   * Gets the appeal department for the denying party, if available, in order to default it on the appeal department page
   * - This will be determined based on the denying party (insurance, PBM, or other) and potentially the plan category depending on the insurer
   * - The fax number may also be different based on standard vs expedited review, depending on the insurer
   */
  denyingPartyAppealDepartment?: Maybe<DenyingPartyAppealDepartment>;
  /** Gets a single email message by ID (Support users only) */
  emailMessage?: Maybe<EmailMessage>;
  /** Gets all email messages for a provider (Support users only) */
  emailMessagesByProvider: Array<EmailMessage>;
  /** Returns metadata for all registered evaluators. Support users only. */
  evaluators: Array<EvaluatorInfo>;
  /** Returns the expedited review recommendation for an existing appeal. If the appeal already has a persisted value, returns EXPEDITED or STANDARD. Otherwise computes the recommendation from the appeal's condition and denial reason. */
  expeditedReviewRecommendationForAppeal: ExpeditedReviewRecommendation;
  /** Returns the expedited review recommendation for a given condition and denial reason, without requiring a persisted appeal. */
  expeditedReviewRecommendationForInputs: ExpeditedReviewRecommendation;
  /** Returns all survey schemas */
  getAllSurveySchemas: Array<SurveySchema>;
  /** This will return a single appeal if the appeal id exists. It will return an empty object if the appeal does not exist. */
  getAppealById?: Maybe<Appeal>;
  getAppealDetailSection?: Maybe<AppealDetailSection>;
  /** Returns outcome events (reported/removed) for a given appeal */
  getAppealOutcomeEvents: Array<AppealOutcomeEvent>;
  /** Gets the payment information from Stripe and returns the data to the user */
  getAppealPayment?: Maybe<Payment>;
  /** This will pull the userId out of the context */
  getAppeals: Array<Appeal>;
  getHelpScoutConversations: Array<HelpScoutConversation>;
  /** Returns the insurance card extraction result for an appeal, or null if none exists. */
  getInsuranceCardExtraction?: Maybe<InsuranceCardExtraction>;
  /** Returns all letter generations for a given appeal */
  getLetterGenerations?: Maybe<Array<Maybe<LetterGeneration>>>;
  /** Returns the letter revision for a given appeal */
  getLetterRevisions?: Maybe<Array<Maybe<LetterRevisionHistory>>>;
  /** Returns all letter revisions with full letter content for a given appeal */
  getLetterRevisionsFull: Array<LetterRevisionFull>;
  /** Gets a presigned URL for a payer policy PDF from PolicyBot. */
  getPayerPolicyPresignedUrl: Scalars['String']['output'];
  /** Gets the provider based on a provider ID */
  getProviderById?: Maybe<Provider>;
  /** Returns the provider user who referred the appeal */
  getReferringProviderUser?: Maybe<ProviderUser>;
  /** Returns all letter generations that have been reviewed (have review grade or notes). Support users only. */
  getReviewedLetterGenerations: Array<LetterGeneration>;
  /** Returns a survey schema by ID */
  getSurveySchemaById?: Maybe<SurveySchema>;
  /**
   * Returns whether the appeal already has legacy (non-SurveyJS) survey answers saved.
   * Used to keep in-flight appeals on the legacy survey flow even when a SurveyJS
   * schema has since been published for their condition.
   */
  hasLegacySurveyAnswers: Scalars['Boolean']['output'];
  /** Returns whether a published SurveyJS schema exists for the appeal's condition */
  hasSurveySchemaForAppeal: Scalars['Boolean']['output'];
  /** Health check endpoint for uptime monitoring */
  healthCheck: Scalars['String']['output'];
  /** Gets a list of paginated in-review clinical evidence (pending review), sorted by medication and condition. */
  inReviewClinicalEvidence: PaginatedInReviewClinicalEvidence;
  /** Returns whether an appeal is free (no payment required) based on referral, coverage fund, sponsored medication, or PANS/PANDAS condition. */
  isAppealFree: Scalars['Boolean']['output'];
  /** Gets a single letter test by ID (Support users only) */
  letterTest?: Maybe<LetterTest>;
  /** Gets a single letter test scenario by ID (Support users only) */
  letterTestScenario?: Maybe<LetterTestScenario>;
  /** Gets a single letter test scenario execution by ID (Support users only) */
  letterTestScenarioExecution: LetterTestScenarioExecution;
  /** Gets a paginated list of letter tests (Support users only) */
  letterTests: PaginatedLetterTests;
  /** Gets a single medication by ID (Support users only) */
  medication?: Maybe<Medication>;
  /** Gets a single medication-condition association by ID (Support users only) */
  medicationCondition?: Maybe<MedicationCondition>;
  /**
   * Returns all medication-condition pairs with aliases for the combined eligibility search.
   * Applies the same feature-flag gating and coverageFundAppeal filtering as the individual
   * conditionsForEligibility and medicationsForCondition queries.
   */
  medicationConditionPairsForEligibility: Array<MedicationConditionPair>;
  /** Gets a paginated list of medication-condition associations (Support users only) */
  medicationConditions: PaginatedMedicationConditions;
  medicationDashboard?: Maybe<Scalars['String']['output']>;
  /** Gets a paginated list of medications (Support users only) */
  medications: PaginatedMedications;
  /**
   * Returns the medications available for a given condition in the patient eligibility flow.
   * Mirrors the client-side getFilteredMedications: the shared getMedications helper for the
   * given condition, with Wegovy and Zepbound filtered out when coverageFundAppeal is true.
   */
  medicationsForCondition: Array<Scalars['String']['output']>;
  /**
   * Returns the medications available in the provider referral medication dropdown for the
   * authenticated provider user. Lifts the medicationOptions derivation from
   * initial-referral-page.tsx onto the server: provider-name detection and feature-flag evaluation
   * happen here, then the shared getMedicationsForReferral helper produces the same string list
   * the client used to compute locally.
   */
  medicationsForReferral: Array<Scalars['String']['output']>;
  /** Gets a list of paginated payer policy clinical criteria, sorted by payer, medication, then condition. */
  payerPolicyClinicalCriteria: PaginatedPayerPolicyClinicalCriteria;
  /** Gets a single payer policy extraction by ID. */
  payerPolicyExtraction?: Maybe<PayerPolicyExtraction>;
  /** Gets all unique payer names from payer policy extractions. */
  payerPolicyExtractionPayerNames: Array<Scalars['String']['output']>;
  /** Gets a list of paginated payer policy extractions. */
  payerPolicyExtractions: PaginatedPayerPolicyExtraction;
  /** Gets all unique payer names from payer policy clinical criteria. */
  payerPolicyPayerNames: Array<Scalars['String']['output']>;
  /** Gets a paginated list of precedent cases (Support users only) */
  precedentCases: PaginatedPrecedentCases;
  /** Gets the stripe prices for the appeal-letter and cc destination products */
  productPrices: ProductPrices;
  /** Gets the provider information for a provider user's provider. */
  provider?: Maybe<Provider>;
  /** Gets the provider information for a provider user's provider. */
  providerUser?: Maybe<ProviderUser>;
  /** Gets a list of paginated providers, sorted alphabetically by provider name. */
  providers: PaginatedProviders;
  /** Returns the published survey schema for a specific condition */
  publishedSurveySchema?: Maybe<SurveySchema>;
  qrUploadUrl: QrUploadUrlResponse;
  /** Gets a paginated list of referrals for a provider user's provider */
  referrals: PaginatedReferrals;
  /** Gets a single sub-denial reason by ID (Support users only) */
  subDenialReason?: Maybe<SubDenialReason>;
  /** Gets a paginated list of sub-denial reasons (Support users only) */
  subDenialReasons: PaginatedSubDenialReasons;
  /** This will return the extracted information and confirmed info from the denial letter and the insurance card of an appeal */
  uploadInfo: UploadInfo;
};


export type QueryAdverseEventAppealsArgs = {
  endDate: Scalars['Date']['input'];
  medication: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryAdverseEventsArgs = {
  options?: InputMaybe<AdverseEventsInput>;
};


export type QueryAppealDeliverabilityMetricsArgs = {
  dateRange: DeliverabilityDateRange;
};


export type QueryAppealDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppealDepartmentsArgs = {
  options?: InputMaybe<AppealDepartmentsQueryInput>;
};


export type QueryAppealDestinationsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealOverviewArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealPatientArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealPurchaseSummaryArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealStatusArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealStrategiesArgs = {
  options?: InputMaybe<AppealStrategiesQueryInput>;
};


export type QueryAppealStrategyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppealStrategyAuditLogArgs = {
  appealStrategyId: Scalars['ID']['input'];
};


export type QueryAppealsArgs = {
  options?: InputMaybe<AppealsInput>;
};


export type QueryAutocompleteAddressArgs = {
  addressPrefix: Scalars['String']['input'];
};


export type QueryCcDestinationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCcDestinationsArgs = {
  options?: InputMaybe<CcDestinationsQueryInput>;
};


export type QueryClinicalEvidenceArgs = {
  options?: InputMaybe<ClinicalEvidenceQueryInput>;
};


export type QueryConditionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConditionsArgs = {
  options?: InputMaybe<ConditionsQueryInput>;
};


export type QueryConditionsForEligibilityArgs = {
  coverageFundAppeal: Scalars['Boolean']['input'];
};


export type QueryConditionsTreatedByMedicationArgs = {
  medication: Scalars['String']['input'];
};


export type QueryDenialArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryDenialReasonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDenialReasonsArgs = {
  options?: InputMaybe<DenialReasonsQueryInput>;
};


export type QueryDenyingPartyAppealDepartmentArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailMessagesByProviderArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryExpeditedReviewRecommendationForAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryExpeditedReviewRecommendationForInputsArgs = {
  condition: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
};


export type QueryGetAppealByIdArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetAppealDetailSectionArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetAppealOutcomeEventsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetAppealPaymentArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetHelpScoutConversationsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetInsuranceCardExtractionArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetLetterGenerationsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetLetterRevisionsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetLetterRevisionsFullArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetPayerPolicyPresignedUrlArgs = {
  policyBotId: Scalars['ID']['input'];
};


export type QueryGetProviderByIdArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryGetReferringProviderUserArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetSurveySchemaByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHasLegacySurveyAnswersArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryHasSurveySchemaForAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryInReviewClinicalEvidenceArgs = {
  options?: InputMaybe<ClinicalEvidenceQueryInput>;
};


export type QueryIsAppealFreeArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryLetterTestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLetterTestScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLetterTestScenarioExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLetterTestsArgs = {
  options?: InputMaybe<LetterTestsQueryInput>;
};


export type QueryMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationConditionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationConditionPairsForEligibilityArgs = {
  coverageFundAppeal: Scalars['Boolean']['input'];
};


export type QueryMedicationConditionsArgs = {
  options?: InputMaybe<MedicationConditionsQueryInput>;
};


export type QueryMedicationDashboardArgs = {
  medication: Scalars['String']['input'];
};


export type QueryMedicationsArgs = {
  options?: InputMaybe<MedicationsQueryInput>;
};


export type QueryMedicationsForConditionArgs = {
  condition: Scalars['String']['input'];
  coverageFundAppeal: Scalars['Boolean']['input'];
};


export type QueryPayerPolicyClinicalCriteriaArgs = {
  options?: InputMaybe<PayerPolicyClinicalCriteriaInput>;
};


export type QueryPayerPolicyExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayerPolicyExtractionsArgs = {
  options?: InputMaybe<PayerPolicyExtractionInput>;
};


export type QueryPrecedentCasesArgs = {
  options?: InputMaybe<PrecedentCasesQueryInput>;
};


export type QueryProvidersArgs = {
  options?: InputMaybe<ProvidersInput>;
};


export type QueryPublishedSurveySchemaArgs = {
  condition: Scalars['String']['input'];
};


export type QueryQrUploadUrlArgs = {
  token: Scalars['String']['input'];
};


export type QueryReferralsArgs = {
  filter?: InputMaybe<ReferralsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReferralsSortInput>;
};


export type QuerySubDenialReasonArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubDenialReasonsArgs = {
  options?: InputMaybe<SubDenialReasonsQueryInput>;
};


export type QueryUploadInfoArgs = {
  appealId: Scalars['ID']['input'];
};

export enum RecipientType {
  Ag = 'AG',
  AppealDept = 'APPEAL_DEPT',
  Cfpb = 'CFPB',
  Cms = 'CMS',
  Doi = 'DOI',
  Dol = 'DOL',
  Employer = 'EMPLOYER',
  Ftc = 'FTC',
  Gov = 'GOV',
  Hhs = 'HHS',
  Insurer = 'INSURER',
  Opm = 'OPM',
  Politician = 'POLITICIAN',
  StateHhs = 'STATE_HHS',
  UserGenerated = 'USER_GENERATED'
}

export type Referral = {
  __typename?: 'Referral';
  appeal: Appeal;
  patientEmail?: Maybe<Scalars['String']['output']>;
  referralId: Scalars['ID']['output'];
  referringUser?: Maybe<ProviderUser>;
  sponsoringParty?: Maybe<SponsoringParty>;
};

export enum ReferralSortField {
  AppealStatusChangedDate = 'APPEAL_STATUS_CHANGED_DATE',
  ReferralSentDate = 'REFERRAL_SENT_DATE'
}

export type ReferralsFilterInput = {
  appealStatusChangedDateFrom?: InputMaybe<Scalars['Date']['input']>;
  appealStatusChangedDateTo?: InputMaybe<Scalars['Date']['input']>;
  patientDateOfBirth?: InputMaybe<Scalars['String']['input']>;
  patientExternalId?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  referringUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<AppealCurrentStatus>>;
};

export type ReferralsSortInput = {
  direction: SortDirection;
  field: ReferralSortField;
};

export enum RelationshipToPolicyholder {
  Dependent = 'DEPENDENT',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export type ReportAppealStatusInput = {
  denialOverturned?: InputMaybe<Scalars['Boolean']['input']>;
  denialUpheld?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeDeterminedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ReviewGrade {
  Fail = 'FAIL',
  Pass = 'PASS',
  Ungraded = 'UNGRADED'
}

export type ReviewLetterGenerationInput = {
  letterGenerationId: Scalars['ID']['input'];
  reviewGrade: ReviewGrade;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SaveInsuranceInfoInput = {
  denyingParty?: InputMaybe<DenyingParty>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  otherDenyingPartyName?: InputMaybe<Scalars['String']['input']>;
  pharmacyBenefitManager?: InputMaybe<Scalars['String']['input']>;
  planCategory?: InputMaybe<PlanCategory>;
  policyholderFirstName?: InputMaybe<Scalars['String']['input']>;
  policyholderLastName?: InputMaybe<Scalars['String']['input']>;
  relationshipToPolicyholder?: InputMaybe<RelationshipToPolicyholder>;
  rxBin?: InputMaybe<Scalars['String']['input']>;
  rxGroup?: InputMaybe<Scalars['String']['input']>;
  rxMemberId?: InputMaybe<Scalars['String']['input']>;
};

export type SavePatientAndCaregiverInfoOnReferralInput = {
  appealId: Scalars['ID']['input'];
  caregiver?: InputMaybe<CaregiverInfoInput>;
  consentToMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  hasPatientConsent?: InputMaybe<Scalars['Boolean']['input']>;
  patient: PatientInfoInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerMessage?: InputMaybe<Scalars['String']['input']>;
};

export enum SendMethod {
  Fax = 'FAX',
  Mail = 'MAIL'
}

export type SentFax = {
  __typename?: 'SentFax';
  completedTimestamp?: Maybe<Scalars['Date']['output']>;
  errorDetails?: Maybe<Scalars['String']['output']>;
  faxId: Scalars['ID']['output'];
  /** @deprecated Use toFaxNumber instead */
  faxNumber?: Maybe<Scalars['String']['output']>;
  fromFaxNumber: Scalars['String']['output'];
  initiatedTimestamp?: Maybe<Scalars['Date']['output']>;
  sentStatus: FaxSentStatus;
  toFaxNumber: Scalars['String']['output'];
};

export type SentLetter = {
  __typename?: 'SentLetter';
  address: Address;
  addressId: Scalars['ID']['output'];
  currentExpectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  initiatedTimestamp: Scalars['Date']['output'];
  letterId: Scalars['ID']['output'];
  lobStatus: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum Sex {
  DeclineToAnswer = 'DECLINE_TO_ANSWER',
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SponsoringParty {
  Claimable = 'CLAIMABLE',
  Provider = 'PROVIDER'
}

export type SubDenialReason = {
  __typename?: 'SubDenialReason';
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum SubDenialReasonEnum {
  A1CDoesntMeetCriteria = 'A1C_DOESNT_MEET_CRITERIA',
  AbsenceOfSkeletalManifestations = 'ABSENCE_OF_SKELETAL_MANIFESTATIONS',
  AlpNotLowEnough = 'ALP_NOT_LOW_ENOUGH',
  BmiDoesntMeetCriteria = 'BMI_DOESNT_MEET_CRITERIA',
  BowelBiopsyNotPerformed = 'BOWEL_BIOPSY_NOT_PERFORMED',
  ClinicalImprovementNotMet = 'CLINICAL_IMPROVEMENT_NOT_MET',
  DidntLoseEnoughWeight = 'DIDNT_LOSE_ENOUGH_WEIGHT',
  ExerciseOrDietDoesntMeetCriteria = 'EXERCISE_OR_DIET_DOESNT_MEET_CRITERIA',
  GeneticTestingRequired = 'GENETIC_TESTING_REQUIRED',
  HppGeneticTestingNegative = 'HPP_GENETIC_TESTING_NEGATIVE',
  HppGeneticTestingNotPerformed = 'HPP_GENETIC_TESTING_NOT_PERFORMED',
  HppPantherLackOfCurrentSymptoms = 'HPP_PANTHER_LACK_OF_CURRENT_SYMPTOMS',
  HppPantherNormalB6OrUrinePea = 'HPP_PANTHER_NORMAL_B6_OR_URINE_PEA',
  HppPantherNormalOrNoRadiology = 'HPP_PANTHER_NORMAL_OR_NO_RADIOLOGY',
  HppPantherNoB6OrUrinePeaPerformed = 'HPP_PANTHER_NO_B6_OR_URINE_PEA_PERFORMED',
  HppPantherNoDecreaseInB6OrPeaFromBaseline = 'HPP_PANTHER_NO_DECREASE_IN_B6_OR_PEA_FROM_BASELINE',
  HppPantherNoMobilityTestingOrImprovement = 'HPP_PANTHER_NO_MOBILITY_TESTING_OR_IMPROVEMENT',
  HppPantherNoRadiologyPriorToAge_18 = 'HPP_PANTHER_NO_RADIOLOGY_PRIOR_TO_AGE_18',
  InsufficientDocumentationOfPediatricJuvenileOnset = 'INSUFFICIENT_DOCUMENTATION_OF_PEDIATRIC_JUVENILE_ONSET',
  LostTooMuchWeight = 'LOST_TOO_MUCH_WEIGHT',
  MedicationNotConsideredEffective = 'MEDICATION_NOT_CONSIDERED_EFFECTIVE',
  MedicationNotCoveredAtAll = 'MEDICATION_NOT_COVERED_AT_ALL',
  MedicationNotCoveredForMyDiagnosis = 'MEDICATION_NOT_COVERED_FOR_MY_DIAGNOSIS',
  MustTryOtherMedicationsFirst = 'MUST_TRY_OTHER_MEDICATIONS_FIRST',
  ObesityPlanExclusionAlternativeCondition = 'OBESITY_PLAN_EXCLUSION_ALTERNATIVE_CONDITION',
  PositiveSucraidResponseContinuation = 'POSITIVE_SUCRAID_RESPONSE_CONTINUATION',
  SubstrateLevelsNotElevated = 'SUBSTRATE_LEVELS_NOT_ELEVATED',
  SucraseActivityLessThan_10 = 'SUCRASE_ACTIVITY_LESS_THAN_10',
  WeightLossCareNotCoveredAtAll = 'WEIGHT_LOSS_CARE_NOT_COVERED_AT_ALL',
  WeightLossProgramDoesntMeetCriteria = 'WEIGHT_LOSS_PROGRAM_DOESNT_MEET_CRITERIA'
}

export type SubDenialReasonSearchInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type SubDenialReasonsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<SubDenialReasonSearchInput>;
};

export type SupportingDocumentFileUploadDetail = {
  __typename?: 'SupportingDocumentFileUploadDetail';
  downloadUrl: Scalars['String']['output'];
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  uploadToken?: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surveyData: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  id: Scalars['ID']['output'];
  questionText?: Maybe<Scalars['String']['output']>;
  value: Scalars['StringOrStringArray']['output'];
};

export type SurveyAnswerInput = {
  id: Scalars['ID']['input'];
  questionText?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['StringOrStringArray']['input'];
};

export type SurveySchema = {
  __typename?: 'SurveySchema';
  condition: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  schemaData: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type UnpublishSurveySchemaInput = {
  id: Scalars['ID']['input'];
};

export type UpdateAppealDenialReasonsInput = {
  appealId: Scalars['ID']['input'];
  bmiComorbidCriteria?: InputMaybe<Scalars['Float']['input']>;
  bmiObesityCriteria?: InputMaybe<Scalars['Float']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  denialReason: Scalars['String']['input'];
  subDenialReasons: Array<SubDenialReasonEnum>;
};

export type UpdateAppealDepartmentInput = {
  address?: InputMaybe<AppealDepartmentAddressInput>;
  addressCompany?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expeditedFaxNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planCategory?: InputMaybe<PlanCategory>;
  secondaryStandardFaxNumber?: InputMaybe<Scalars['String']['input']>;
  standardFaxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppealPlanCategoryInput = {
  employer?: InputMaybe<EmployerInput>;
  planCategory: PlanCategory;
};

export type UpdateAppealStrategyInput = {
  status?: InputMaybe<AppealStrategyStatus>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCcDestinationInput = {
  address?: InputMaybe<CcDestinationAddressInput>;
  addressCompany?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  denyingPartyParent?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<RecipientType>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicalEvidenceInput = {
  abstract?: InputMaybe<Scalars['String']['input']>;
  citation?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  medication?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateConditionInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isReferrable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDenialReasonInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLetterTestInput = {
  letterTestId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  scenarios: Array<CreateLetterTestScenarioInput>;
};

export type UpdateLetterTestScenarioPersonaInput = {
  letterTestScenarioId: Scalars['ID']['input'];
  persona: Scalars['String']['input'];
};

export type UpdateMedicationInput = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayerPolicyClinicalCriteriaInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  continuationClinicalCriteria?: InputMaybe<Scalars['String']['input']>;
  initialClinicalCriteria?: InputMaybe<Scalars['String']['input']>;
  medication?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderUserInfoInput = {
  firstName: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateSubDenialReasonInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveySchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  schemaData?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadDocumentType {
  DenialLetter = 'DENIAL_LETTER'
}

export type UploadInfo = {
  __typename?: 'UploadInfo';
  appealId: Scalars['ID']['output'];
  insuranceInfo?: Maybe<InsuranceInfo>;
};

export type UploadLink = {
  __typename?: 'UploadLink';
  fileExtension: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UploadUrls = {
  __typename?: 'UploadUrls';
  allFilesUploaded: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  s3Urls: Array<Scalars['String']['output']>;
};

export type UpsertAppealSupportingDocumentResponse = {
  __typename?: 'UpsertAppealSupportingDocumentResponse';
  document: AppealSupportingDocument;
};

export type SidebarAppealOverviewQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type SidebarAppealOverviewQuery = { __typename?: 'Query', appealOverview: { __typename?: 'AppealOverview', appealId: string, medicationName?: string | null, patientProfileSection: { __typename?: 'AppealPatientProfileSectionStatus', status: AppealSectionStatus }, denialDetailsSection: { __typename?: 'AppealDenialDetailsSectionStatus', status: AppealSectionStatus }, insuranceCoverageSection: { __typename?: 'AppealInsuranceCoverageSectionStatus', status: AppealSectionStatus }, surveySection?: { __typename?: 'AppealSurveySectionStatus', status: AppealSectionStatus } | null, supportingDocumentsSection: { __typename?: 'AppealSupportingDocumentsSectionStatus', status: AppealSectionStatus }, generateAndReviewSection: { __typename?: 'AppealGenerateAndReviewSectionStatus', status: AppealSectionStatus }, finalizeAndSubmitSection: { __typename?: 'AppealFinalizeAndSubmitSectionStatus', status: AppealSectionStatus } } };

export type PaymentGateQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type PaymentGateQuery = { __typename?: 'Query', appealStatus?: { __typename?: 'AppealStatus', paymentSuccessful?: boolean | null } | null };

export type AutocompleteAddressQueryVariables = Exact<{
  addressPrefix: Scalars['String']['input'];
}>;


export type AutocompleteAddressQuery = { __typename?: 'Query', autocompleteAddress: Array<{ __typename?: 'AddressSuggestion', primaryLine: string, city: string, state: string, zipCode: string }> };

export type SectionLockOverviewQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type SectionLockOverviewQuery = { __typename?: 'Query', appealOverview: { __typename?: 'AppealOverview', appealId: string, surveySection?: { __typename?: 'AppealSurveySectionStatus', status: AppealSectionStatus } | null, finalizeAndSubmitSection: { __typename?: 'AppealFinalizeAndSubmitSectionStatus', status: AppealSectionStatus }, generateAndReviewSection: { __typename?: 'AppealGenerateAndReviewSectionStatus', status: AppealSectionStatus } } };

export type SetupNewUserWithExistingReferralsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SetupNewUserWithExistingReferralsMutation = { __typename?: 'Mutation', setupNewUserWithExistingReferrals?: Array<{ __typename: 'Appeal' }> | null };

export type SubmittedGateQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type SubmittedGateQuery = { __typename?: 'Query', appealStatus?: { __typename?: 'AppealStatus', appealSubmitted?: boolean | null } | null };

export type GetPublishedSurveySchemaQueryVariables = Exact<{
  condition: Scalars['String']['input'];
}>;


export type GetPublishedSurveySchemaQuery = { __typename?: 'Query', publishedSurveySchema?: { __typename?: 'SurveySchema', id: string, condition: string, version: number, schemaData: string, description?: string | null, isPublished: boolean } | null };

export type GetAppealsForMagicLinkUpheldFollowUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppealsForMagicLinkUpheldFollowUpQuery = { __typename?: 'Query', getAppeals: Array<{ __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', denialUpheld?: boolean | null, denialUpheldTimestamp?: string | null } }> };

export type AppealDetailsSectionQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type AppealDetailsSectionQuery = { __typename?: 'Query', getAppealDetailSection?: { __typename?: 'AppealDetailSection', appealId: string, createdTimestamp: any, condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null } | null };

export type AppealOverviewPageQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type AppealOverviewPageQuery = { __typename?: 'Query', isAppealFree: boolean, appealOverview: { __typename?: 'AppealOverview', appealId: string, medicationName?: string | null, condition?: string | null, referral?: { __typename?: 'ProviderReferral', providerName?: string | null } | null, patientProfileSection: { __typename?: 'AppealPatientProfileSectionStatus', status: AppealSectionStatus }, denialDetailsSection: { __typename?: 'AppealDenialDetailsSectionStatus', status: AppealSectionStatus }, insuranceCoverageSection: { __typename?: 'AppealInsuranceCoverageSectionStatus', status: AppealSectionStatus }, surveySection?: { __typename?: 'AppealSurveySectionStatus', status: AppealSectionStatus } | null, supportingDocumentsSection: { __typename?: 'AppealSupportingDocumentsSectionStatus', status: AppealSectionStatus }, generateAndReviewSection: { __typename?: 'AppealGenerateAndReviewSectionStatus', status: AppealSectionStatus }, finalizeAndSubmitSection: { __typename?: 'AppealFinalizeAndSubmitSectionStatus', status: AppealSectionStatus }, appealStatus: { __typename?: 'AppealStatus', paymentSuccessful?: boolean | null, currentStatus?: AppealCurrentStatus | null } }, getAppealDetailSection?: { __typename?: 'AppealDetailSection', createdTimestamp: any } | null };

export type GetSurveyAnswersQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetSurveyAnswersQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', isExpeditedReview?: boolean | null, surveyAnswers: Array<{ __typename?: 'SurveyAnswer', id: string, value: any }>, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null, subDenialReasons: Array<SubDenialReasonEnum>, denyingParty?: DenyingParty | null, otherDenyingPartyName?: string | null } | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string, pronouns?: Pronouns | null, sex?: Sex | null } | null, patientInsurance?: { __typename?: 'PatientInsurance', pbmName?: string | null, providerName?: string | null } | null } | null };

export type UpdateSurveyAnswersMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  surveyAnswers: Array<SurveyAnswerInput> | SurveyAnswerInput;
}>;


export type UpdateSurveyAnswersMutation = { __typename?: 'Mutation', updateSurveyAnswers?: boolean | null };

export type SaveIsExpeditedReviewMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  isExpeditedReview: Scalars['Boolean']['input'];
}>;


export type SaveIsExpeditedReviewMutation = { __typename?: 'Mutation', saveIsExpeditedReview?: boolean | null };

export type UpdateAppealDenialReasonsMutationVariables = Exact<{
  input: UpdateAppealDenialReasonsInput;
}>;


export type UpdateAppealDenialReasonsMutation = { __typename?: 'Mutation', updateAppealDenialReasons: { __typename?: 'Appeal', appealId: string, denial?: { __typename?: 'Denial', denialReason?: string | null, subDenialReasons: Array<SubDenialReasonEnum>, bmiObesityCriteria?: number | null, bmiComorbidCriteria?: number | null, condition?: string | null } | null } };

export type GetDenialReasonPageDataQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetDenialReasonPageDataQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', isCoverageFund: boolean, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null, subDenialReasons: Array<SubDenialReasonEnum>, bmiObesityCriteria?: number | null, bmiComorbidCriteria?: number | null } | null } | null, appealOverview: { __typename?: 'AppealOverview', surveySection?: { __typename?: 'AppealSurveySectionStatus', status: AppealSectionStatus } | null } };

export type SaveOtherAppealSituationsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  otherAppealSituations: OtherAppealSituationsInput;
}>;


export type SaveOtherAppealSituationsMutation = { __typename?: 'Mutation', saveOtherAppealSituations?: boolean | null };

export type GetEligibilityDataQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetEligibilityDataQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', isCoverageFund: boolean, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null, subDenialReasons: Array<SubDenialReasonEnum>, bmiObesityCriteria?: number | null, bmiComorbidCriteria?: number | null } | null } | null };

export type SaveAppealDeptDataMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  appealDeptData: AppealDestinationInput;
}>;


export type SaveAppealDeptDataMutation = { __typename?: 'Mutation', saveAppealDeptData?: boolean | null };

export type GetAppealDestinationQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealDestinationQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', originalAppealId?: string | null, destination?: { __typename?: 'AppealDestination', name: string, company?: string | null, fax?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null, patientInsurance?: { __typename?: 'PatientInsurance', planCategory?: PlanCategory | null } | null } | null, denyingPartyAppealDepartment?: { __typename?: 'DenyingPartyAppealDepartment', name?: string | null, company?: string | null, fax?: string | null, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } } | null };

export type AppealDestinationsQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type AppealDestinationsQuery = { __typename?: 'Query', isAppealFree: boolean, appealDestinations: Array<{ __typename?: 'AppealDestination', recipientType: RecipientType, name: string, company?: string | null, email?: string | null, fax?: string | null, phone?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null }>, getAppealById?: { __typename?: 'Appeal', couponId?: string | null, ccDestinations: Array<{ __typename?: 'CcDestination', sendMethod: SendMethod, destination: { __typename?: 'AppealDestination', recipientType: RecipientType, name: string, company?: string | null, email?: string | null, fax?: string | null, phone?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } }>, patientInsurance?: { __typename?: 'PatientInsurance', planCategory?: PlanCategory | null, employer?: { __typename?: 'Employer', employerName?: string | null, recipientName?: string | null, fax?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null } | null } | null, productPrices: { __typename?: 'ProductPrices', ccDestinationPrice: number } };

export type SaveCcDestinationsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  destinations: Array<CcDestinationInput> | CcDestinationInput;
}>;


export type SaveCcDestinationsMutation = { __typename?: 'Mutation', saveCCDestinations?: boolean | null };

export type SaveInsuranceEmployerMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  employerData: EmployerInput;
}>;


export type SaveInsuranceEmployerMutation = { __typename?: 'Mutation', saveInsuranceEmployer?: boolean | null };

export type GetEmployerAddressQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetEmployerAddressQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', originalAppealId?: string | null, patientInsurance?: { __typename?: 'PatientInsurance', employer?: { __typename?: 'Employer', employerName?: string | null, recipientName?: string | null, fax?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null } | null } | null };

export type SavePatientDataMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  patientData: PatientDataInput;
}>;


export type SavePatientDataMutation = { __typename?: 'Mutation', savePatientData?: boolean | null };

export type SaveCaregiverDataFromFinalizeMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  caregiver: CaregiverInput;
}>;


export type SaveCaregiverDataFromFinalizeMutation = { __typename?: 'Mutation', saveCaregiverData: boolean };

export type GetPatientDataQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetPatientDataQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any, phone?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null, caregiver?: { __typename?: 'Caregiver', firstName: string, lastName: string, dateOfBirth?: any | null, relationship: CaregiverRelationship } | null } | null };

export type GetPurchaseDisplayDataQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetPurchaseDisplayDataQuery = { __typename?: 'Query', isAppealFree: boolean, appealPurchaseSummary?: { __typename?: 'AppealPurchaseSummary', destination?: { __typename?: 'AppealDestination', recipientType: RecipientType, name: string, company?: string | null, email?: string | null, fax?: string | null, phone?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null, ccDestinations: Array<{ __typename?: 'CcDestination', sendMethod: SendMethod, destination: { __typename?: 'AppealDestination', recipientType: RecipientType, name: string, company?: string | null, email?: string | null, fax?: string | null, phone?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } }> } | null, getAppealPayment?: { __typename?: 'Payment', paymentMethodType: string, amountSubtotal: number, amountTax: number, amountDiscount: number, shippingAmount: number, amountTotal: number, appealPrice: number, destinationPrice: number, destinationQuantity: number, paymentTimestamp: any } | null };

export type GetAppealPollingStatusQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealPollingStatusQuery = { __typename?: 'Query', appealStatus?: { __typename?: 'AppealStatus', paymentSuccessful?: boolean | null, pdfGenerated?: boolean | null, pdfGenerationFailed?: boolean | null, appealSubmittedTimestamp?: string | null } | null };

export type CreateCheckoutSessionFromPrePaymentMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  useModularRoutes?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCheckoutSessionFromPrePaymentMutation = { __typename?: 'Mutation', createCheckoutSession: string };

export type IsAppealFreeForPrePaymentQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type IsAppealFreeForPrePaymentQuery = { __typename?: 'Query', isAppealFree: boolean };

export type SendAppealMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type SendAppealMutation = { __typename?: 'Mutation', sendAppeal: boolean };

export type GetReadyToSubmitAppealInfoQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetReadyToSubmitAppealInfoQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', denial?: { __typename?: 'Denial', medicationBrandName?: string | null } | null, patientInsurance?: { __typename?: 'PatientInsurance', planCategory?: PlanCategory | null } | null } | null };

export type GenerateAppealPdfMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GenerateAppealPdfMutation = { __typename?: 'Mutation', generateAppealPdf: string };

export type CreateAppealPacketIssueFromReviewMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  appealLetterIssue: AppealLetterIssueInput;
}>;


export type CreateAppealPacketIssueFromReviewMutation = { __typename?: 'Mutation', createAppealPacketIssue?: boolean | null };

export type GenerateLetterAppealOverviewQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GenerateLetterAppealOverviewQuery = { __typename?: 'Query', appealOverview: { __typename?: 'AppealOverview', appealId: string, patientProfileSection: { __typename?: 'AppealPatientProfileSectionStatus', status: AppealSectionStatus }, denialDetailsSection: { __typename?: 'AppealDenialDetailsSectionStatus', status: AppealSectionStatus }, insuranceCoverageSection: { __typename?: 'AppealInsuranceCoverageSectionStatus', status: AppealSectionStatus }, surveySection?: { __typename?: 'AppealSurveySectionStatus', status: AppealSectionStatus } | null, appealStatus: { __typename?: 'AppealStatus', appealLetterGenerated?: boolean | null, letterGenerationFailed?: boolean | null, currentStatus?: AppealCurrentStatus | null } } };

export type GetAppealLetterStatusQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealLetterStatusQuery = { __typename?: 'Query', appealStatus?: { __typename?: 'AppealStatus', appealLetterGenerated?: boolean | null, letterGenerationFailed?: boolean | null, currentStatus?: AppealCurrentStatus | null } | null };

export type GetLetterBodyQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetLetterBodyQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealLetter?: { __typename?: 'AppealLetter', body: string, references: string } | null, status: { __typename?: 'AppealStatus', letterOfMedicalNecessityUploaded?: boolean | null }, denial?: { __typename?: 'Denial', condition?: string | null } | null } | null };

export type CreateAppealLetterIssueMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  appealLetterIssue: AppealLetterIssueInput;
}>;


export type CreateAppealLetterIssueMutation = { __typename?: 'Mutation', createAppealLetterIssue?: boolean | null };

export type LinkAppealStagingToUserMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type LinkAppealStagingToUserMutation = { __typename?: 'Mutation', linkAppealStagingToUser: { __typename?: 'LinkAppealStagingToUserResult', appealId: string } };

export type GetInsuranceInfoQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetInsuranceInfoQuery = { __typename?: 'Query', uploadInfo: { __typename?: 'UploadInfo', insuranceInfo?: { __typename?: 'InsuranceInfo', confirmed?: { __typename?: 'InsuranceInfoDetails', insuranceProvider?: string | null, planCategory?: PlanCategory | null, employer?: string | null, memberNumber?: string | null, groupNumber?: string | null, pbmName?: string | null, rxBinNumber?: string | null, rxGroupNumber?: string | null, rxMemberId?: string | null } | null } | null }, getAppealById?: { __typename?: 'Appeal', denial?: { __typename?: 'Denial', denialReason?: string | null, medicationBrandName?: string | null } | null } | null };

export type GetInsuranceCardExtractionForTestQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetInsuranceCardExtractionForTestQuery = { __typename?: 'Query', getInsuranceCardExtraction?: { __typename?: 'InsuranceCardExtraction', id: string, extractedData: { __typename?: 'InsuranceCardExtractionResult', insuranceProvider?: string | null, planCategory?: string | null, memberNumber?: string | null, groupNumber?: string | null, rxBin?: string | null, rxGroup?: string | null, rxMemberId?: string | null, employer?: string | null } } | null };

export type GetInsuranceCardExtractionQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetInsuranceCardExtractionQuery = { __typename?: 'Query', getInsuranceCardExtraction?: { __typename?: 'InsuranceCardExtraction', id: string, extractedData: { __typename?: 'InsuranceCardExtractionResult', insuranceProvider?: string | null, planCategory?: string | null, memberNumber?: string | null, groupNumber?: string | null, rxBin?: string | null, rxGroup?: string | null, rxMemberId?: string | null, employer?: string | null } } | null };

export type SaveDenyingPartyMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  denyingParty: DenyingPartyInput;
}>;


export type SaveDenyingPartyMutation = { __typename?: 'Mutation', saveDenyingParty?: boolean | null };

export type UploadInfoQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type UploadInfoQuery = { __typename?: 'Query', uploadInfo: { __typename?: 'UploadInfo', appealId: string, insuranceInfo?: { __typename?: 'InsuranceInfo', confirmed?: { __typename?: 'InsuranceInfoDetails', insuranceProvider?: string | null, planCategory?: PlanCategory | null, employer?: string | null, memberNumber?: string | null, groupNumber?: string | null, pbmName?: string | null, rxBinNumber?: string | null, rxGroupNumber?: string | null, rxMemberId?: string | null, denyingParty?: DenyingParty | null, otherDenyingPartyName?: string | null, isPatientEnrollee?: boolean | null, enrolleeFirstName?: string | null, enrolleeLastName?: string | null, otherAppealSituations?: Array<OtherAppealSituations> | null } | null } | null }, getAppealById?: { __typename?: 'Appeal', denial?: { __typename?: 'Denial', denialReason?: string | null, medicationBrandName?: string | null } | null } | null };

export type ConfirmDetailsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  confirmDetails: ConfirmDetailsInput;
}>;


export type ConfirmDetailsMutation = { __typename?: 'Mutation', confirmDetails?: boolean | null };

export type SavePrimaryEnrolleeMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  primaryEnrollee: PrimaryEnrolleeInput;
}>;


export type SavePrimaryEnrolleeMutation = { __typename?: 'Mutation', savePrimaryEnrollee?: boolean | null };

export type GenerateInsuranceCardUploadUrlsMyAppealsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: GenerateSupportingDocumentUploadInput;
}>;


export type GenerateInsuranceCardUploadUrlsMyAppealsMutation = { __typename?: 'Mutation', generateSupportingDocumentUploadUrls: { __typename?: 'GenerateSupportingDocumentUploadUrlsResponse', documentId: string, fileUploadDetails: Array<{ __typename?: 'SupportingDocumentFileUploadDetail', fileId: string, fileName: string, uploadUrl: string, uploadToken?: string | null, downloadUrl: string }> } };

export type UpsertInsuranceCardDocumentMyAppealsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: PersistSupportingDocumentInput;
}>;


export type UpsertInsuranceCardDocumentMyAppealsMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', document: { __typename?: 'AppealSupportingDocument', documentId: string } } };

export type ExtractInsuranceCardDataMyAppealsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type ExtractInsuranceCardDataMyAppealsMutation = { __typename?: 'Mutation', extractInsuranceCardData: { __typename?: 'InsuranceCardExtraction', id: string, extractionResult: ExtractionResult, extractedData: { __typename?: 'InsuranceCardExtractionResult', insuranceProvider?: string | null, planCategory?: string | null, memberNumber?: string | null, groupNumber?: string | null, rxBin?: string | null, rxGroup?: string | null, rxMemberId?: string | null, employer?: string | null } } };

export type GetPatientInfoDataQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetPatientInfoDataQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any, sex?: Sex | null, pronouns?: Pronouns | null, phone?: string | null, hasTransactionalSmsConsent: boolean, hasMarketingSmsConsent: boolean, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null, caregiver?: { __typename?: 'Caregiver', firstName: string, lastName: string, dateOfBirth?: any | null, relationship: CaregiverRelationship } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null } | null } | null };

export type SaveCaregiverDataMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  caregiver: CaregiverInput;
}>;


export type SaveCaregiverDataMutation = { __typename?: 'Mutation', saveCaregiverData: boolean };

export type SaveDenialUpheldHasClaimsFileMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  hasReceivedClaimsFile: Scalars['Boolean']['input'];
}>;


export type SaveDenialUpheldHasClaimsFileMutation = { __typename?: 'Mutation', saveDenialUpheldReceivedClaimsFile?: boolean | null };

export type SaveDenialUpheldDenialReasonMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  denialReason: Scalars['String']['input'];
}>;


export type SaveDenialUpheldDenialReasonMutation = { __typename?: 'Mutation', saveDenialUpheldDenialReason?: boolean | null };

export type GenerateDenialUpheldUploadUrlsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: GenerateSupportingDocumentUploadInput;
}>;


export type GenerateDenialUpheldUploadUrlsMutation = { __typename?: 'Mutation', generateSupportingDocumentUploadUrls: { __typename?: 'GenerateSupportingDocumentUploadUrlsResponse', documentId: string, fileUploadDetails: Array<{ __typename?: 'SupportingDocumentFileUploadDetail', fileId: string, fileName: string, uploadUrl: string }> } };

export type UpsertDenialUpheldDocumentMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: PersistSupportingDocumentInput;
}>;


export type UpsertDenialUpheldDocumentMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', document: { __typename?: 'AppealSupportingDocument', documentId: string } } };

export type GetAppealForReportAnAppealQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealForReportAnAppealQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', originalAppealId?: string | null, status: { __typename?: 'AppealStatus', appealSubmitted?: boolean | null, appealSubmittedTimestamp?: string | null, denialOverturned?: boolean | null, denialUpheld?: boolean | null, secondAppealRequested?: boolean | null }, denial?: { __typename?: 'Denial', medicationBrandName?: string | null, denialReason?: string | null, condition?: string | null, denyingParty?: DenyingParty | null } | null, patientInsurance?: { __typename?: 'PatientInsurance', pbmName?: string | null } | null } | null };

export type ReportAppealStatusWithAppealOutcomeMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  status: ReportAppealStatusInput;
  source?: InputMaybe<AppealOutcomeSource>;
}>;


export type ReportAppealStatusWithAppealOutcomeMutation = { __typename?: 'Mutation', reportAppealOutcomeStatus?: boolean | null };

export type RequestSecondAppealMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type RequestSecondAppealMutation = { __typename?: 'Mutation', requestSecondAppeal: boolean };

export type GenerateApprovalLetterUploadUrlsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: GenerateSupportingDocumentUploadInput;
}>;


export type GenerateApprovalLetterUploadUrlsMutation = { __typename?: 'Mutation', generateSupportingDocumentUploadUrls: { __typename?: 'GenerateSupportingDocumentUploadUrlsResponse', documentId: string, fileUploadDetails: Array<{ __typename?: 'SupportingDocumentFileUploadDetail', fileId: string, fileName: string, uploadUrl: string }> } };

export type UpsertApprovalLetterDocumentMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: PersistSupportingDocumentInput;
}>;


export type UpsertApprovalLetterDocumentMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', document: { __typename?: 'AppealSupportingDocument', documentId: string } } };

export type GetConditionForRoutingQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetConditionForRoutingQuery = { __typename?: 'Query', denial: { __typename?: 'Denial', condition?: string | null } };

export type GetPublishedSchemaForRoutingQueryVariables = Exact<{
  condition: Scalars['String']['input'];
}>;


export type GetPublishedSchemaForRoutingQuery = { __typename?: 'Query', publishedSurveySchema?: { __typename?: 'SurveySchema', id: string } | null };

export type GetHasLegacySurveyAnswersForRoutingQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetHasLegacySurveyAnswersForRoutingQuery = { __typename?: 'Query', hasLegacySurveyAnswers: boolean };

export type GetAppealWithSurveyJsAnswersQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealWithSurveyJsAnswersQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, surveyJsAnswers: string, isExpeditedReview?: boolean | null, caregiver?: { __typename?: 'Caregiver', firstName: string } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null, subDenialReasons: Array<SubDenialReasonEnum> } | null } | null };

export type UpdateSurveyJsAnswersMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  surveyJsAnswers: Scalars['String']['input'];
  surveySchemaId: Scalars['ID']['input'];
}>;


export type UpdateSurveyJsAnswersMutation = { __typename?: 'Mutation', updateSurveyJsAnswers?: boolean | null };

export type CreateAppealStagingMutationVariables = Exact<{
  input: CreateAppealStagingInput;
}>;


export type CreateAppealStagingMutation = { __typename?: 'Mutation', createAppealStaging: { __typename?: 'CreateAppealStagingResult', appealId: string } };

export type ConditionsForEligibilityQueryVariables = Exact<{
  coverageFundAppeal: Scalars['Boolean']['input'];
}>;


export type ConditionsForEligibilityQuery = { __typename?: 'Query', conditionsForEligibility: Array<string> };

export type MedicationsForConditionQueryVariables = Exact<{
  condition: Scalars['String']['input'];
  coverageFundAppeal: Scalars['Boolean']['input'];
}>;


export type MedicationsForConditionQuery = { __typename?: 'Query', medicationsForCondition: Array<string> };

export type MedicationConditionPairsForEligibilityQueryVariables = Exact<{
  coverageFundAppeal: Scalars['Boolean']['input'];
}>;


export type MedicationConditionPairsForEligibilityQuery = { __typename?: 'Query', medicationConditionPairsForEligibility: Array<{ __typename?: 'MedicationConditionPair', medication: string, condition: string, medicationAliases: Array<string>, conditionAliases: Array<string> }> };

export type GetAppealsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppealsQuery = { __typename?: 'Query', getAppeals: Array<{ __typename?: 'Appeal', appealId: string, originalAppealId?: string | null, userId?: string | null, createdTimestamp: any, updatedTimestamp: any, isExpeditedReview?: boolean | null, sentFaxes: Array<{ __typename?: 'SentFax', faxId: string, toFaxNumber: string, fromFaxNumber: string, sentStatus: FaxSentStatus, initiatedTimestamp?: any | null, completedTimestamp?: any | null, errorDetails?: string | null }>, sentLetters: Array<{ __typename?: 'SentLetter', letterId: string, recipientName: string, addressId: string, lobStatus: string, expectedDeliveryDate?: any | null, trackingNumber?: string | null, initiatedTimestamp: any, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } }>, ccDestinations: Array<{ __typename?: 'CcDestination', sendMethod: SendMethod, destination: { __typename?: 'AppealDestination', name: string, company?: string | null, addressId?: string | null, fax?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } }>, destination?: { __typename?: 'AppealDestination', name: string, company?: string | null, addressId?: string | null, fax?: string | null, address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, daysToAppeal?: number | null, denialDate?: any | null, denialReason?: string | null, denyingParty?: DenyingParty | null } | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any, address?: { __typename?: 'Address', addressLine1: string, city: string, state: string, zip: string } | null } | null, patientInsurance?: { __typename?: 'PatientInsurance', memberNumber?: string | null, planCategory?: PlanCategory | null, providerName?: string | null, pbmName?: string | null } | null, status: { __typename?: 'AppealStatus', currentStatus?: AppealCurrentStatus | null, initiated?: boolean | null, denialLetterUpload?: boolean | null, denialLetterUploadSkipped?: boolean | null, insuranceCardUpload?: boolean | null, insuranceCardUploadSkipped?: boolean | null, informationConfirmed?: boolean | null, patientSavedExperience?: boolean | null, appealLetterGenerated?: boolean | null, appealSubmittedTimestamp?: string | null, paymentSuccessful?: boolean | null, denialOverturned?: boolean | null, denialUpheld?: boolean | null, issueOutstanding?: boolean | null, closed?: boolean | null, secondAppealRequested?: boolean | null } }> };

export type RequestSecondAppealFromAppealsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type RequestSecondAppealFromAppealsMutation = { __typename?: 'Mutation', requestSecondAppeal: boolean };

export type DownloadAppealLetterLinkMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type DownloadAppealLetterLinkMutation = { __typename?: 'Mutation', downloadAppealLetterLink?: string | null };

export type StartAppealGenerationMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type StartAppealGenerationMutation = { __typename?: 'Mutation', startGenerateAppeal?: boolean | null };

export type GetSupportingDocumentsForAppealQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetSupportingDocumentsForAppealQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', denial?: { __typename?: 'Denial', condition?: string | null } | null, supportingDocuments?: Array<{ __typename?: 'AppealSupportingDocument', documentId: string, documentType: AppealSupportingDocumentType, otherDocumentTypeName?: string | null, uploadedBy: AppealSupportingDocumentUploadedBy, files: Array<{ __typename?: 'AppealSupportingDocumentFile', fileId: string, fileName: string, fileType: AppealSupportingDocumentFileType, url: string, pageCount: number }> }> | null } | null };

export type GenerateSupportingDocumentUploadUrlsMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: GenerateSupportingDocumentUploadInput;
}>;


export type GenerateSupportingDocumentUploadUrlsMutation = { __typename?: 'Mutation', generateSupportingDocumentUploadUrls: { __typename?: 'GenerateSupportingDocumentUploadUrlsResponse', documentId: string, fileUploadDetails: Array<{ __typename?: 'SupportingDocumentFileUploadDetail', fileId: string, fileName: string, uploadUrl: string, downloadUrl: string, uploadToken?: string | null }> } };

export type UpsertAppealSupportingDocumentMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: PersistSupportingDocumentInput;
}>;


export type UpsertAppealSupportingDocumentMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', document: { __typename?: 'AppealSupportingDocument', documentId: string, documentType: AppealSupportingDocumentType, otherDocumentTypeName?: string | null, uploadedBy: AppealSupportingDocumentUploadedBy, files: Array<{ __typename?: 'AppealSupportingDocumentFile', fileId: string, fileName: string, fileType: AppealSupportingDocumentFileType, url: string, pageCount: number }> } } };

export type DeleteAppealSupportingDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteAppealSupportingDocumentMutation = { __typename?: 'Mutation', deleteAppealSupportingDocument?: boolean | null };

export type UpdateAppealStatusWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  status: AppealOutcomeStatus;
  source?: InputMaybe<AppealOutcomeSource>;
  outcomeDeterminedAt?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateAppealStatusWithTokenMutation = { __typename?: 'Mutation', updateAppealStatusWithToken?: boolean | null };

export type QrUploadUrlQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type QrUploadUrlQuery = { __typename?: 'Query', qrUploadUrl: { __typename?: 'QrUploadUrlResponse', uploadUrl: string } };

export type ExpeditedReviewRecommendationForAppealQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type ExpeditedReviewRecommendationForAppealQuery = { __typename?: 'Query', expeditedReviewRecommendationForAppeal: ExpeditedReviewRecommendation };

export type SkipUploadMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  uploadType: UploadDocumentType;
  uploadSkipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SkipUploadMutation = { __typename?: 'Mutation', skipUpload?: boolean | null };


export const SidebarAppealOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SidebarAppealOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"medicationName"}},{"kind":"Field","name":{"kind":"Name","value":"patientProfileSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denialDetailsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCoverageSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportingDocumentsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generateAndReviewSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalizeAndSubmitSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SidebarAppealOverviewQuery, SidebarAppealOverviewQueryVariables>;
export const PaymentGateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentGate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}}]}}]}}]} as unknown as DocumentNode<PaymentGateQuery, PaymentGateQueryVariables>;
export const AutocompleteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressPrefix"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressPrefix"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressPrefix"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryLine"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]} as unknown as DocumentNode<AutocompleteAddressQuery, AutocompleteAddressQueryVariables>;
export const SectionLockOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SectionLockOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalizeAndSubmitSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generateAndReviewSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SectionLockOverviewQuery, SectionLockOverviewQueryVariables>;
export const SetupNewUserWithExistingReferralsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetupNewUserWithExistingReferrals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupNewUserWithExistingReferrals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SetupNewUserWithExistingReferralsMutation, SetupNewUserWithExistingReferralsMutationVariables>;
export const SubmittedGateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmittedGate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealSubmitted"}}]}}]}}]} as unknown as DocumentNode<SubmittedGateQuery, SubmittedGateQueryVariables>;
export const GetPublishedSurveySchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishedSurveySchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedSurveySchema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schemaData"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]} as unknown as DocumentNode<GetPublishedSurveySchemaQuery, GetPublishedSurveySchemaQueryVariables>;
export const GetAppealsForMagicLinkUpheldFollowUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealsForMagicLinkUpheldFollowUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheldTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealsForMagicLinkUpheldFollowUpQuery, GetAppealsForMagicLinkUpheldFollowUpQueryVariables>;
export const AppealDetailsSectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppealDetailsSection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealDetailSection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}}]}}]}}]} as unknown as DocumentNode<AppealDetailsSectionQuery, AppealDetailsSectionQueryVariables>;
export const AppealOverviewPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppealOverviewPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"medicationName"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"referral"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientProfileSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denialDetailsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCoverageSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportingDocumentsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generateAndReviewSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalizeAndSubmitSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"currentStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAppealDetailSection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAppealFree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<AppealOverviewPageQuery, AppealOverviewPageQueryVariables>;
export const GetSurveyAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isExpeditedReview"}},{"kind":"Field","name":{"kind":"Name","value":"surveyAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}},{"kind":"Field","name":{"kind":"Name","value":"denyingParty"}},{"kind":"Field","name":{"kind":"Name","value":"otherDenyingPartyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pbmName"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyAnswersQuery, GetSurveyAnswersQueryVariables>;
export const UpdateSurveyAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveyAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyAnswers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyAnswerInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveyAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyAnswers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyAnswers"}}}]}]}}]} as unknown as DocumentNode<UpdateSurveyAnswersMutation, UpdateSurveyAnswersMutationVariables>;
export const SaveIsExpeditedReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveIsExpeditedReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isExpeditedReview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveIsExpeditedReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isExpeditedReview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isExpeditedReview"}}}]}]}}]} as unknown as DocumentNode<SaveIsExpeditedReviewMutation, SaveIsExpeditedReviewMutationVariables>;
export const UpdateAppealDenialReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAppealDenialReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAppealDenialReasonsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAppealDenialReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}},{"kind":"Field","name":{"kind":"Name","value":"bmiObesityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"bmiComorbidCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAppealDenialReasonsMutation, UpdateAppealDenialReasonsMutationVariables>;
export const GetDenialReasonPageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDenialReasonPageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}},{"kind":"Field","name":{"kind":"Name","value":"bmiObesityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"bmiComorbidCriteria"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCoverageFund"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appealOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetDenialReasonPageDataQuery, GetDenialReasonPageDataQueryVariables>;
export const SaveOtherAppealSituationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveOtherAppealSituations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAppealSituations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OtherAppealSituationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveOtherAppealSituations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherAppealSituations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAppealSituations"}}}]}]}}]} as unknown as DocumentNode<SaveOtherAppealSituationsMutation, SaveOtherAppealSituationsMutationVariables>;
export const GetEligibilityDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEligibilityData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}},{"kind":"Field","name":{"kind":"Name","value":"bmiObesityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"bmiComorbidCriteria"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCoverageFund"}}]}}]}}]} as unknown as DocumentNode<GetEligibilityDataQuery, GetEligibilityDataQueryVariables>;
export const SaveAppealDeptDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveAppealDeptData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealDeptData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealDestinationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveAppealDeptData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appealDeptData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealDeptData"}}}]}]}}]} as unknown as DocumentNode<SaveAppealDeptDataMutation, SaveAppealDeptDataMutationVariables>;
export const GetAppealDestinationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealDestination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalAppealId"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCategory"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"denyingPartyAppealDepartment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}}]}}]} as unknown as DocumentNode<GetAppealDestinationQuery, GetAppealDestinationQueryVariables>;
export const AppealDestinationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppealDestinations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAppealFree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"appealDestinations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"ccDestinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMethod"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"employer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employerName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ccDestinationPrice"}}]}}]}}]} as unknown as DocumentNode<AppealDestinationsQuery, AppealDestinationsQueryVariables>;
export const SaveCcDestinationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCCDestinations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CcDestinationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCCDestinations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinations"}}}]}]}}]} as unknown as DocumentNode<SaveCcDestinationsMutation, SaveCcDestinationsMutationVariables>;
export const SaveInsuranceEmployerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveInsuranceEmployer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employerData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveInsuranceEmployer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"employer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employerData"}}}]}]}}]} as unknown as DocumentNode<SaveInsuranceEmployerMutation, SaveInsuranceEmployerMutationVariables>;
export const GetEmployerAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmployerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalAppealId"}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employerName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployerAddressQuery, GetEmployerAddressQueryVariables>;
export const SavePatientDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePatientData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePatientData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientData"}}}]}]}}]} as unknown as DocumentNode<SavePatientDataMutation, SavePatientDataMutationVariables>;
export const SaveCaregiverDataFromFinalizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCaregiverDataFromFinalize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiver"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCaregiverData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiver"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiver"}}}]}]}}]} as unknown as DocumentNode<SaveCaregiverDataFromFinalizeMutation, SaveCaregiverDataFromFinalizeMutationVariables>;
export const GetPatientDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatientData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}}]}}]}}]} as unknown as DocumentNode<GetPatientDataQuery, GetPatientDataQueryVariables>;
export const GetPurchaseDisplayDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPurchaseDisplayData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAppealFree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"appealPurchaseSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ccDestinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMethod"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAppealPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"amountSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"amountTotal"}},{"kind":"Field","name":{"kind":"Name","value":"appealPrice"}},{"kind":"Field","name":{"kind":"Name","value":"destinationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"destinationQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetPurchaseDisplayDataQuery, GetPurchaseDisplayDataQueryVariables>;
export const GetAppealPollingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealPollingStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"pdfGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"pdfGenerationFailed"}},{"kind":"Field","name":{"kind":"Name","value":"appealSubmittedTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetAppealPollingStatusQuery, GetAppealPollingStatusQueryVariables>;
export const CreateCheckoutSessionFromPrePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCheckoutSessionFromPrePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useModularRoutes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useModularRoutes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useModularRoutes"}}}]}]}}]} as unknown as DocumentNode<CreateCheckoutSessionFromPrePaymentMutation, CreateCheckoutSessionFromPrePaymentMutationVariables>;
export const IsAppealFreeForPrePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsAppealFreeForPrePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAppealFree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<IsAppealFreeForPrePaymentQuery, IsAppealFreeForPrePaymentQueryVariables>;
export const SendAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAppeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<SendAppealMutation, SendAppealMutationVariables>;
export const GetReadyToSubmitAppealInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReadyToSubmitAppealInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCategory"}}]}}]}}]}}]} as unknown as DocumentNode<GetReadyToSubmitAppealInfoQuery, GetReadyToSubmitAppealInfoQueryVariables>;
export const GenerateAppealPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateAppealPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAppealPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<GenerateAppealPdfMutation, GenerateAppealPdfMutationVariables>;
export const CreateAppealPacketIssueFromReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppealPacketIssueFromReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealLetterIssue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealLetterIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAppealPacketIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appealLetterIssue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealLetterIssue"}}}]}]}}]} as unknown as DocumentNode<CreateAppealPacketIssueFromReviewMutation, CreateAppealPacketIssueFromReviewMutationVariables>;
export const GenerateLetterAppealOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateLetterAppealOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"patientProfileSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denialDetailsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCoverageSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveySection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealLetterGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"letterGenerationFailed"}},{"kind":"Field","name":{"kind":"Name","value":"currentStatus"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateLetterAppealOverviewQuery, GenerateLetterAppealOverviewQueryVariables>;
export const GetAppealLetterStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealLetterStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealLetterGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"letterGenerationFailed"}},{"kind":"Field","name":{"kind":"Name","value":"currentStatus"}}]}}]}}]} as unknown as DocumentNode<GetAppealLetterStatusQuery, GetAppealLetterStatusQueryVariables>;
export const GetLetterBodyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLetterBody"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealLetter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"letterOfMedicalNecessityUploaded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}}]}}]}}]}}]} as unknown as DocumentNode<GetLetterBodyQuery, GetLetterBodyQueryVariables>;
export const CreateAppealLetterIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppealLetterIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealLetterIssue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealLetterIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAppealLetterIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appealLetterIssue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealLetterIssue"}}}]}]}}]} as unknown as DocumentNode<CreateAppealLetterIssueMutation, CreateAppealLetterIssueMutationVariables>;
export const LinkAppealStagingToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkAppealStagingToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkAppealStagingToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}}]}}]}}]} as unknown as DocumentNode<LinkAppealStagingToUserMutation, LinkAppealStagingToUserMutationVariables>;
export const GetInsuranceInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceProvider"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pbmName"}},{"kind":"Field","name":{"kind":"Name","value":"rxBinNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxMemberId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceInfoQuery, GetInsuranceInfoQueryVariables>;
export const GetInsuranceCardExtractionForTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceCardExtractionForTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInsuranceCardExtraction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceProvider"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxBin"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroup"}},{"kind":"Field","name":{"kind":"Name","value":"rxMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceCardExtractionForTestQuery, GetInsuranceCardExtractionForTestQueryVariables>;
export const GetInsuranceCardExtractionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceCardExtraction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInsuranceCardExtraction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceProvider"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxBin"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroup"}},{"kind":"Field","name":{"kind":"Name","value":"rxMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceCardExtractionQuery, GetInsuranceCardExtractionQueryVariables>;
export const SaveDenyingPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveDenyingParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"denyingParty"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DenyingPartyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveDenyingParty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"denyingParty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"denyingParty"}}}]}]}}]} as unknown as DocumentNode<SaveDenyingPartyMutation, SaveDenyingPartyMutationVariables>;
export const UploadInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UploadInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceProvider"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pbmName"}},{"kind":"Field","name":{"kind":"Name","value":"rxBinNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"denyingParty"}},{"kind":"Field","name":{"kind":"Name","value":"otherDenyingPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"isPatientEnrollee"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeLastName"}},{"kind":"Field","name":{"kind":"Name","value":"otherAppealSituations"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appealId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}}]}}]}}]} as unknown as DocumentNode<UploadInfoQuery, UploadInfoQueryVariables>;
export const ConfirmDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"confirmDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmDetails"}}}]}]}}]} as unknown as DocumentNode<ConfirmDetailsMutation, ConfirmDetailsMutationVariables>;
export const SavePrimaryEnrolleeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePrimaryEnrollee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primaryEnrollee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrimaryEnrolleeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePrimaryEnrollee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"primaryEnrollee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primaryEnrollee"}}}]}]}}]} as unknown as DocumentNode<SavePrimaryEnrolleeMutation, SavePrimaryEnrolleeMutationVariables>;
export const GenerateInsuranceCardUploadUrlsMyAppealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateInsuranceCardUploadUrlsMyAppeals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSupportingDocumentUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSupportingDocumentUploadUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUploadDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"uploadToken"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateInsuranceCardUploadUrlsMyAppealsMutation, GenerateInsuranceCardUploadUrlsMyAppealsMutationVariables>;
export const UpsertInsuranceCardDocumentMyAppealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertInsuranceCardDocumentMyAppeals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertInsuranceCardDocumentMyAppealsMutation, UpsertInsuranceCardDocumentMyAppealsMutationVariables>;
export const ExtractInsuranceCardDataMyAppealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExtractInsuranceCardDataMyAppeals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extractInsuranceCardData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractionResult"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceProvider"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxBin"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroup"}},{"kind":"Field","name":{"kind":"Name","value":"rxMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}}]}}]}}]}}]} as unknown as DocumentNode<ExtractInsuranceCardDataMyAppealsMutation, ExtractInsuranceCardDataMyAppealsMutationVariables>;
export const GetPatientInfoDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatientInfoData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasTransactionalSmsConsent"}},{"kind":"Field","name":{"kind":"Name","value":"hasMarketingSmsConsent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}}]}}]}}]} as unknown as DocumentNode<GetPatientInfoDataQuery, GetPatientInfoDataQueryVariables>;
export const SaveCaregiverDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCaregiverData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiver"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCaregiverData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiver"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiver"}}}]}]}}]} as unknown as DocumentNode<SaveCaregiverDataMutation, SaveCaregiverDataMutationVariables>;
export const SaveDenialUpheldHasClaimsFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveDenialUpheldHasClaimsFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasReceivedClaimsFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveDenialUpheldReceivedClaimsFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasReceivedClaimsFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasReceivedClaimsFile"}}}]}]}}]} as unknown as DocumentNode<SaveDenialUpheldHasClaimsFileMutation, SaveDenialUpheldHasClaimsFileMutationVariables>;
export const SaveDenialUpheldDenialReasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveDenialUpheldDenialReason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"denialReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveDenialUpheldDenialReason"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"denialReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"denialReason"}}}]}]}}]} as unknown as DocumentNode<SaveDenialUpheldDenialReasonMutation, SaveDenialUpheldDenialReasonMutationVariables>;
export const GenerateDenialUpheldUploadUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateDenialUpheldUploadUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSupportingDocumentUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSupportingDocumentUploadUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUploadDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateDenialUpheldUploadUrlsMutation, GenerateDenialUpheldUploadUrlsMutationVariables>;
export const UpsertDenialUpheldDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertDenialUpheldDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertDenialUpheldDocumentMutation, UpsertDenialUpheldDocumentMutationVariables>;
export const GetAppealForReportAnAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealForReportAnAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalAppealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"appealSubmittedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"denialOverturned"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"secondAppealRequested"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"denyingParty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pbmName"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealForReportAnAppealQuery, GetAppealForReportAnAppealQueryVariables>;
export const ReportAppealStatusWithAppealOutcomeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportAppealStatusWithAppealOutcome"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportAppealStatusInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealOutcomeSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportAppealOutcomeStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}]}]}}]} as unknown as DocumentNode<ReportAppealStatusWithAppealOutcomeMutation, ReportAppealStatusWithAppealOutcomeMutationVariables>;
export const RequestSecondAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestSecondAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestSecondAppeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<RequestSecondAppealMutation, RequestSecondAppealMutationVariables>;
export const GenerateApprovalLetterUploadUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateApprovalLetterUploadUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSupportingDocumentUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSupportingDocumentUploadUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUploadDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateApprovalLetterUploadUrlsMutation, GenerateApprovalLetterUploadUrlsMutationVariables>;
export const UpsertApprovalLetterDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertApprovalLetterDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertApprovalLetterDocumentMutation, UpsertApprovalLetterDocumentMutationVariables>;
export const GetConditionForRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConditionForRouting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}}]}}]}}]} as unknown as DocumentNode<GetConditionForRoutingQuery, GetConditionForRoutingQueryVariables>;
export const GetPublishedSchemaForRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishedSchemaForRouting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedSurveySchema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetPublishedSchemaForRoutingQuery, GetPublishedSchemaForRoutingQueryVariables>;
export const GetHasLegacySurveyAnswersForRoutingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHasLegacySurveyAnswersForRouting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasLegacySurveyAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<GetHasLegacySurveyAnswersForRoutingQuery, GetHasLegacySurveyAnswersForRoutingQueryVariables>;
export const GetAppealWithSurveyJsAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealWithSurveyJsAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"surveyJsAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"isExpeditedReview"}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealWithSurveyJsAnswersQuery, GetAppealWithSurveyJsAnswersQueryVariables>;
export const UpdateSurveyJsAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveyJsAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyJsAnswers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveySchemaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveyJsAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyJsAnswers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyJsAnswers"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveySchemaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveySchemaId"}}}]}]}}]} as unknown as DocumentNode<UpdateSurveyJsAnswersMutation, UpdateSurveyJsAnswersMutationVariables>;
export const CreateAppealStagingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppealStaging"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAppealStagingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAppealStaging"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}}]}}]}}]} as unknown as DocumentNode<CreateAppealStagingMutation, CreateAppealStagingMutationVariables>;
export const ConditionsForEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConditionsForEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditionsForEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"coverageFundAppeal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}}}]}]}}]} as unknown as DocumentNode<ConditionsForEligibilityQuery, ConditionsForEligibilityQueryVariables>;
export const MedicationsForConditionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MedicationsForCondition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationsForCondition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverageFundAppeal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}}}]}]}}]} as unknown as DocumentNode<MedicationsForConditionQuery, MedicationsForConditionQueryVariables>;
export const MedicationConditionPairsForEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MedicationConditionPairsForEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationConditionPairsForEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"coverageFundAppeal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageFundAppeal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medication"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationAliases"}},{"kind":"Field","name":{"kind":"Name","value":"conditionAliases"}}]}}]}}]} as unknown as DocumentNode<MedicationConditionPairsForEligibilityQuery, MedicationConditionPairsForEligibilityQueryVariables>;
export const GetAppealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"originalAppealId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"updatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"sentFaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faxId"}},{"kind":"Field","name":{"kind":"Name","value":"toFaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fromFaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentLetters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"letterId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientName"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lobStatus"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ccDestinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMethod"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"daysToAppeal"}},{"kind":"Field","name":{"kind":"Name","value":"denialDate"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"denyingParty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"pbmName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isExpeditedReview"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"initiated"}},{"kind":"Field","name":{"kind":"Name","value":"denialLetterUpload"}},{"kind":"Field","name":{"kind":"Name","value":"denialLetterUploadSkipped"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUpload"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUploadSkipped"}},{"kind":"Field","name":{"kind":"Name","value":"informationConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"patientSavedExperience"}},{"kind":"Field","name":{"kind":"Name","value":"appealLetterGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"appealSubmittedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"denialOverturned"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"issueOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"denialOverturned"}},{"kind":"Field","name":{"kind":"Name","value":"secondAppealRequested"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealsQuery, GetAppealsQueryVariables>;
export const RequestSecondAppealFromAppealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestSecondAppealFromAppeals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestSecondAppeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<RequestSecondAppealFromAppealsMutation, RequestSecondAppealFromAppealsMutationVariables>;
export const DownloadAppealLetterLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadAppealLetterLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadAppealLetterLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<DownloadAppealLetterLinkMutation, DownloadAppealLetterLinkMutationVariables>;
export const StartAppealGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartAppealGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startGenerateAppeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<StartAppealGenerationMutation, StartAppealGenerationMutationVariables>;
export const GetSupportingDocumentsForAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportingDocumentsForAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportingDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"otherDocumentTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSupportingDocumentsForAppealQuery, GetSupportingDocumentsForAppealQueryVariables>;
export const GenerateSupportingDocumentUploadUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateSupportingDocumentUploadUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSupportingDocumentUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSupportingDocumentUploadUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUploadDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"uploadToken"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateSupportingDocumentUploadUrlsMutation, GenerateSupportingDocumentUploadUrlsMutationVariables>;
export const UpsertAppealSupportingDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAppealSupportingDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"otherDocumentTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertAppealSupportingDocumentMutation, UpsertAppealSupportingDocumentMutationVariables>;
export const DeleteAppealSupportingDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAppealSupportingDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}]}}]} as unknown as DocumentNode<DeleteAppealSupportingDocumentMutation, DeleteAppealSupportingDocumentMutationVariables>;
export const UpdateAppealStatusWithTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAppealStatusWithToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealOutcomeStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealOutcomeSource"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outcomeDeterminedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAppealStatusWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"outcomeDeterminedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outcomeDeterminedAt"}}}]}]}}]} as unknown as DocumentNode<UpdateAppealStatusWithTokenMutation, UpdateAppealStatusWithTokenMutationVariables>;
export const QrUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QrUploadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qrUploadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]} as unknown as DocumentNode<QrUploadUrlQuery, QrUploadUrlQueryVariables>;
export const ExpeditedReviewRecommendationForAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpeditedReviewRecommendationForAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expeditedReviewRecommendationForAppeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<ExpeditedReviewRecommendationForAppealQuery, ExpeditedReviewRecommendationForAppealQueryVariables>;
export const SkipUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SkipUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadDocumentType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadSkipped"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skipUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadType"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadSkipped"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadSkipped"}}}]}]}}]} as unknown as DocumentNode<SkipUploadMutation, SkipUploadMutationVariables>;
export type ActiveSupportItemKeySpecifier = ('appealId' | 'appealStatus' | 'condition' | 'helpScoutConversationId' | 'helpScoutCreatedAt' | 'helpScoutStatus' | 'helpScoutSubject' | 'medication' | 'patientName' | ActiveSupportItemKeySpecifier)[];
export type ActiveSupportItemFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	helpScoutConversationId?: FieldPolicy<any> | FieldReadFunction<any>,
	helpScoutCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	helpScoutStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	helpScoutSubject?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	patientName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('addressLine1' | 'addressLine2' | 'city' | 'state' | 'zip' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressSuggestionKeySpecifier = ('city' | 'primaryLine' | 'state' | 'zipCode' | AddressSuggestionKeySpecifier)[];
export type AddressSuggestionFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLine?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	zipCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdverseEventKeySpecifier = ('adverseEvent' | 'adverseEventId' | 'appealId' | 'channel' | 'condition' | 'createdTimestamp' | 'medication' | 'reportingUserId' | 'sanofiId' | 'updatedTimestamp' | AdverseEventKeySpecifier)[];
export type AdverseEventFieldPolicy = {
	adverseEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	adverseEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	sanofiId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdverseEventAppealResultKeySpecifier = ('appealId' | 'email' | 'patientName' | AdverseEventAppealResultKeySpecifier)[];
export type AdverseEventAppealResultFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	patientName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealKeySpecifier = ('appealId' | 'appealLetter' | 'appealType' | 'caregiver' | 'ccDestinations' | 'couponId' | 'createdTimestamp' | 'denial' | 'destination' | 'formattedSurveyAnswers' | 'isCoverageFund' | 'isExpeditedReview' | 'letterGeneration' | 'originalAppealId' | 'patient' | 'patientInsurance' | 'referral' | 'secondAppealId' | 'sentFaxes' | 'sentLetters' | 'status' | 'supportingDocuments' | 'surveyAnswers' | 'surveyId' | 'surveyJsAnswers' | 'updatedTimestamp' | 'userEmail' | 'userId' | AppealKeySpecifier)[];
export type AppealFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealLetter?: FieldPolicy<any> | FieldReadFunction<any>,
	appealType?: FieldPolicy<any> | FieldReadFunction<any>,
	caregiver?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	couponId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	denial?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedSurveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	isCoverageFund?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpeditedReview?: FieldPolicy<any> | FieldReadFunction<any>,
	letterGeneration?: FieldPolicy<any> | FieldReadFunction<any>,
	originalAppealId?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	patientInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	referral?: FieldPolicy<any> | FieldReadFunction<any>,
	secondAppealId?: FieldPolicy<any> | FieldReadFunction<any>,
	sentFaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	sentLetters?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supportingDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyId?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyJsAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDeliverabilityMetricsKeySpecifier = ('dateRange' | 'kpis' | 'payerHealth' | 'stuckLetters' | 'worstCcDestinations' | 'worstFaxNumbers' | AppealDeliverabilityMetricsKeySpecifier)[];
export type AppealDeliverabilityMetricsFieldPolicy = {
	dateRange?: FieldPolicy<any> | FieldReadFunction<any>,
	kpis?: FieldPolicy<any> | FieldReadFunction<any>,
	payerHealth?: FieldPolicy<any> | FieldReadFunction<any>,
	stuckLetters?: FieldPolicy<any> | FieldReadFunction<any>,
	worstCcDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	worstFaxNumbers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDenialDetailsSectionStatusKeySpecifier = ('status' | AppealDenialDetailsSectionStatusKeySpecifier)[];
export type AppealDenialDetailsSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDepartmentRecordKeySpecifier = ('address' | 'addressCompany' | 'addressName' | 'createdAt' | 'denyingPartyName' | 'email' | 'expeditedFaxNumber' | 'id' | 'phoneNumber' | 'planCategory' | 'secondaryStandardFaxNumber' | 'standardFaxNumber' | 'updatedAt' | AppealDepartmentRecordKeySpecifier)[];
export type AppealDepartmentRecordFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	addressName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingPartyName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	expeditedFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryStandardFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	standardFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDestinationKeySpecifier = ('address' | 'addressId' | 'company' | 'email' | 'fax' | 'name' | 'phone' | 'recipientType' | AppealDestinationKeySpecifier)[];
export type AppealDestinationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDetailSectionKeySpecifier = ('appealId' | 'condition' | 'createdTimestamp' | 'denialReason' | 'medicationBrandName' | AppealDetailSectionKeySpecifier)[];
export type AppealDetailSectionFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealFinalizeAndSubmitSectionStatusKeySpecifier = ('status' | AppealFinalizeAndSubmitSectionStatusKeySpecifier)[];
export type AppealFinalizeAndSubmitSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealGenerateAndReviewSectionStatusKeySpecifier = ('status' | AppealGenerateAndReviewSectionStatusKeySpecifier)[];
export type AppealGenerateAndReviewSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealInsuranceCoverageSectionStatusKeySpecifier = ('status' | AppealInsuranceCoverageSectionStatusKeySpecifier)[];
export type AppealInsuranceCoverageSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealLetterKeySpecifier = ('body' | 'references' | AppealLetterKeySpecifier)[];
export type AppealLetterFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	references?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealOutcomeEventKeySpecifier = ('actorEmail' | 'actorUserType' | 'eventTimestamp' | 'eventType' | 'id' | 'source' | 'status' | AppealOutcomeEventKeySpecifier)[];
export type AppealOutcomeEventFieldPolicy = {
	actorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	actorUserType?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealOverviewKeySpecifier = ('appealId' | 'appealStatus' | 'condition' | 'denialDetailsSection' | 'finalizeAndSubmitSection' | 'generateAndReviewSection' | 'insuranceCoverageSection' | 'medicationName' | 'patientProfileSection' | 'referral' | 'supportingDocumentsSection' | 'surveySection' | AppealOverviewKeySpecifier)[];
export type AppealOverviewFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	denialDetailsSection?: FieldPolicy<any> | FieldReadFunction<any>,
	finalizeAndSubmitSection?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAndReviewSection?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCoverageSection?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationName?: FieldPolicy<any> | FieldReadFunction<any>,
	patientProfileSection?: FieldPolicy<any> | FieldReadFunction<any>,
	referral?: FieldPolicy<any> | FieldReadFunction<any>,
	supportingDocumentsSection?: FieldPolicy<any> | FieldReadFunction<any>,
	surveySection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealPatientProfileSectionStatusKeySpecifier = ('status' | AppealPatientProfileSectionStatusKeySpecifier)[];
export type AppealPatientProfileSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealPurchaseSummaryKeySpecifier = ('ccDestinations' | 'destination' | 'medicationBrandName' | 'planCategory' | 'referralId' | 'referringProviderType' | AppealPurchaseSummaryKeySpecifier)[];
export type AppealPurchaseSummaryFieldPolicy = {
	ccDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>,
	referringProviderType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealStatusKeySpecifier = ('appealLetterGenerated' | 'appealSubmitted' | 'appealSubmittedTimestamp' | 'closed' | 'currentStatus' | 'denialLetterExtracted' | 'denialLetterExtractionFailed' | 'denialLetterUpload' | 'denialLetterUploadSkipped' | 'denialOverturned' | 'denialOverturnedTimestamp' | 'denialUpheld' | 'denialUpheldTimestamp' | 'informationConfirmed' | 'initiated' | 'insuranceCardExtracted' | 'insuranceCardExtractionFailed' | 'insuranceCardUpload' | 'insuranceCardUploadSkipped' | 'issueOutstanding' | 'letterGenerationFailed' | 'letterOfMedicalNecessityUploaded' | 'outcomeDeterminedAt' | 'patientSavedExperience' | 'paymentFailed' | 'paymentSuccessful' | 'pdfGenerated' | 'pdfGenerationFailed' | 'referred' | 'secondAppealRequested' | 'secondAppealRequestedTimestamp' | 'updatedTimestamp' | AppealStatusKeySpecifier)[];
export type AppealStatusFieldPolicy = {
	appealLetterGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	appealSubmitted?: FieldPolicy<any> | FieldReadFunction<any>,
	appealSubmittedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	currentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterExtracted?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterExtractionFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterUploadSkipped?: FieldPolicy<any> | FieldReadFunction<any>,
	denialOverturned?: FieldPolicy<any> | FieldReadFunction<any>,
	denialOverturnedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	denialUpheld?: FieldPolicy<any> | FieldReadFunction<any>,
	denialUpheldTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	informationConfirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	initiated?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardExtracted?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardExtractionFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardUploadSkipped?: FieldPolicy<any> | FieldReadFunction<any>,
	issueOutstanding?: FieldPolicy<any> | FieldReadFunction<any>,
	letterGenerationFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	letterOfMedicalNecessityUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	outcomeDeterminedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	patientSavedExperience?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSuccessful?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfGenerationFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	referred?: FieldPolicy<any> | FieldReadFunction<any>,
	secondAppealRequested?: FieldPolicy<any> | FieldReadFunction<any>,
	secondAppealRequestedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealStrategyKeySpecifier = ('createdAt' | 'id' | 'status' | 'strategy' | 'tags' | 'updatedAt' | AppealStrategyKeySpecifier)[];
export type AppealStrategyFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealStrategyAuditEntryKeySpecifier = ('createdAt' | 'eventType' | 'id' | 'performedByEmail' | 'previousStatus' | 'previousStrategy' | 'previousTags' | 'status' | 'strategy' | 'tags' | AppealStrategyAuditEntryKeySpecifier)[];
export type AppealStrategyAuditEntryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	performedByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	previousStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	previousStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	previousTags?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSupportingDocumentKeySpecifier = ('documentId' | 'documentType' | 'files' | 'isIncludedInAppeal' | 'otherDocumentTypeName' | 'uploadedBy' | AppealSupportingDocumentKeySpecifier)[];
export type AppealSupportingDocumentFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncludedInAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDocumentTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSupportingDocumentFileKeySpecifier = ('fileId' | 'fileName' | 'fileType' | 'pageCount' | 'url' | AppealSupportingDocumentFileKeySpecifier)[];
export type AppealSupportingDocumentFileFieldPolicy = {
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileType?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSupportingDocumentsSectionStatusKeySpecifier = ('status' | AppealSupportingDocumentsSectionStatusKeySpecifier)[];
export type AppealSupportingDocumentsSectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSurveySectionStatusKeySpecifier = ('status' | AppealSurveySectionStatusKeySpecifier)[];
export type AppealSurveySectionStatusFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaregiverKeySpecifier = ('dateOfBirth' | 'firstName' | 'lastName' | 'relationship' | CaregiverKeySpecifier)[];
export type CaregiverFieldPolicy = {
	dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcDestinationKeySpecifier = ('destination' | 'sendMethod' | CcDestinationKeySpecifier)[];
export type CcDestinationFieldPolicy = {
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcDestinationRecordKeySpecifier = ('address' | 'addressCompany' | 'addressName' | 'createdAt' | 'denyingPartyParent' | 'email' | 'faxNumber' | 'id' | 'phoneNumber' | 'recipientType' | 'stateCode' | 'updatedAt' | CcDestinationRecordKeySpecifier)[];
export type CcDestinationRecordFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	addressName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingPartyParent?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	faxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientType?: FieldPolicy<any> | FieldReadFunction<any>,
	stateCode?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatGptResponseKeySpecifier = ('message' | 'usage' | ChatGptResponseKeySpecifier)[];
export type ChatGptResponseFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatGptUsageKeySpecifier = ('completionTokens' | 'promptTokens' | 'totalTokens' | ChatGptUsageKeySpecifier)[];
export type ChatGptUsageFieldPolicy = {
	completionTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	promptTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTokens?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClinicalEvidenceKeySpecifier = ('abstract' | 'citation' | 'condition' | 'id' | 'medication' | 'tags' | ClinicalEvidenceKeySpecifier)[];
export type ClinicalEvidenceFieldPolicy = {
	abstract?: FieldPolicy<any> | FieldReadFunction<any>,
	citation?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionKeySpecifier = ('abbreviation' | 'aliases' | 'createdAt' | 'displayName' | 'id' | 'isReferrable' | 'name' | 'updatedAt' | ConditionKeySpecifier)[];
export type ConditionFieldPolicy = {
	abbreviation?: FieldPolicy<any> | FieldReadFunction<any>,
	aliases?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isReferrable?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAppealStagingResultKeySpecifier = ('appealId' | CreateAppealStagingResultKeySpecifier)[];
export type CreateAppealStagingResultFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverabilityCcDestinationRowKeySpecifier = ('destinationName' | 'failureCount' | 'sendMethod' | 'successCount' | 'successRate' | 'totalSends' | DeliverabilityCcDestinationRowKeySpecifier)[];
export type DeliverabilityCcDestinationRowFieldPolicy = {
	destinationName?: FieldPolicy<any> | FieldReadFunction<any>,
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSends?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverabilityFaxNumberRowKeySpecifier = ('failureCount' | 'inFlightCount' | 'recipientCompany' | 'recipientName' | 'successCount' | 'successRate' | 'toFaxNumber' | 'totalSends' | DeliverabilityFaxNumberRowKeySpecifier)[];
export type DeliverabilityFaxNumberRowFieldPolicy = {
	failureCount?: FieldPolicy<any> | FieldReadFunction<any>,
	inFlightCount?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>,
	successCount?: FieldPolicy<any> | FieldReadFunction<any>,
	successRate?: FieldPolicy<any> | FieldReadFunction<any>,
	toFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSends?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverabilityKpisKeySpecifier = ('faxAttempts' | 'faxFailedWithFallback' | 'faxFailures' | 'faxFallbackRate' | 'faxInFlight' | 'faxSuccessRate' | 'faxSuccesses' | 'letterAttempts' | 'letterDelivered' | 'letterDeliveredRate' | 'letterReroutedOrInternational' | 'letterReturnedToSender' | 'letterReturnedToSenderRate' | 'letterTerminal' | 'totalAppealsSent' | DeliverabilityKpisKeySpecifier)[];
export type DeliverabilityKpisFieldPolicy = {
	faxAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	faxFailedWithFallback?: FieldPolicy<any> | FieldReadFunction<any>,
	faxFailures?: FieldPolicy<any> | FieldReadFunction<any>,
	faxFallbackRate?: FieldPolicy<any> | FieldReadFunction<any>,
	faxInFlight?: FieldPolicy<any> | FieldReadFunction<any>,
	faxSuccessRate?: FieldPolicy<any> | FieldReadFunction<any>,
	faxSuccesses?: FieldPolicy<any> | FieldReadFunction<any>,
	letterAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	letterDelivered?: FieldPolicy<any> | FieldReadFunction<any>,
	letterDeliveredRate?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReroutedOrInternational?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReturnedToSender?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReturnedToSenderRate?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTerminal?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAppealsSent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverabilityPayerRowKeySpecifier = ('destinationCompany' | 'faxAttempts' | 'faxSuccessRate' | 'letterAttempts' | 'letterDeliveredRate' | 'totalAppeals' | DeliverabilityPayerRowKeySpecifier)[];
export type DeliverabilityPayerRowFieldPolicy = {
	destinationCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	faxAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	faxSuccessRate?: FieldPolicy<any> | FieldReadFunction<any>,
	letterAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	letterDeliveredRate?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAppeals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliverabilityStuckLetterRowKeySpecifier = ('appealId' | 'daysSinceInitiated' | 'expectedDeliveryDate' | 'initiatedTimestamp' | 'letterId' | 'lobExpectedDeliveryDate' | 'lobStatus' | 'recipientName' | DeliverabilityStuckLetterRowKeySpecifier)[];
export type DeliverabilityStuckLetterRowFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	daysSinceInitiated?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	letterId?: FieldPolicy<any> | FieldReadFunction<any>,
	lobExpectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialKeySpecifier = ('bmiComorbidCriteria' | 'bmiObesityCriteria' | 'claimId' | 'condition' | 'daysToAppeal' | 'denialDate' | 'denialReason' | 'denyingParty' | 'medicationBrandName' | 'medicationGenericName' | 'otherAppealSituations' | 'otherDenyingPartyName' | 'subDenialReasons' | DenialKeySpecifier)[];
export type DenialFieldPolicy = {
	bmiComorbidCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	bmiObesityCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	claimId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	denialDate?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationGenericName?: FieldPolicy<any> | FieldReadFunction<any>,
	otherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDenyingPartyName?: FieldPolicy<any> | FieldReadFunction<any>,
	subDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialLetterKeySpecifier = ('confirmed' | 'extracted' | 's3Urls' | DenialLetterKeySpecifier)[];
export type DenialLetterFieldPolicy = {
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	extracted?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialLetterInfoKeySpecifier = ('daysToAppeal' | 'denialDate' | 'denialReason' | 'disease' | 'medicationBrandName' | 'medicationGenericName' | DenialLetterInfoKeySpecifier)[];
export type DenialLetterInfoFieldPolicy = {
	daysToAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	denialDate?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	disease?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationGenericName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialReasonRecordKeySpecifier = ('createdAt' | 'displayName' | 'id' | 'isUniversal' | 'name' | 'updatedAt' | DenialReasonRecordKeySpecifier)[];
export type DenialReasonRecordFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isUniversal?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenyingPartyAppealDepartmentKeySpecifier = ('address' | 'company' | 'fax' | 'name' | DenyingPartyAppealDepartmentKeySpecifier)[];
export type DenyingPartyAppealDepartmentFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailMessageKeySpecifier = ('body' | 'createdAt' | 'eventType' | 'id' | 'providerId' | 'subject' | 'updatedAt' | EmailMessageKeySpecifier)[];
export type EmailMessageFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmployerKeySpecifier = ('address' | 'employerName' | 'fax' | 'recipientName' | EmployerKeySpecifier)[];
export type EmployerFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	employerName?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EvaluatorInfoKeySpecifier = ('datasetName' | 'displayName' | 'evalName' | 'scoreName' | EvaluatorInfoKeySpecifier)[];
export type EvaluatorInfoFieldPolicy = {
	datasetName?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	evalName?: FieldPolicy<any> | FieldReadFunction<any>,
	scoreName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GatherClinicalEvidenceResultKeySpecifier = ('papersInserted' | GatherClinicalEvidenceResultKeySpecifier)[];
export type GatherClinicalEvidenceResultFieldPolicy = {
	papersInserted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateLetterTestPersonasResultKeySpecifier = ('scenarioCount' | 'skippedCount' | GenerateLetterTestPersonasResultKeySpecifier)[];
export type GenerateLetterTestPersonasResultFieldPolicy = {
	scenarioCount?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateLettersForLetterTestResultKeySpecifier = ('executionCount' | GenerateLettersForLetterTestResultKeySpecifier)[];
export type GenerateLettersForLetterTestResultFieldPolicy = {
	executionCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateSupportingDocumentUploadUrlsResponseKeySpecifier = ('documentId' | 'fileUploadDetails' | GenerateSupportingDocumentUploadUrlsResponseKeySpecifier)[];
export type GenerateSupportingDocumentUploadUrlsResponseFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploadDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeneratedAppealStrategyKeySpecifier = ('reasoning' | 'strategy' | 'suggestedTags' | GeneratedAppealStrategyKeySpecifier)[];
export type GeneratedAppealStrategyFieldPolicy = {
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedTags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HelpScoutConversationKeySpecifier = ('createdAt' | 'id' | 'status' | 'subject' | 'threads' | HelpScoutConversationKeySpecifier)[];
export type HelpScoutConversationFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	threads?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HelpScoutThreadKeySpecifier = ('author' | 'body' | 'createdAt' | 'type' | HelpScoutThreadKeySpecifier)[];
export type HelpScoutThreadFieldPolicy = {
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HistoryQuestionKeySpecifier = ('answer' | 'question' | HistoryQuestionKeySpecifier)[];
export type HistoryQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InReviewClinicalEvidenceKeySpecifier = ('abstract' | 'ageGroup' | 'citation' | 'condition' | 'conditionIndication' | 'dosageRegimen' | 'drugMedicine' | 'evidenceType' | 'fundingDetails' | 'fundingSource' | 'id' | 'journalImpactFactor' | 'journalName' | 'labelAbstract' | 'medication' | 'numberOfCitations' | 'populationRegion' | 'publicationYear' | 'result' | 'resultDescription' | 'sampleSize' | 'sexStudied' | 'specialPopulations' | 'studyDesign' | 'tldr' | 'trialPhase' | InReviewClinicalEvidenceKeySpecifier)[];
export type InReviewClinicalEvidenceFieldPolicy = {
	abstract?: FieldPolicy<any> | FieldReadFunction<any>,
	ageGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	citation?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionIndication?: FieldPolicy<any> | FieldReadFunction<any>,
	dosageRegimen?: FieldPolicy<any> | FieldReadFunction<any>,
	drugMedicine?: FieldPolicy<any> | FieldReadFunction<any>,
	evidenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	fundingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	fundingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	journalImpactFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	journalName?: FieldPolicy<any> | FieldReadFunction<any>,
	labelAbstract?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfCitations?: FieldPolicy<any> | FieldReadFunction<any>,
	populationRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	publicationYear?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	resultDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleSize?: FieldPolicy<any> | FieldReadFunction<any>,
	sexStudied?: FieldPolicy<any> | FieldReadFunction<any>,
	specialPopulations?: FieldPolicy<any> | FieldReadFunction<any>,
	studyDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	tldr?: FieldPolicy<any> | FieldReadFunction<any>,
	trialPhase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InitialReferralDataKeySpecifier = ('appealId' | 'condition' | 'denialReason' | 'medication' | InitialReferralDataKeySpecifier)[];
export type InitialReferralDataFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceCardExtractionKeySpecifier = ('appealId' | 'createdAt' | 'extractedData' | 'extractionResult' | 'id' | 'updatedAt' | InsuranceCardExtractionKeySpecifier)[];
export type InsuranceCardExtractionFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	extractedData?: FieldPolicy<any> | FieldReadFunction<any>,
	extractionResult?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceCardExtractionResultKeySpecifier = ('employer' | 'groupNumber' | 'insuranceProvider' | 'memberNumber' | 'planCategory' | 'rxBin' | 'rxGroup' | 'rxMemberId' | InsuranceCardExtractionResultKeySpecifier)[];
export type InsuranceCardExtractionResultFieldPolicy = {
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	groupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	memberNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	rxBin?: FieldPolicy<any> | FieldReadFunction<any>,
	rxGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	rxMemberId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceInfoKeySpecifier = ('confirmed' | InsuranceInfoKeySpecifier)[];
export type InsuranceInfoFieldPolicy = {
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceInfoDetailsKeySpecifier = ('birthDate' | 'claimId' | 'denyingParty' | 'employer' | 'enrolleeFirstName' | 'enrolleeLastName' | 'groupNumber' | 'insuranceProvider' | 'insuranceType' | 'isPatientEnrollee' | 'memberNumber' | 'otherAppealSituations' | 'otherDenyingPartyName' | 'pbmName' | 'planCategory' | 'rxBinNumber' | 'rxGroupNumber' | 'rxMemberId' | 'state' | InsuranceInfoDetailsKeySpecifier)[];
export type InsuranceInfoDetailsFieldPolicy = {
	birthDate?: FieldPolicy<any> | FieldReadFunction<any>,
	claimId?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	groupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceType?: FieldPolicy<any> | FieldReadFunction<any>,
	isPatientEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	memberNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	otherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDenyingPartyName?: FieldPolicy<any> | FieldReadFunction<any>,
	pbmName?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	rxBinNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxGroupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterGenerationKeySpecifier = ('appealId' | 'appealLetterGenerationId' | 'createdTimestamp' | 'generationOutput' | 'letterBody' | 'letterReferences' | 'prompt' | 'reviewGrade' | 'reviewNotes' | 'reviewedBySupportUserEmail' | 'trace' | 'updatedTimestamp' | LetterGenerationKeySpecifier)[];
export type LetterGenerationFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealLetterGenerationId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	generationOutput?: FieldPolicy<any> | FieldReadFunction<any>,
	letterBody?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewGrade?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewedBySupportUserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	trace?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterOfNecessityInfoKeySpecifier = ('s3Urls' | LetterOfNecessityInfoKeySpecifier)[];
export type LetterOfNecessityInfoFieldPolicy = {
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterRevisionFullKeySpecifier = ('appealLetterRevisionId' | 'comment' | 'createdTimestamp' | 'letterBody' | 'letterReferences' | 'reason' | 'supportUserEmail' | 'supportUserId' | 'updatedTimestamp' | LetterRevisionFullKeySpecifier)[];
export type LetterRevisionFullFieldPolicy = {
	appealLetterRevisionId?: FieldPolicy<any> | FieldReadFunction<any>,
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	letterBody?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterRevisionHistoryKeySpecifier = ('comment' | 'createdTimestamp' | 'reason' | 'supportUserEmail' | 'supportUserId' | LetterRevisionHistoryKeySpecifier)[];
export type LetterRevisionHistoryFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterTestKeySpecifier = ('createdAt' | 'id' | 'name' | 'scenarios' | 'status' | 'updatedAt' | LetterTestKeySpecifier)[];
export type LetterTestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	scenarios?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterTestScenarioKeySpecifier = ('condition' | 'createdAt' | 'denialReason' | 'executions' | 'id' | 'letterTestId' | 'medication' | 'persona' | 'subDenialReasons' | 'updatedAt' | LetterTestScenarioKeySpecifier)[];
export type LetterTestScenarioFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	executions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTestId?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	persona?: FieldPolicy<any> | FieldReadFunction<any>,
	subDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterTestScenarioExecutionKeySpecifier = ('appealId' | 'configuration' | 'createdAt' | 'errorMessage' | 'id' | 'letterGeneration' | 'letterGenerationId' | 'letterTestScenarioId' | 'status' | 'updatedAt' | LetterTestScenarioExecutionKeySpecifier)[];
export type LetterTestScenarioExecutionFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	configuration?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	letterGeneration?: FieldPolicy<any> | FieldReadFunction<any>,
	letterGenerationId?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTestScenarioId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterTestScenarioExecutionConfigurationKeySpecifier = ('model' | 'singleStep' | 'skipPatientSummary' | 'strategyId' | LetterTestScenarioExecutionConfigurationKeySpecifier)[];
export type LetterTestScenarioExecutionConfigurationFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	singleStep?: FieldPolicy<any> | FieldReadFunction<any>,
	skipPatientSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	strategyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkAppealStagingToUserResultKeySpecifier = ('appealId' | LinkAppealStagingToUserResultKeySpecifier)[];
export type LinkAppealStagingToUserResultFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualAppealSendResponseKeySpecifier = ('error' | 'success' | ManualAppealSendResponseKeySpecifier)[];
export type ManualAppealSendResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicalHistoryKeySpecifier = ('questions' | MedicalHistoryKeySpecifier)[];
export type MedicalHistoryFieldPolicy = {
	questions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicationKeySpecifier = ('aliases' | 'createdAt' | 'displayName' | 'id' | 'name' | 'updatedAt' | MedicationKeySpecifier)[];
export type MedicationFieldPolicy = {
	aliases?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicationConditionKeySpecifier = ('conditionDisplayName' | 'conditionId' | 'conditionName' | 'createdAt' | 'id' | 'isActive' | 'medicationDisplayName' | 'medicationId' | 'medicationName' | MedicationConditionKeySpecifier)[];
export type MedicationConditionFieldPolicy = {
	conditionDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionId?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationId?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicationConditionPairKeySpecifier = ('condition' | 'conditionAliases' | 'medication' | 'medicationAliases' | MedicationConditionPairKeySpecifier)[];
export type MedicationConditionPairFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionAliases?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationAliases?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('UpdateProviderUserRole' | 'addAppealLetterTraceToEvalDataset' | 'addClinicalEvidenceEntry' | 'addNewUserToProvider' | 'addNewUserToProviderByProviderId' | 'approvePayerPolicyExtraction' | 'archiveInReviewEvidence' | 'cloneAppeal' | 'closeAppeal' | 'confirmDetails' | 'createAdverseEvent' | 'createAppealDepartment' | 'createAppealLetterIssue' | 'createAppealPacketIssue' | 'createAppealStaging' | 'createAppealStrategy' | 'createCcDestination' | 'createCheckoutSession' | 'createCondition' | 'createDenialReason' | 'createEmailMessage' | 'createLetterRevision' | 'createLetterTest' | 'createLetterTestScenario' | 'createMedication' | 'createMedicationCondition' | 'createPayerPolicyClinicalCriteria' | 'createPrecedentCase' | 'createProvider' | 'createProviderViaSelfSignUp' | 'createSubDenialReason' | 'createSurveySchema' | 'createSurveySchemaVersion' | 'deleteAppealDepartment' | 'deleteAppealStrategy' | 'deleteAppealSupportingDocument' | 'deleteCcDestination' | 'deleteClinicalEvidence' | 'deleteEmailMessage' | 'deleteLetterTestScenario' | 'deleteMedicationCondition' | 'deletePayerPolicyClinicalCriteria' | 'deletePrecedentCase' | 'downloadAppealLetterLink' | 'downloadBAAFormLink' | 'editSurveySchema' | 'extractInsuranceCardData' | 'gatherClinicalEvidence' | 'generateAppealPdf' | 'generateAppealPdfUploadLink' | 'generateAppealStrategy' | 'generateLetterTestPersonas' | 'generateLettersForLetterTest' | 'generateProviderLetterOfMedicalNecessity' | 'generateSupportingDocumentUploadUrls' | 'initializeReferral' | 'linkAppealStagingToUser' | 'markAppealPdfUploaded' | 'markAppealReadyForReview' | 'previewAppealPdf' | 'publishSurveySchema' | 'removeAppealOutcomeStatus' | 'removeLetterGenerationFromScenario' | 'reportAppealOutcomeStatus' | 'requestSecondAppeal' | 'resolveIssue' | 'reviewLetterGeneration' | 'saveAppealDeptData' | 'saveCCDestinations' | 'saveCaregiverData' | 'saveDenialUpheldDenialReason' | 'saveDenialUpheldReceivedClaimsFile' | 'saveDenyingParty' | 'saveInsuranceEmployer' | 'saveInsuranceInfo' | 'saveIsExpeditedReview' | 'saveOtherAppealSituations' | 'savePatientAndCaregiverInfoOnReferral' | 'savePatientData' | 'savePrimaryEnrollee' | 'saveProviderDefaultReferralMessage' | 'sendAppeal' | 'sendAppealManually' | 'sendChatGptMessage' | 'sendReferralToPatient' | 'setupNewUserWithExistingReferrals' | 'signProviderBusinessAssociateAgreement' | 'skipUpload' | 'startGenerateAppeal' | 'startNextAppeal' | 'toggleAppealSupportingDocumentInclusion' | 'toggleClaimableAppealSponsorship' | 'toggleMedicationConditionActive' | 'unpublishSurveySchema' | 'updateAdverseEventSanofiId' | 'updateAppealDenialReasons' | 'updateAppealDepartment' | 'updateAppealPatientDateOfBirth' | 'updateAppealPlanCategory' | 'updateAppealStatusWithToken' | 'updateAppealStrategy' | 'updateAppealType' | 'updateCcDestination' | 'updateClinicalEvidence' | 'updateCondition' | 'updateDenialReason' | 'updateEmailMessage' | 'updateLetterTest' | 'updateLetterTestScenarioPersona' | 'updateMedication' | 'updatePayerPolicyClinicalCriteria' | 'updatePayerPolicyExtraction' | 'updatePrecedentCase' | 'updateProviderFreeTrialEndDate' | 'updateProviderNotificationEmail' | 'updateProviderType' | 'updateProviderUserActiveStatus' | 'updateProviderUserActiveStatusBySupport' | 'updateProviderUserInfo' | 'updateSubDenialReason' | 'updateSurveyAnswers' | 'updateSurveyJsAnswers' | 'upsertAppealSupportingDocument' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	UpdateProviderUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	addAppealLetterTraceToEvalDataset?: FieldPolicy<any> | FieldReadFunction<any>,
	addClinicalEvidenceEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addNewUserToProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	addNewUserToProviderByProviderId?: FieldPolicy<any> | FieldReadFunction<any>,
	approvePayerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveInReviewEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	closeAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	createAdverseEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealLetterIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealPacketIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealStaging?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	createCcDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	createCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	createDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmailMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	createLetterRevision?: FieldPolicy<any> | FieldReadFunction<any>,
	createLetterTest?: FieldPolicy<any> | FieldReadFunction<any>,
	createLetterTestScenario?: FieldPolicy<any> | FieldReadFunction<any>,
	createMedication?: FieldPolicy<any> | FieldReadFunction<any>,
	createMedicationCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	createPayerPolicyClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	createPrecedentCase?: FieldPolicy<any> | FieldReadFunction<any>,
	createProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	createProviderViaSelfSignUp?: FieldPolicy<any> | FieldReadFunction<any>,
	createSubDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	createSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	createSurveySchemaVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAppealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAppealStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAppealSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCcDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLetterTestScenario?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMedicationCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePayerPolicyClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePrecedentCase?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadAppealLetterLink?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadBAAFormLink?: FieldPolicy<any> | FieldReadFunction<any>,
	editSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	extractInsuranceCardData?: FieldPolicy<any> | FieldReadFunction<any>,
	gatherClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAppealPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAppealPdfUploadLink?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAppealStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	generateLetterTestPersonas?: FieldPolicy<any> | FieldReadFunction<any>,
	generateLettersForLetterTest?: FieldPolicy<any> | FieldReadFunction<any>,
	generateProviderLetterOfMedicalNecessity?: FieldPolicy<any> | FieldReadFunction<any>,
	generateSupportingDocumentUploadUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	initializeReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAppealStagingToUser?: FieldPolicy<any> | FieldReadFunction<any>,
	markAppealPdfUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	markAppealReadyForReview?: FieldPolicy<any> | FieldReadFunction<any>,
	previewAppealPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	publishSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	removeAppealOutcomeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	removeLetterGenerationFromScenario?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAppealOutcomeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	requestSecondAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	resolveIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewLetterGeneration?: FieldPolicy<any> | FieldReadFunction<any>,
	saveAppealDeptData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCCDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCaregiverData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenialUpheldDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenialUpheldReceivedClaimsFile?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	saveInsuranceEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	saveInsuranceInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	saveIsExpeditedReview?: FieldPolicy<any> | FieldReadFunction<any>,
	saveOtherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	savePatientAndCaregiverInfoOnReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	savePatientData?: FieldPolicy<any> | FieldReadFunction<any>,
	savePrimaryEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProviderDefaultReferralMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	sendAppealManually?: FieldPolicy<any> | FieldReadFunction<any>,
	sendChatGptMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendReferralToPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	setupNewUserWithExistingReferrals?: FieldPolicy<any> | FieldReadFunction<any>,
	signProviderBusinessAssociateAgreement?: FieldPolicy<any> | FieldReadFunction<any>,
	skipUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	startGenerateAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	startNextAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleAppealSupportingDocumentInclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleClaimableAppealSponsorship?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleMedicationConditionActive?: FieldPolicy<any> | FieldReadFunction<any>,
	unpublishSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAdverseEventSanofiId?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealPatientDateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealPlanCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealStatusWithToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCcDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	updateClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmailMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLetterTest?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLetterTestScenarioPersona?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMedication?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayerPolicyClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePrecedentCase?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderFreeTrialEndDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderNotificationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderUserActiveStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderUserActiveStatusBySupport?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderUserInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSubDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSurveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSurveyJsAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertAppealSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedAdverseEventsKeySpecifier = ('data' | 'totalCount' | PaginatedAdverseEventsKeySpecifier)[];
export type PaginatedAdverseEventsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedAppealDepartmentsKeySpecifier = ('data' | 'hasNextPage' | PaginatedAppealDepartmentsKeySpecifier)[];
export type PaginatedAppealDepartmentsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedAppealStrategiesKeySpecifier = ('data' | 'totalCount' | PaginatedAppealStrategiesKeySpecifier)[];
export type PaginatedAppealStrategiesFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedAppealsKeySpecifier = ('data' | 'hasNextPage' | PaginatedAppealsKeySpecifier)[];
export type PaginatedAppealsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCcDestinationsKeySpecifier = ('data' | 'totalCount' | PaginatedCcDestinationsKeySpecifier)[];
export type PaginatedCcDestinationsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedClinicalEvidenceKeySpecifier = ('data' | 'totalCount' | PaginatedClinicalEvidenceKeySpecifier)[];
export type PaginatedClinicalEvidenceFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedConditionsKeySpecifier = ('data' | 'hasNextPage' | PaginatedConditionsKeySpecifier)[];
export type PaginatedConditionsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedDenialReasonsKeySpecifier = ('data' | 'hasNextPage' | PaginatedDenialReasonsKeySpecifier)[];
export type PaginatedDenialReasonsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedInReviewClinicalEvidenceKeySpecifier = ('data' | 'totalCount' | PaginatedInReviewClinicalEvidenceKeySpecifier)[];
export type PaginatedInReviewClinicalEvidenceFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedLetterTestsKeySpecifier = ('data' | 'totalCount' | PaginatedLetterTestsKeySpecifier)[];
export type PaginatedLetterTestsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedMedicationConditionsKeySpecifier = ('data' | 'hasNextPage' | PaginatedMedicationConditionsKeySpecifier)[];
export type PaginatedMedicationConditionsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedMedicationsKeySpecifier = ('data' | 'hasNextPage' | PaginatedMedicationsKeySpecifier)[];
export type PaginatedMedicationsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPayerPolicyClinicalCriteriaKeySpecifier = ('data' | 'totalCount' | PaginatedPayerPolicyClinicalCriteriaKeySpecifier)[];
export type PaginatedPayerPolicyClinicalCriteriaFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPayerPolicyExtractionKeySpecifier = ('data' | 'totalCount' | PaginatedPayerPolicyExtractionKeySpecifier)[];
export type PaginatedPayerPolicyExtractionFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPrecedentCasesKeySpecifier = ('data' | 'totalCount' | PaginatedPrecedentCasesKeySpecifier)[];
export type PaginatedPrecedentCasesFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedProvidersKeySpecifier = ('data' | 'totalCount' | PaginatedProvidersKeySpecifier)[];
export type PaginatedProvidersFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedReferralsKeySpecifier = ('hasNextPage' | 'referrals' | PaginatedReferralsKeySpecifier)[];
export type PaginatedReferralsFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	referrals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSubDenialReasonsKeySpecifier = ('data' | 'hasNextPage' | PaginatedSubDenialReasonsKeySpecifier)[];
export type PaginatedSubDenialReasonsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientKeySpecifier = ('address' | 'dateOfBirth' | 'externalId' | 'firstName' | 'hasMarketingSmsConsent' | 'hasTransactionalSmsConsent' | 'lastName' | 'phone' | 'pronouns' | 'sex' | PatientKeySpecifier)[];
export type PatientFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasMarketingSmsConsent?: FieldPolicy<any> | FieldReadFunction<any>,
	hasTransactionalSmsConsent?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pronouns?: FieldPolicy<any> | FieldReadFunction<any>,
	sex?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientInsuranceKeySpecifier = ('employer' | 'enrolleeFirstName' | 'enrolleeLastName' | 'groupNumber' | 'isPatientEnrollee' | 'memberNumber' | 'pbmName' | 'planCategory' | 'providerName' | 'rxBinNumber' | 'rxGroupNumber' | 'rxMemberId' | PatientInsuranceKeySpecifier)[];
export type PatientInsuranceFieldPolicy = {
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	groupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	isPatientEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	memberNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pbmName?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	rxBinNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxGroupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxMemberId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayerPolicyClinicalCriteriaKeySpecifier = ('condition' | 'continuationClinicalCriteria' | 'id' | 'initialClinicalCriteria' | 'medication' | 'payer' | PayerPolicyClinicalCriteriaKeySpecifier)[];
export type PayerPolicyClinicalCriteriaFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	continuationClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayerPolicyExtractionKeySpecifier = ('approvingUserId' | 'condition' | 'continuationClinicalCriteria' | 'createdAt' | 'id' | 'initialClinicalCriteria' | 'medication' | 'payer' | 'payerPolicyClinicalCriteriaId' | 'policyBotId' | 'updatedAt' | PayerPolicyExtractionKeySpecifier)[];
export type PayerPolicyExtractionFieldPolicy = {
	approvingUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	continuationClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyClinicalCriteriaId?: FieldPolicy<any> | FieldReadFunction<any>,
	policyBotId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('amountDiscount' | 'amountSubtotal' | 'amountTax' | 'amountTotal' | 'appealPrice' | 'checkoutSessionId' | 'destinationPrice' | 'destinationQuantity' | 'paymentIntentId' | 'paymentMethodType' | 'paymentStatus' | 'paymentTimestamp' | 'shippingAmount' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	amountDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSubtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTax?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	appealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrecedentCaseKeySpecifier = ('condition' | 'createdAt' | 'decisionYear' | 'id' | 'medication' | 'referenceNumber' | 'state' | 'summary' | 'updatedAt' | PrecedentCaseKeySpecifier)[];
export type PrecedentCaseFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	decisionYear?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductPricesKeySpecifier = ('appealPrice' | 'ccDestinationPrice' | 'shippingRate' | ProductPricesKeySpecifier)[];
export type ProductPricesFieldPolicy = {
	appealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestinationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderKeySpecifier = ('createdTimestamp' | 'defaultReferralMessage' | 'facilities' | 'freeTrialEndTimestamp' | 'hasSignedBAA' | 'identificationNumber' | 'notificationEmail' | 'organizationType' | 'providerId' | 'providerName' | 'specialty' | 'type' | 'users' | ProviderKeySpecifier)[];
export type ProviderFieldPolicy = {
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultReferralMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTrialEndTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSignedBAA?: FieldPolicy<any> | FieldReadFunction<any>,
	identificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	specialty?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderFacilityKeySpecifier = ('facilityName' | 'facilityShortName' | 'providerFacilityId' | ProviderFacilityKeySpecifier)[];
export type ProviderFacilityFieldPolicy = {
	facilityName?: FieldPolicy<any> | FieldReadFunction<any>,
	facilityShortName?: FieldPolicy<any> | FieldReadFunction<any>,
	providerFacilityId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderReferralKeySpecifier = ('appealId' | 'createdTimestamp' | 'hasPatientConsent' | 'patientEmail' | 'providerId' | 'providerMessage' | 'providerName' | 'providerType' | 'providerUserId' | 'referralId' | 'sponsoringParty' | ProviderReferralKeySpecifier)[];
export type ProviderReferralFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPatientConsent?: FieldPolicy<any> | FieldReadFunction<any>,
	patientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsoringParty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderUserKeySpecifier = ('active' | 'createdTimestamp' | 'email' | 'firstName' | 'jobTitle' | 'lastName' | 'providerId' | 'providerUserId' | 'role' | ProviderUserKeySpecifier)[];
export type ProviderUserFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	jobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QrUploadUrlResponseKeySpecifier = ('uploadUrl' | QrUploadUrlResponseKeySpecifier)[];
export type QrUploadUrlResponseFieldPolicy = {
	uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('activeHelpScoutConversations' | 'adverseEventAppeals' | 'adverseEvents' | 'appealDeliverabilityMetrics' | 'appealDepartment' | 'appealDepartments' | 'appealDestinations' | 'appealOverview' | 'appealPatient' | 'appealPurchaseSummary' | 'appealStatus' | 'appealStrategies' | 'appealStrategy' | 'appealStrategyAuditLog' | 'appealStrategyTags' | 'appeals' | 'autocompleteAddress' | 'ccDestination' | 'ccDestinations' | 'clinicalEvidence' | 'clinicalEvidenceConditions' | 'clinicalEvidenceMedications' | 'clinicalEvidenceTags' | 'condition' | 'conditions' | 'conditionsForEligibility' | 'conditionsTreatedByMedication' | 'denial' | 'denialReason' | 'denialReasons' | 'denyingPartyAppealDepartment' | 'emailMessage' | 'emailMessagesByProvider' | 'evaluators' | 'expeditedReviewRecommendationForAppeal' | 'expeditedReviewRecommendationForInputs' | 'getAllSurveySchemas' | 'getAppealById' | 'getAppealDetailSection' | 'getAppealOutcomeEvents' | 'getAppealPayment' | 'getAppeals' | 'getHelpScoutConversations' | 'getInsuranceCardExtraction' | 'getLetterGenerations' | 'getLetterRevisions' | 'getLetterRevisionsFull' | 'getPayerPolicyPresignedUrl' | 'getProviderById' | 'getReferringProviderUser' | 'getReviewedLetterGenerations' | 'getSurveySchemaById' | 'hasLegacySurveyAnswers' | 'hasSurveySchemaForAppeal' | 'healthCheck' | 'inReviewClinicalEvidence' | 'isAppealFree' | 'letterTest' | 'letterTestScenario' | 'letterTestScenarioExecution' | 'letterTests' | 'medication' | 'medicationCondition' | 'medicationConditionPairsForEligibility' | 'medicationConditions' | 'medicationDashboard' | 'medications' | 'medicationsForCondition' | 'medicationsForReferral' | 'payerPolicyClinicalCriteria' | 'payerPolicyExtraction' | 'payerPolicyExtractionPayerNames' | 'payerPolicyExtractions' | 'payerPolicyPayerNames' | 'precedentCases' | 'productPrices' | 'provider' | 'providerUser' | 'providers' | 'publishedSurveySchema' | 'qrUploadUrl' | 'referrals' | 'subDenialReason' | 'subDenialReasons' | 'uploadInfo' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	activeHelpScoutConversations?: FieldPolicy<any> | FieldReadFunction<any>,
	adverseEventAppeals?: FieldPolicy<any> | FieldReadFunction<any>,
	adverseEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	appealDeliverabilityMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	appealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	appealDepartments?: FieldPolicy<any> | FieldReadFunction<any>,
	appealDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	appealOverview?: FieldPolicy<any> | FieldReadFunction<any>,
	appealPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	appealPurchaseSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStrategies?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStrategyAuditLog?: FieldPolicy<any> | FieldReadFunction<any>,
	appealStrategyTags?: FieldPolicy<any> | FieldReadFunction<any>,
	appeals?: FieldPolicy<any> | FieldReadFunction<any>,
	autocompleteAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidenceConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidenceMedications?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidenceTags?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	conditions?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionsForEligibility?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionsTreatedByMedication?: FieldPolicy<any> | FieldReadFunction<any>,
	denial?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingPartyAppealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMessagesByProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	evaluators?: FieldPolicy<any> | FieldReadFunction<any>,
	expeditedReviewRecommendationForAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	expeditedReviewRecommendationForInputs?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSurveySchemas?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealById?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealDetailSection?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealOutcomeEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppeals?: FieldPolicy<any> | FieldReadFunction<any>,
	getHelpScoutConversations?: FieldPolicy<any> | FieldReadFunction<any>,
	getInsuranceCardExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	getLetterGenerations?: FieldPolicy<any> | FieldReadFunction<any>,
	getLetterRevisions?: FieldPolicy<any> | FieldReadFunction<any>,
	getLetterRevisionsFull?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayerPolicyPresignedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	getProviderById?: FieldPolicy<any> | FieldReadFunction<any>,
	getReferringProviderUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getReviewedLetterGenerations?: FieldPolicy<any> | FieldReadFunction<any>,
	getSurveySchemaById?: FieldPolicy<any> | FieldReadFunction<any>,
	hasLegacySurveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSurveySchemaForAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	healthCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	inReviewClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	isAppealFree?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTest?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTestScenario?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTestScenarioExecution?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTests?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationConditionPairsForEligibility?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationDashboard?: FieldPolicy<any> | FieldReadFunction<any>,
	medications?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationsForCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationsForReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtractionPayerNames?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtractions?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyPayerNames?: FieldPolicy<any> | FieldReadFunction<any>,
	precedentCases?: FieldPolicy<any> | FieldReadFunction<any>,
	productPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUser?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	qrUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	referrals?: FieldPolicy<any> | FieldReadFunction<any>,
	subDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	subDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferralKeySpecifier = ('appeal' | 'patientEmail' | 'referralId' | 'referringUser' | 'sponsoringParty' | ReferralKeySpecifier)[];
export type ReferralFieldPolicy = {
	appeal?: FieldPolicy<any> | FieldReadFunction<any>,
	patientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>,
	referringUser?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsoringParty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SentFaxKeySpecifier = ('completedTimestamp' | 'errorDetails' | 'faxId' | 'faxNumber' | 'fromFaxNumber' | 'initiatedTimestamp' | 'sentStatus' | 'toFaxNumber' | SentFaxKeySpecifier)[];
export type SentFaxFieldPolicy = {
	completedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	errorDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	faxId?: FieldPolicy<any> | FieldReadFunction<any>,
	faxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	fromFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	sentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	toFaxNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SentLetterKeySpecifier = ('address' | 'addressId' | 'currentExpectedDeliveryDate' | 'expectedDeliveryDate' | 'initiatedTimestamp' | 'letterId' | 'lobStatus' | 'recipientName' | 'trackingNumber' | SentLetterKeySpecifier)[];
export type SentLetterFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	currentExpectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	letterId?: FieldPolicy<any> | FieldReadFunction<any>,
	lobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubDenialReasonKeySpecifier = ('createdAt' | 'displayName' | 'id' | 'name' | 'updatedAt' | SubDenialReasonKeySpecifier)[];
export type SubDenialReasonFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupportingDocumentFileUploadDetailKeySpecifier = ('downloadUrl' | 'fileId' | 'fileName' | 'uploadToken' | 'uploadUrl' | SupportingDocumentFileUploadDetailKeySpecifier)[];
export type SupportingDocumentFileUploadDetailFieldPolicy = {
	downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadToken?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyKeySpecifier = ('createdAt' | 'id' | 'name' | 'surveyData' | 'updatedAt' | 'version' | SurveyKeySpecifier)[];
export type SurveyFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyData?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyAnswerKeySpecifier = ('id' | 'questionText' | 'value' | SurveyAnswerKeySpecifier)[];
export type SurveyAnswerFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	questionText?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveySchemaKeySpecifier = ('condition' | 'createdAt' | 'description' | 'id' | 'isPublished' | 'schemaData' | 'updatedAt' | 'version' | SurveySchemaKeySpecifier)[];
export type SurveySchemaFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaData?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadInfoKeySpecifier = ('appealId' | 'insuranceInfo' | UploadInfoKeySpecifier)[];
export type UploadInfoFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadLinkKeySpecifier = ('fileExtension' | 'uploadUrl' | UploadLinkKeySpecifier)[];
export type UploadLinkFieldPolicy = {
	fileExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadUrlsKeySpecifier = ('allFilesUploaded' | 'key' | 's3Urls' | UploadUrlsKeySpecifier)[];
export type UploadUrlsFieldPolicy = {
	allFilesUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpsertAppealSupportingDocumentResponseKeySpecifier = ('document' | UpsertAppealSupportingDocumentResponseKeySpecifier)[];
export type UpsertAppealSupportingDocumentResponseFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	ActiveSupportItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveSupportItemKeySpecifier | (() => undefined | ActiveSupportItemKeySpecifier),
		fields?: ActiveSupportItemFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AddressSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressSuggestionKeySpecifier | (() => undefined | AddressSuggestionKeySpecifier),
		fields?: AddressSuggestionFieldPolicy,
	},
	AdverseEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdverseEventKeySpecifier | (() => undefined | AdverseEventKeySpecifier),
		fields?: AdverseEventFieldPolicy,
	},
	AdverseEventAppealResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdverseEventAppealResultKeySpecifier | (() => undefined | AdverseEventAppealResultKeySpecifier),
		fields?: AdverseEventAppealResultFieldPolicy,
	},
	Appeal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealKeySpecifier | (() => undefined | AppealKeySpecifier),
		fields?: AppealFieldPolicy,
	},
	AppealDeliverabilityMetrics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDeliverabilityMetricsKeySpecifier | (() => undefined | AppealDeliverabilityMetricsKeySpecifier),
		fields?: AppealDeliverabilityMetricsFieldPolicy,
	},
	AppealDenialDetailsSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDenialDetailsSectionStatusKeySpecifier | (() => undefined | AppealDenialDetailsSectionStatusKeySpecifier),
		fields?: AppealDenialDetailsSectionStatusFieldPolicy,
	},
	AppealDepartmentRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDepartmentRecordKeySpecifier | (() => undefined | AppealDepartmentRecordKeySpecifier),
		fields?: AppealDepartmentRecordFieldPolicy,
	},
	AppealDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDestinationKeySpecifier | (() => undefined | AppealDestinationKeySpecifier),
		fields?: AppealDestinationFieldPolicy,
	},
	AppealDetailSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDetailSectionKeySpecifier | (() => undefined | AppealDetailSectionKeySpecifier),
		fields?: AppealDetailSectionFieldPolicy,
	},
	AppealFinalizeAndSubmitSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealFinalizeAndSubmitSectionStatusKeySpecifier | (() => undefined | AppealFinalizeAndSubmitSectionStatusKeySpecifier),
		fields?: AppealFinalizeAndSubmitSectionStatusFieldPolicy,
	},
	AppealGenerateAndReviewSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealGenerateAndReviewSectionStatusKeySpecifier | (() => undefined | AppealGenerateAndReviewSectionStatusKeySpecifier),
		fields?: AppealGenerateAndReviewSectionStatusFieldPolicy,
	},
	AppealInsuranceCoverageSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealInsuranceCoverageSectionStatusKeySpecifier | (() => undefined | AppealInsuranceCoverageSectionStatusKeySpecifier),
		fields?: AppealInsuranceCoverageSectionStatusFieldPolicy,
	},
	AppealLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealLetterKeySpecifier | (() => undefined | AppealLetterKeySpecifier),
		fields?: AppealLetterFieldPolicy,
	},
	AppealOutcomeEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealOutcomeEventKeySpecifier | (() => undefined | AppealOutcomeEventKeySpecifier),
		fields?: AppealOutcomeEventFieldPolicy,
	},
	AppealOverview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealOverviewKeySpecifier | (() => undefined | AppealOverviewKeySpecifier),
		fields?: AppealOverviewFieldPolicy,
	},
	AppealPatientProfileSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealPatientProfileSectionStatusKeySpecifier | (() => undefined | AppealPatientProfileSectionStatusKeySpecifier),
		fields?: AppealPatientProfileSectionStatusFieldPolicy,
	},
	AppealPurchaseSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealPurchaseSummaryKeySpecifier | (() => undefined | AppealPurchaseSummaryKeySpecifier),
		fields?: AppealPurchaseSummaryFieldPolicy,
	},
	AppealStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealStatusKeySpecifier | (() => undefined | AppealStatusKeySpecifier),
		fields?: AppealStatusFieldPolicy,
	},
	AppealStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealStrategyKeySpecifier | (() => undefined | AppealStrategyKeySpecifier),
		fields?: AppealStrategyFieldPolicy,
	},
	AppealStrategyAuditEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealStrategyAuditEntryKeySpecifier | (() => undefined | AppealStrategyAuditEntryKeySpecifier),
		fields?: AppealStrategyAuditEntryFieldPolicy,
	},
	AppealSupportingDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSupportingDocumentKeySpecifier | (() => undefined | AppealSupportingDocumentKeySpecifier),
		fields?: AppealSupportingDocumentFieldPolicy,
	},
	AppealSupportingDocumentFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSupportingDocumentFileKeySpecifier | (() => undefined | AppealSupportingDocumentFileKeySpecifier),
		fields?: AppealSupportingDocumentFileFieldPolicy,
	},
	AppealSupportingDocumentsSectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSupportingDocumentsSectionStatusKeySpecifier | (() => undefined | AppealSupportingDocumentsSectionStatusKeySpecifier),
		fields?: AppealSupportingDocumentsSectionStatusFieldPolicy,
	},
	AppealSurveySectionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSurveySectionStatusKeySpecifier | (() => undefined | AppealSurveySectionStatusKeySpecifier),
		fields?: AppealSurveySectionStatusFieldPolicy,
	},
	Caregiver?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaregiverKeySpecifier | (() => undefined | CaregiverKeySpecifier),
		fields?: CaregiverFieldPolicy,
	},
	CcDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcDestinationKeySpecifier | (() => undefined | CcDestinationKeySpecifier),
		fields?: CcDestinationFieldPolicy,
	},
	CcDestinationRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcDestinationRecordKeySpecifier | (() => undefined | CcDestinationRecordKeySpecifier),
		fields?: CcDestinationRecordFieldPolicy,
	},
	ChatGptResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatGptResponseKeySpecifier | (() => undefined | ChatGptResponseKeySpecifier),
		fields?: ChatGptResponseFieldPolicy,
	},
	ChatGptUsage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatGptUsageKeySpecifier | (() => undefined | ChatGptUsageKeySpecifier),
		fields?: ChatGptUsageFieldPolicy,
	},
	ClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClinicalEvidenceKeySpecifier | (() => undefined | ClinicalEvidenceKeySpecifier),
		fields?: ClinicalEvidenceFieldPolicy,
	},
	Condition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionKeySpecifier | (() => undefined | ConditionKeySpecifier),
		fields?: ConditionFieldPolicy,
	},
	CreateAppealStagingResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAppealStagingResultKeySpecifier | (() => undefined | CreateAppealStagingResultKeySpecifier),
		fields?: CreateAppealStagingResultFieldPolicy,
	},
	DeliverabilityCcDestinationRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverabilityCcDestinationRowKeySpecifier | (() => undefined | DeliverabilityCcDestinationRowKeySpecifier),
		fields?: DeliverabilityCcDestinationRowFieldPolicy,
	},
	DeliverabilityFaxNumberRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverabilityFaxNumberRowKeySpecifier | (() => undefined | DeliverabilityFaxNumberRowKeySpecifier),
		fields?: DeliverabilityFaxNumberRowFieldPolicy,
	},
	DeliverabilityKpis?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverabilityKpisKeySpecifier | (() => undefined | DeliverabilityKpisKeySpecifier),
		fields?: DeliverabilityKpisFieldPolicy,
	},
	DeliverabilityPayerRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverabilityPayerRowKeySpecifier | (() => undefined | DeliverabilityPayerRowKeySpecifier),
		fields?: DeliverabilityPayerRowFieldPolicy,
	},
	DeliverabilityStuckLetterRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliverabilityStuckLetterRowKeySpecifier | (() => undefined | DeliverabilityStuckLetterRowKeySpecifier),
		fields?: DeliverabilityStuckLetterRowFieldPolicy,
	},
	Denial?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialKeySpecifier | (() => undefined | DenialKeySpecifier),
		fields?: DenialFieldPolicy,
	},
	DenialLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialLetterKeySpecifier | (() => undefined | DenialLetterKeySpecifier),
		fields?: DenialLetterFieldPolicy,
	},
	DenialLetterInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialLetterInfoKeySpecifier | (() => undefined | DenialLetterInfoKeySpecifier),
		fields?: DenialLetterInfoFieldPolicy,
	},
	DenialReasonRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialReasonRecordKeySpecifier | (() => undefined | DenialReasonRecordKeySpecifier),
		fields?: DenialReasonRecordFieldPolicy,
	},
	DenyingPartyAppealDepartment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenyingPartyAppealDepartmentKeySpecifier | (() => undefined | DenyingPartyAppealDepartmentKeySpecifier),
		fields?: DenyingPartyAppealDepartmentFieldPolicy,
	},
	EmailMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailMessageKeySpecifier | (() => undefined | EmailMessageKeySpecifier),
		fields?: EmailMessageFieldPolicy,
	},
	Employer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmployerKeySpecifier | (() => undefined | EmployerKeySpecifier),
		fields?: EmployerFieldPolicy,
	},
	EvaluatorInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EvaluatorInfoKeySpecifier | (() => undefined | EvaluatorInfoKeySpecifier),
		fields?: EvaluatorInfoFieldPolicy,
	},
	GatherClinicalEvidenceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GatherClinicalEvidenceResultKeySpecifier | (() => undefined | GatherClinicalEvidenceResultKeySpecifier),
		fields?: GatherClinicalEvidenceResultFieldPolicy,
	},
	GenerateLetterTestPersonasResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateLetterTestPersonasResultKeySpecifier | (() => undefined | GenerateLetterTestPersonasResultKeySpecifier),
		fields?: GenerateLetterTestPersonasResultFieldPolicy,
	},
	GenerateLettersForLetterTestResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateLettersForLetterTestResultKeySpecifier | (() => undefined | GenerateLettersForLetterTestResultKeySpecifier),
		fields?: GenerateLettersForLetterTestResultFieldPolicy,
	},
	GenerateSupportingDocumentUploadUrlsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateSupportingDocumentUploadUrlsResponseKeySpecifier | (() => undefined | GenerateSupportingDocumentUploadUrlsResponseKeySpecifier),
		fields?: GenerateSupportingDocumentUploadUrlsResponseFieldPolicy,
	},
	GeneratedAppealStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeneratedAppealStrategyKeySpecifier | (() => undefined | GeneratedAppealStrategyKeySpecifier),
		fields?: GeneratedAppealStrategyFieldPolicy,
	},
	HelpScoutConversation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HelpScoutConversationKeySpecifier | (() => undefined | HelpScoutConversationKeySpecifier),
		fields?: HelpScoutConversationFieldPolicy,
	},
	HelpScoutThread?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HelpScoutThreadKeySpecifier | (() => undefined | HelpScoutThreadKeySpecifier),
		fields?: HelpScoutThreadFieldPolicy,
	},
	HistoryQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HistoryQuestionKeySpecifier | (() => undefined | HistoryQuestionKeySpecifier),
		fields?: HistoryQuestionFieldPolicy,
	},
	InReviewClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InReviewClinicalEvidenceKeySpecifier | (() => undefined | InReviewClinicalEvidenceKeySpecifier),
		fields?: InReviewClinicalEvidenceFieldPolicy,
	},
	InitialReferralData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InitialReferralDataKeySpecifier | (() => undefined | InitialReferralDataKeySpecifier),
		fields?: InitialReferralDataFieldPolicy,
	},
	InsuranceCardExtraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceCardExtractionKeySpecifier | (() => undefined | InsuranceCardExtractionKeySpecifier),
		fields?: InsuranceCardExtractionFieldPolicy,
	},
	InsuranceCardExtractionResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceCardExtractionResultKeySpecifier | (() => undefined | InsuranceCardExtractionResultKeySpecifier),
		fields?: InsuranceCardExtractionResultFieldPolicy,
	},
	InsuranceInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceInfoKeySpecifier | (() => undefined | InsuranceInfoKeySpecifier),
		fields?: InsuranceInfoFieldPolicy,
	},
	InsuranceInfoDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceInfoDetailsKeySpecifier | (() => undefined | InsuranceInfoDetailsKeySpecifier),
		fields?: InsuranceInfoDetailsFieldPolicy,
	},
	LetterGeneration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterGenerationKeySpecifier | (() => undefined | LetterGenerationKeySpecifier),
		fields?: LetterGenerationFieldPolicy,
	},
	LetterOfNecessityInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterOfNecessityInfoKeySpecifier | (() => undefined | LetterOfNecessityInfoKeySpecifier),
		fields?: LetterOfNecessityInfoFieldPolicy,
	},
	LetterRevisionFull?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterRevisionFullKeySpecifier | (() => undefined | LetterRevisionFullKeySpecifier),
		fields?: LetterRevisionFullFieldPolicy,
	},
	LetterRevisionHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterRevisionHistoryKeySpecifier | (() => undefined | LetterRevisionHistoryKeySpecifier),
		fields?: LetterRevisionHistoryFieldPolicy,
	},
	LetterTest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterTestKeySpecifier | (() => undefined | LetterTestKeySpecifier),
		fields?: LetterTestFieldPolicy,
	},
	LetterTestScenario?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterTestScenarioKeySpecifier | (() => undefined | LetterTestScenarioKeySpecifier),
		fields?: LetterTestScenarioFieldPolicy,
	},
	LetterTestScenarioExecution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterTestScenarioExecutionKeySpecifier | (() => undefined | LetterTestScenarioExecutionKeySpecifier),
		fields?: LetterTestScenarioExecutionFieldPolicy,
	},
	LetterTestScenarioExecutionConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterTestScenarioExecutionConfigurationKeySpecifier | (() => undefined | LetterTestScenarioExecutionConfigurationKeySpecifier),
		fields?: LetterTestScenarioExecutionConfigurationFieldPolicy,
	},
	LinkAppealStagingToUserResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkAppealStagingToUserResultKeySpecifier | (() => undefined | LinkAppealStagingToUserResultKeySpecifier),
		fields?: LinkAppealStagingToUserResultFieldPolicy,
	},
	ManualAppealSendResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualAppealSendResponseKeySpecifier | (() => undefined | ManualAppealSendResponseKeySpecifier),
		fields?: ManualAppealSendResponseFieldPolicy,
	},
	MedicalHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicalHistoryKeySpecifier | (() => undefined | MedicalHistoryKeySpecifier),
		fields?: MedicalHistoryFieldPolicy,
	},
	Medication?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicationKeySpecifier | (() => undefined | MedicationKeySpecifier),
		fields?: MedicationFieldPolicy,
	},
	MedicationCondition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicationConditionKeySpecifier | (() => undefined | MedicationConditionKeySpecifier),
		fields?: MedicationConditionFieldPolicy,
	},
	MedicationConditionPair?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicationConditionPairKeySpecifier | (() => undefined | MedicationConditionPairKeySpecifier),
		fields?: MedicationConditionPairFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	PaginatedAdverseEvents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedAdverseEventsKeySpecifier | (() => undefined | PaginatedAdverseEventsKeySpecifier),
		fields?: PaginatedAdverseEventsFieldPolicy,
	},
	PaginatedAppealDepartments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedAppealDepartmentsKeySpecifier | (() => undefined | PaginatedAppealDepartmentsKeySpecifier),
		fields?: PaginatedAppealDepartmentsFieldPolicy,
	},
	PaginatedAppealStrategies?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedAppealStrategiesKeySpecifier | (() => undefined | PaginatedAppealStrategiesKeySpecifier),
		fields?: PaginatedAppealStrategiesFieldPolicy,
	},
	PaginatedAppeals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedAppealsKeySpecifier | (() => undefined | PaginatedAppealsKeySpecifier),
		fields?: PaginatedAppealsFieldPolicy,
	},
	PaginatedCcDestinations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCcDestinationsKeySpecifier | (() => undefined | PaginatedCcDestinationsKeySpecifier),
		fields?: PaginatedCcDestinationsFieldPolicy,
	},
	PaginatedClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedClinicalEvidenceKeySpecifier | (() => undefined | PaginatedClinicalEvidenceKeySpecifier),
		fields?: PaginatedClinicalEvidenceFieldPolicy,
	},
	PaginatedConditions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedConditionsKeySpecifier | (() => undefined | PaginatedConditionsKeySpecifier),
		fields?: PaginatedConditionsFieldPolicy,
	},
	PaginatedDenialReasons?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedDenialReasonsKeySpecifier | (() => undefined | PaginatedDenialReasonsKeySpecifier),
		fields?: PaginatedDenialReasonsFieldPolicy,
	},
	PaginatedInReviewClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedInReviewClinicalEvidenceKeySpecifier | (() => undefined | PaginatedInReviewClinicalEvidenceKeySpecifier),
		fields?: PaginatedInReviewClinicalEvidenceFieldPolicy,
	},
	PaginatedLetterTests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedLetterTestsKeySpecifier | (() => undefined | PaginatedLetterTestsKeySpecifier),
		fields?: PaginatedLetterTestsFieldPolicy,
	},
	PaginatedMedicationConditions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedMedicationConditionsKeySpecifier | (() => undefined | PaginatedMedicationConditionsKeySpecifier),
		fields?: PaginatedMedicationConditionsFieldPolicy,
	},
	PaginatedMedications?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedMedicationsKeySpecifier | (() => undefined | PaginatedMedicationsKeySpecifier),
		fields?: PaginatedMedicationsFieldPolicy,
	},
	PaginatedPayerPolicyClinicalCriteria?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPayerPolicyClinicalCriteriaKeySpecifier | (() => undefined | PaginatedPayerPolicyClinicalCriteriaKeySpecifier),
		fields?: PaginatedPayerPolicyClinicalCriteriaFieldPolicy,
	},
	PaginatedPayerPolicyExtraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPayerPolicyExtractionKeySpecifier | (() => undefined | PaginatedPayerPolicyExtractionKeySpecifier),
		fields?: PaginatedPayerPolicyExtractionFieldPolicy,
	},
	PaginatedPrecedentCases?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPrecedentCasesKeySpecifier | (() => undefined | PaginatedPrecedentCasesKeySpecifier),
		fields?: PaginatedPrecedentCasesFieldPolicy,
	},
	PaginatedProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedProvidersKeySpecifier | (() => undefined | PaginatedProvidersKeySpecifier),
		fields?: PaginatedProvidersFieldPolicy,
	},
	PaginatedReferrals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedReferralsKeySpecifier | (() => undefined | PaginatedReferralsKeySpecifier),
		fields?: PaginatedReferralsFieldPolicy,
	},
	PaginatedSubDenialReasons?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSubDenialReasonsKeySpecifier | (() => undefined | PaginatedSubDenialReasonsKeySpecifier),
		fields?: PaginatedSubDenialReasonsFieldPolicy,
	},
	Patient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientKeySpecifier | (() => undefined | PatientKeySpecifier),
		fields?: PatientFieldPolicy,
	},
	PatientInsurance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientInsuranceKeySpecifier | (() => undefined | PatientInsuranceKeySpecifier),
		fields?: PatientInsuranceFieldPolicy,
	},
	PayerPolicyClinicalCriteria?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayerPolicyClinicalCriteriaKeySpecifier | (() => undefined | PayerPolicyClinicalCriteriaKeySpecifier),
		fields?: PayerPolicyClinicalCriteriaFieldPolicy,
	},
	PayerPolicyExtraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayerPolicyExtractionKeySpecifier | (() => undefined | PayerPolicyExtractionKeySpecifier),
		fields?: PayerPolicyExtractionFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PrecedentCase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrecedentCaseKeySpecifier | (() => undefined | PrecedentCaseKeySpecifier),
		fields?: PrecedentCaseFieldPolicy,
	},
	ProductPrices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductPricesKeySpecifier | (() => undefined | ProductPricesKeySpecifier),
		fields?: ProductPricesFieldPolicy,
	},
	Provider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderKeySpecifier | (() => undefined | ProviderKeySpecifier),
		fields?: ProviderFieldPolicy,
	},
	ProviderFacility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderFacilityKeySpecifier | (() => undefined | ProviderFacilityKeySpecifier),
		fields?: ProviderFacilityFieldPolicy,
	},
	ProviderReferral?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderReferralKeySpecifier | (() => undefined | ProviderReferralKeySpecifier),
		fields?: ProviderReferralFieldPolicy,
	},
	ProviderUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderUserKeySpecifier | (() => undefined | ProviderUserKeySpecifier),
		fields?: ProviderUserFieldPolicy,
	},
	QrUploadUrlResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QrUploadUrlResponseKeySpecifier | (() => undefined | QrUploadUrlResponseKeySpecifier),
		fields?: QrUploadUrlResponseFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Referral?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferralKeySpecifier | (() => undefined | ReferralKeySpecifier),
		fields?: ReferralFieldPolicy,
	},
	SentFax?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SentFaxKeySpecifier | (() => undefined | SentFaxKeySpecifier),
		fields?: SentFaxFieldPolicy,
	},
	SentLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SentLetterKeySpecifier | (() => undefined | SentLetterKeySpecifier),
		fields?: SentLetterFieldPolicy,
	},
	SubDenialReason?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubDenialReasonKeySpecifier | (() => undefined | SubDenialReasonKeySpecifier),
		fields?: SubDenialReasonFieldPolicy,
	},
	SupportingDocumentFileUploadDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupportingDocumentFileUploadDetailKeySpecifier | (() => undefined | SupportingDocumentFileUploadDetailKeySpecifier),
		fields?: SupportingDocumentFileUploadDetailFieldPolicy,
	},
	Survey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyKeySpecifier | (() => undefined | SurveyKeySpecifier),
		fields?: SurveyFieldPolicy,
	},
	SurveyAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyAnswerKeySpecifier | (() => undefined | SurveyAnswerKeySpecifier),
		fields?: SurveyAnswerFieldPolicy,
	},
	SurveySchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveySchemaKeySpecifier | (() => undefined | SurveySchemaKeySpecifier),
		fields?: SurveySchemaFieldPolicy,
	},
	UploadInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadInfoKeySpecifier | (() => undefined | UploadInfoKeySpecifier),
		fields?: UploadInfoFieldPolicy,
	},
	UploadLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadLinkKeySpecifier | (() => undefined | UploadLinkKeySpecifier),
		fields?: UploadLinkFieldPolicy,
	},
	UploadUrls?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadUrlsKeySpecifier | (() => undefined | UploadUrlsKeySpecifier),
		fields?: UploadUrlsFieldPolicy,
	},
	UpsertAppealSupportingDocumentResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpsertAppealSupportingDocumentResponseKeySpecifier | (() => undefined | UpsertAppealSupportingDocumentResponseKeySpecifier),
		fields?: UpsertAppealSupportingDocumentResponseFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;